{
  "app.name": "DoneTalk",
  "nav.inbox": "Conversations",
  "nav.contacts": "Contacts",
  "nav.flows": "Flows",
  "nav.assistants": "Assistants",
  "nav.numbers": "Numbers",
  "nav.settings": "Settings",
  "inbox.view.mine": "Mine",
  "inbox.view.team": "My team",
  "inbox.view.queue": "Queue",
  "inbox.view.waiting_contact": "Waiting on contact",
  "inbox.view.snoozed": "Snoozed",
  "inbox.view.closed": "Closed",
  "conversation.status.new": "New",
  "conversation.status.active": "Active",
  "conversation.status.waiting_contact": "Waiting on contact",
  "conversation.status.waiting_internal": "Waiting internally",
  "conversation.status.snoozed": "Snoozed",
  "conversation.status.closed": "Closed",
  "conversation.outcome": "Outcome",
  "conversation.close": "Close conversation",
  "handler.flow": "Flow",
  "handler.assistant": "Assistant",
  "handler.human": "Person",
  "common.close": "Close",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "locale.name": "English",
  "auth.title": "Sign in",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.submit": "Sign in",
  "auth.invalid": "Wrong email or password.",
  "auth.blocked": "This access is blocked.",
  "auth.logout": "Sign out",
  "workspaces.title": "Choose a customer",
  "workspaces.subtitle": "Your access covers more than one customer.",
  "workspaces.none": "You have no customer access yet.",
  "workspaces.not_ready": "Being prepared",
  "role.owner": "Owner",
  "role.admin": "Administrator",
  "role.manager": "Manager",
  "role.supervisor": "Supervisor",
  "role.operator": "Agent",
  "role.auditor": "Auditor",
  "role.integration": "Integration",
  "inbox.search": "Search by name or phone",
  "inbox.empty": "No conversations in this view",
  "inbox.empty_hint": "Switch the view or wait for new messages.",
  "inbox.select": "Select a conversation",
  "inbox.select_hint": "Conversations of the chosen view are listed on the left.",
  "inbox.loading": "Loading…",
  "inbox.no_messages": "No messages yet.",
  "inbox.action.take": "Take",
  "inbox.action.assign": "Assign",
  "inbox.action.transfer": "Transfer",
  "handoff.to_assistant": "Hand back to the assistant",
  "handoff.to_flow": "Start a flow…",
  "handoff.assistant_title": "Hand back to the AI assistant",
  "handoff.flow_title": "Start a flow",
  "handoff.assistant_text": "If the customer is waiting for an answer, the assistant answers now; otherwise it answers their next message. It calls the team again if needed, and you stop handling this conversation.",
  "handoff.flow_text": "The flow starts now: from the beginning, from where it stopped when someone from the team wrote, or at a chosen step. You stop attending this conversation.",
  "handoff.window_closed": "The 24-hour window is closed: a flow can only start after the customer writes again.",
  "handoff.flow_pick": "Published flow",
  "handoff.assistant_pick": "Published assistant",
  "handoff.no_flows": "No published flow. Publish one in the flow builder.",
  "handoff.no_assistants": "No published assistant. Publish one in Settings › AI assistants.",
  "handoff.confirm": "Hand back",
  "handoff.assistant_done": "The assistant took the conversation.",
  "handoff.flow_done": "The flow started.",
  "errors.flow_not_published": "That flow isn't published.",
  "errors.outside_session_window": "The 24-hour window is closed. Use an approved template.",
  "errors.conversation_closed": "This conversation is already closed.",
  "inbox.action.snooze": "Snooze",
  "inbox.action.wait_contact": "Wait on contact",
  "inbox.action.wait_internal": "Wait internally",
  "inbox.action.resume": "Resume",
  "inbox.action.close": "Close",
  "inbox.action.reopen": "Reopen",
  "inbox.action.note": "Note",
  "inbox.action.more": "More actions",
  "inbox.header.queue": "In queue",
  "inbox.header.mine": "With me",
  "inbox.header.with": "With {name}",
  "inbox.header.assistant": "With the assistant",
  "inbox.header.flow": "In a flow",
  "inbox.header.closed": "Closed: {outcome}",
  "inbox.window.remaining": "Reply window: {time} left",
  "inbox.window.expired": "The 24-hour window closed. Only an approved template can be sent.",
  "inbox.window.free": "Ad conversation: free for {time}",
  "inbox.window.send_template": "Send template",
  "inbox.snoozed_until": "Snoozed until {time}",
  "inbox.priority.low": "Low",
  "inbox.priority.normal": "Normal",
  "inbox.priority.high": "High",
  "inbox.priority.urgent": "Urgent",
  "outcome.title": "Close conversation",
  "outcome.select": "Outcome",
  "outcome.note": "Note",
  "outcome.note_required": "This outcome requires a note.",
  "outcome.confirm": "Close",
  "outcome.success": "Success",
  "outcome.neutral": "Neutral",
  "outcome.negative": "Negative",
  "outcome.invalid": "Invalid",
  "assign.title": "Assign conversation",
  "assign.member": "Agent",
  "assign.unassigned": "Unassigned",
  "assign.confirm": "Assign",
  "transfer.title": "Transfer conversation",
  "transfer.team": "Team",
  "transfer.keep_team": "Keep team",
  "transfer.member": "Agent",
  "transfer.any_member": "Any agent of the team",
  "transfer.note": "Context for the receiver",
  "transfer.confirm": "Transfer",
  "snooze.title": "Snooze",
  "snooze.hint": "The conversation leaves the inbox and comes back by itself at the chosen time.",
  "snooze.1h": "In 1 hour",
  "snooze.3h": "In 3 hours",
  "snooze.tomorrow": "Tomorrow at 9",
  "snooze.next_week": "Next week",
  "snooze.custom": "Pick date and time",
  "snooze.reason": "Reason",
  "snooze.confirm": "Snooze",
  "note.title": "Internal note",
  "note.placeholder": "Visible to the team only",
  "note.save": "Save note",
  "event.created": "Conversation opened",
  "event.assigned": "Assigned to {name}",
  "event.unassigned": "Returned to queue",
  "event.transferred": "Transferred",
  "event.status_changed": "Status: {to}",
  "event.snoozed": "Snoozed until {until}",
  "event.closed": "Closed",
  "event.reopened": "Reopened",
  "event.note_added": "Note added",
  "event.priority_changed": "Priority: {to}",
  "event.outcome_set": "Outcome: {outcome}",
  "event.policy": "Automatic rule",
  "event.handler_changed": "Now handled by: {to}",
  "message.failed": "Not sent",
  "message.queued": "Sending…",
  "message.media.image": "Image",
  "message.media.audio": "Audio",
  "message.media.video": "Video",
  "message.media.document": "Document",
  "message.media.sticker": "Sticker",
  "message.location": "Location",
  "message.template": "Template",
  "message.reaction": "Reacted with {emoji}",
  "time.yesterday": "Yesterday",
  "time.now": "now",
  "time.minutes": "{n} min",
  "time.hours": "{n} h",
  "common.confirm": "Confirm",
  "common.back": "Back",
  "common.error": "Something went wrong. Try again.",
  "common.none": "None",
  "common.styleguide": "Styleguide",
  "flows.title": "Flows",
  "flows.new": "New flow",
  "flows.empty": "No flows yet",
  "flows.empty_hint": "Create a flow to handle conversations automatically before a person steps in.",
  "flows.name": "Name",
  "flows.description": "Description",
  "flows.status.draft": "Draft",
  "flows.status.published": "Published",
  "flows.status.archived": "Archived",
  "flows.active_runs": "{n} running",
  "flows.version": "v{n}",
  "flows.unsaved": "Unsaved changes",
  "builder.save": "Save draft",
  "builder.saved": "Draft saved",
  "builder.publish": "Publish",
  "builder.published": "Version {n} published",
  "builder.test": "Test",
  "builder.triggers": "Triggers",
  "builder.versions": "Versions",
  "builder.restore": "Restore",
  "builder.restored": "Version {n} restored as v{next}",
  "builder.add": "Add block",
  "builder.delete_node": "Remove block",
  "builder.inspector_empty": "Select a block to edit",
  "builder.exit": "Exit",
  "builder.exit_next": "Next",
  "builder.exit_fallback": "No valid answer",
  "builder.exit_invalid": "Invalid",
  "builder.exit_error": "Error",
  "builder.exit_default": "Otherwise",
  "builder.exit_inside": "Inside hours",
  "builder.exit_outside": "Outside hours",
  "builder.exit_done": "When done",
  "builder.unconnected": "Exit without target",
  "builder.invalid": "The flow has errors: {detail}",
  "builder.channel_default": "When a contact starts a conversation on the number",
  "builder.keywords": "Keywords (one per line)",
  "builder.trigger_saved": "Triggers saved",
  "builder.variables_hint": "Use {{contact.name}}, {{vars.name}} or {{input.text}} in text.",
  "node.start": "Start",
  "node.message": "Message",
  "node.menu": "Menu",
  "node.input": "Question",
  "node.condition": "Condition",
  "node.http_request": "API call",
  "node.script": "Script",
  "node.field.code": "Code (JavaScript)",
  "node.field.code_hint": "Use vars (the flow's variables) and contact (name and fields) and return an object: each key becomes a variable. It runs isolated, without internet, for up to 0.2 seconds; if it fails, it goes through the Error exit with vars.script_error.",
  "node.set_variable": "Set variable",
  "node.set_field": "Save contact field",
  "node.tag": "Tag",
  "node.wait": "Wait",
  "node.business_hours": "Business hours",
  "node.transfer": "Transfer to a person",
  "node.assistant": "AI assistant",
  "node.close": "Close",
  "node.event": "Record event",
  "node.exception": "Exception",
  "node.end": "End",
  "node.field.text": "Text",
  "node.field.body": "Menu text",
  "node.field.header": "Header",
  "node.field.footer": "Footer",
  "node.field.options": "Options",
  "node.field.option_title": "Title",
  "node.field.option_id": "Identifier",
  "node.field.add_option": "Add option",
  "node.field.retries": "Retries",
  "node.field.retry_text": "Text when not understood",
  "node.field.variable": "Store in",
  "node.field.prompt": "Question",
  "node.field.validation": "Validation",
  "node.field.pattern": "Regular expression",
  "node.field.error_text": "Text when invalid",
  "node.field.rules": "Rules",
  "node.field.add_rule": "Add rule",
  "node.field.op": "Operator",
  "node.field.value": "Value",
  "node.field.method": "Method",
  "node.field.url": "URL",
  "node.field.headers": "Headers (JSON)",
  "node.field.request_body": "Body",
  "node.field.timeout": "Timeout (ms)",
  "node.field.field": "Field",
  "node.field.tag": "Tag",
  "node.field.seconds": "Seconds",
  "node.field.business_hours": "Hours",
  "node.field.team": "Team",
  "node.field.member": "Agent",
  "node.field.note": "Context for the receiver",
  "node.field.assistant": "Assistant",
  "node.field.outcome": "Outcome",
  "node.field.event_name": "Event name",
  "node.field.any": "Any",
  "validation.text": "Free text",
  "validation.number": "Number",
  "validation.email": "Email",
  "validation.phone": "Phone",
  "validation.cpf": "CPF",
  "validation.cnpj": "CNPJ",
  "validation.date": "Date",
  "validation.regex": "Regular expression",
  "op.exists": "exists",
  "op.eq": "equals",
  "op.neq": "differs from",
  "op.contains": "contains",
  "op.starts_with": "starts with",
  "op.ends_with": "ends with",
  "op.gt": "greater than",
  "op.gte": "at least",
  "op.lt": "less than",
  "op.lte": "at most",
  "op.regex": "matches regex",
  "op.in": "is one of",
  "simulator.title": "Flow test",
  "simulator.hint": "Chat as the customer. The current draft runs in memory and sends nothing.",
  "simulator.placeholder": "Reply as the customer",
  "simulator.reset": "Restart",
  "simulator.state": "State: {status}",
  "simulator.action": "Action: {type}",
  "gate.title": "Review before sending",
  "gate.hint": "The company policy reviewed your message before it goes out.",
  "gate.draft": "Your message",
  "gate.suggestion": "Suggestion",
  "gate.reasons": "Reasons",
  "gate.verdict.rewrite": "Suggested change",
  "gate.verdict.block": "Blocked",
  "gate.accept": "Use suggestion",
  "gate.edit": "Send my edit",
  "gate.override": "Send anyway",
  "gate.blocked_hint": "This message cannot go out as written. Edit the text.",
  "gate.rule.blocked_term": "blocked term",
  "gate.rule.pii": "sensitive data",
  "gate.rule.link": "link not allowed",
  "gate.rule.promise": "promise",
  "settings.title": "Settings",
  "settings.numbers": "Numbers",
  "settings.team": "Team and people",
  "settings.assistants": "AI assistants",
  "settings.knowledge": "Knowledge base",
  "settings.policies": "Policies",
  "settings.ai": "AI: models, keys and usage",
  "settings.integrations": "Integrations",
  "settings.save": "Save",
  "settings.saved": "Saved",
  "settings.new": "New",
  "settings.none": "Nothing here yet",
  "numbers.connect": "Connect number",
  "numbers.connect_hint": "Paste the system user token or the code from Meta's embedded signup.",
  "numbers.waba": "WhatsApp Business Account ID (WABA)",
  "numbers.phone_id": "Phone number ID",
  "numbers.token": "Access token",
  "numbers.pin": "Registration PIN (optional)",
  "numbers.mode": "Handling mode",
  "numbers.quality": "Quality",
  "numbers.tier": "Limit",
  "numbers.templates": "Approved templates",
  "numbers.templates_hint": "1 template in this account. Create, fix and follow Meta's review.|{count} templates in this account. Create, fix and follow Meta's review.",
  "numbers.sync": "Sync with Meta",
  "numbers.synced": "{n} templates synced, {changes} changed category",
  "numbers.category": "Category",
  "numbers.language": "Language",
  "numbers.status": "Status",
  "team.members": "People",
  "team.invite": "Invite",
  "team.invite_hint": "The invitation creates a link for the person to set a password. No automatic e-mail yet: copy and send it.",
  "team.invite_link": "Invitation link",
  "team.name": "Name",
  "team.role": "Role",
  "team.presence": "Presence",
  "team.teams": "Teams",
  "team.new_team": "New team",
  "team.distribution": "Distribution",
  "team.capacity": "Capacity per person",
  "team.auto_assign": "Assign automatically",
  "team.add_member": "Add to team",
  "team.hours": "Business hours",
  "team.new_hours": "New schedule",
  "team.timezone": "Time zone",
  "distribution.least_busy": "Least busy",
  "distribution.most_idle": "Most idle",
  "distribution.round_robin": "Round robin",
  "distribution.manual": "Manual",
  "presence.online": "Online",
  "presence.paused": "Paused",
  "presence.offline": "Offline",
  "assistant.new": "New assistant",
  "assistant.persona_name": "Persona name",
  "assistant.tone": "Tone",
  "assistant.language": "Reply language",
  "assistant.instructions": "Instructions",
  "assistant.instructions_hint": "Explain the business, what to answer, what never to promise and when to call a person.",
  "assistant.knowledge": "Knowledge bases",
  "assistant.tools": "Tools",
  "assistant.exit": "Exit conditions",
  "assistant.exit_field": "When the field is filled",
  "assistant.exit_keyword": "When the customer says",
  "assistant.filters": "Blocked terms in replies (one per line)",
  "assistant.fallback": "Safety text",
  "assistant.max_turns": "Most replies before handing over to a person",
  "assistant.handoff_team": "Team that takes over",
  "assistant.publish": "Publish",
  "assistant.published": "Version {n} published",
  "assistant.status.draft": "Draft",
  "assistant.status.active": "Active",
  "assistant.status.archived": "Archived",
  "assistant.running": "{n} in conversation",
  "assistant.temperature": "Creativity",
  "knowledge.collections": "Collections",
  "knowledge.new_collection": "New collection",
  "knowledge.documents": "Documents",
  "knowledge.add": "Add content",
  "knowledge.source.text": "Text",
  "knowledge.source.site": "Website",
  "knowledge.source.faq": "FAQ",
  "knowledge.site_url": "Page address",
  "knowledge.site_crawl": "Also read the linked pages of the same site (up to 10)",
  "knowledge.site_hint": "Each page becomes a document. Pages with little text and those already in the collection are left out.",
  "knowledge.site_read": "Read the site",
  "knowledge.site_error.private": "That address isn't a public website.",
  "knowledge.site_error.missing": "No page found at that address.",
  "knowledge.site_error.not_page": "That address isn't a text page.",
  "knowledge.site_error.unreachable": "We couldn't open the site right now. Check the address and try again.",
  "knowledge.site_added": "1 page added|{count} pages added",
  "knowledge.pdf_ready": "{name}: {pages} pages, {chars} characters of text.",
  "knowledge.pdf_truncated": "Only the start of the file fits; the rest is left out.",
  "knowledge.pdf_no_text": "That PDF has no text to read (maybe it's a scanned image).",
  "knowledge.doc_title": "Title",
  "knowledge.doc_text": "Content",
  "knowledge.chunks": "{n} chunks",
  "knowledge.search": "Test search",
  "knowledge.search_hint": "See what the assistant would find for a question.",
  "knowledge.status.ready": "Ready",
  "knowledge.status.processing": "Processing",
  "knowledge.status.failed": "Failed",
  "knowledge.status.pending": "Pending",
  "policy.new": "New policy",
  "policy.kind": "Kind",
  "policy.kind.lifecycle": "Automatic closure",
  "policy.kind.gate": "Message review",
  "policy.scope": "Scope",
  "policy.scope.customer": "Whole company",
  "policy.scope.team": "Team",
  "policy.scope.channel": "Number",
  "policy.mode": "Mode",
  "policy.mode.shadow": "Shadow (record only)",
  "policy.mode.log": "Log",
  "policy.mode.suggest": "Suggest to the agent",
  "policy.mode.auto_fix": "Fix and send",
  "policy.mode.block": "Block",
  "policy.active": "Active",
  "policy.rules": "Rules",
  "policy.rule.no_inbound_for": "No reply from the contact for {hours} h, close as",
  "policy.rule.window_expired": "24 h window closed: mark as waiting on contact",
  "policy.rule.unanswered_new_for": "No first reply for {hours} h: priority",
  "policy.hours": "Hours",
  "policy.outcome": "Outcome",
  "policy.add_rule": "Add rule",
  "policy.gate.blocked": "Blocked terms (one per line)",
  "policy.gate.domains": "Allowed link domains (one per line)",
  "policy.gate.promises": "Promise patterns (regex, one per line)",
  "policy.gate.pii": "Block sensitive data (card, CPF)",
  "policy.gate.judge": "Use the AI judge",
  "policy.gate.instructions": "Policy for the AI judge",
  "policy.gate.override": "Roles that may send anyway",
  "ai.own_keys": "Use my own AI keys",
  "ai.budget": "Monthly budget (USD)",
  "ai.budget_action": "When the budget is reached",
  "ai.budget.warn": "Warn",
  "ai.budget.block": "Block",
  "ai.keys": "Keys",
  "ai.add_key": "Add key",
  "ai.provider": "Provider",
  "ai.key": "Key",
  "ai.usage": "Usage this month",
  "ai.surface.assistant.reply": "Assistant replies",
  "ai.surface.gate.judge": "Message review",
  "ai.surface.outcome.classify": "Outcome suggestion",
  "ai.surface.summary.brief": "Conversation summary",
  "ai.surface.knowledge.embed": "Knowledge base",
  "ai.surface.audio.transcribe": "Audio transcription",
  "ai.surface.learning.mine": "Weekly learning",
  "ai.surface.onboarding.propose": "Setup suggestions",
  "ai.calls.previous": "Previous month",
  "ai.calls.next": "Next month",
  "ai.calls.cost": "Cost",
  "ai.calls.of_budget": "of {budget} this month ({share}%)",
  "ai.calls.calls": "Calls",
  "ai.calls.tokens": "Tokens",
  "ai.calls.cached": "{n} cached",
  "ai.calls.failed": "Failed",
  "ai.calls.failed_detail": "{errors} errors · {blocked} blocked by the budget",
  "ai.calls.n_calls": "1 call|{count} calls",
  "ai.calls.use": "Use",
  "ai.calls.all_uses": "All uses",
  "ai.calls.status_label": "Status",
  "ai.calls.all_status": "All",
  "ai.calls.status.success": "Done",
  "ai.calls.status.error": "Error",
  "ai.calls.status.blocked": "Blocked",
  "ai.calls.when": "When",
  "ai.calls.model": "Model",
  "ai.calls.latency": "Time",
  "ai.calls.conversation": "See conversation",
  "ai.calls.own_key": "own key",
  "ai.calls.none": "No AI calls in this period.",
  "ai.calls.more": "Load more",
  "ai.label": "Label",
  "member.status.active": "Active",
  "member.status.invited": "Invited",
  "member.status.suspended": "Suspended",
  "contact.panel": "Contact details",
  "contact.name": "Contact name",
  "contact.edit_name": "Edit name",
  "contact.this_conversation": "This conversation",
  "contact.source": "Source",
  "contact.goal": "Goal",
  "contact.channel": "Channel",
  "contact.started": "Started",
  "contact.meta_cost": "Meta cost",
  "contact.fields": "Fields",
  "contact.consent": "Consent and blocking",
  "contact.consent_marketing": "Accepts marketing messages",
  "contact.blocked": "Contact blocked",
  "contact.history": "Previous conversations",
  "contact.no_history": "First conversation with this contact.",
  "source.inbound": "Contact started",
  "source.ad": "Ad (click to WhatsApp)",
  "source.template": "Template sent",
  "source.campaign": "Campaign",
  "source.api": "API",
  "source.flow": "Flow",
  "source.connector": "Integration",
  "source.reopen": "Reopened",
  "common.yes": "Yes",
  "common.no": "No",
  "template.pick": "Send an approved template",
  "template.search": "Search templates",
  "template.none_approved": "No approved template on this WhatsApp account. If you already created one and Meta approved it, sync; otherwise create one under Settings › Message templates.",
  "template.waiting": "Not cleared by Meta yet",
  "template.category.marketing": "Marketing",
  "template.category.utility": "Utility",
  "template.category.authentication": "Authentication",
  "template.change": "Change template",
  "template.param": "Variable {n}",
  "template.header": "header",
  "template.no_params": "This template has no variables.",
  "template.preview": "Preview",
  "template.send": "Send template",
  "settings.templates": "Message templates",
  "template.param_button": "Link ending for “{text}”",
  "common.more": "More options",
  "templates.title": "Message templates",
  "templates.lead": "Once 24 hours have passed since the customer's last message, WhatsApp only lets the business write with a template approved by Meta. Create templates here and follow their review.",
  "templates.new": "New template",
  "templates.sync": "Fetch from Meta",
  "templates.no_account": "Connect a number in Settings › Numbers to create templates.",
  "templates.empty": "No templates yet. Create the first one or fetch the ones already at Meta.",
  "templates.filter.all": "All",
  "templates.filter.approved": "Approved",
  "templates.filter.review": "In review",
  "templates.filter.rejected": "Needs attention",
  "templates.filter.draft": "Drafts",
  "templates.status.draft": "Draft",
  "templates.status.pending": "In review",
  "templates.status.approved": "Approved",
  "templates.status.rejected": "Rejected",
  "templates.status.paused": "Paused",
  "templates.status.disabled": "Disabled",
  "templates.status.archived": "Deleted",
  "templates.quality.GREEN": "High quality",
  "templates.quality.YELLOW": "Medium quality",
  "templates.quality.RED": "Low quality",
  "templates.quality.UNKNOWN": "Quality pending",
  "templates.recategorized": "Meta changed the category from {from} to {to}. Each send is priced by Meta's category.",
  "templates.reason": "Meta's reason: {reason}",
  "templates.reason.ABUSIVE_CONTENT": "abusive content",
  "templates.reason.INCORRECT_CATEGORY": "wrong category",
  "templates.reason.INVALID_FORMAT": "invalid format (variables, examples or buttons)",
  "templates.reason.PROMOTIONAL": "promotional content outside the marketing category",
  "templates.reason.SCAM": "suspected scam",
  "templates.reason.TAG_CONTENT_MISMATCH": "the content does not match the chosen category",
  "templates.reason.NONE": "Meta gave no reason",
  "templates.not_editable": "Made in WhatsApp Manager with features this editor does not write yet (one-tap code, carousel, catalog or flow). It can still be sent.",
  "templates.edit": "Edit",
  "templates.fix": "Fix and resend",
  "templates.duplicate": "Duplicate",
  "templates.delete": "Delete",
  "templates.delete_title": "Delete template?",
  "templates.delete_confirm": "The template {name} ({language}) will be deleted at Meta. Messages already sent stay in the history, and Meta blocks the name for 30 days.",
  "templates.delete_draft": "The draft {name} will be discarded. Meta never received it.",
  "templates.deleted": "Template deleted",
  "templates.back": "Back to templates",
  "templates.new_title": "New template",
  "templates.edit_title": "Edit template",
  "templates.add": "Add",
  "templates.remove": "Remove",
  "templates.field.account": "WhatsApp account",
  "templates.field.name": "Template name",
  "templates.field.name_hint": "At Meta: {name}",
  "templates.field.name_locked": "The name and language cannot change once Meta has the template. Duplicate it for another name.",
  "templates.field.language": "Language",
  "templates.field.category": "Category",
  "templates.category.utility_hint": "Confirmations, reminders and updates about something the customer asked for or bought.",
  "templates.category.marketing_hint": "Offers, news, invitations and messages to reconnect.",
  "templates.category.note": "Meta checks the category and may change it. Each send is priced by the final category.",
  "templates.field.header": "Header",
  "templates.field.header_text": "Header text",
  "templates.field.body": "Message",
  "templates.field.body_text": "Message text",
  "templates.field.examples": "Variable examples",
  "templates.field.examples_hint": "Meta uses the examples to review the template. Use realistic values, never real customer data.",
  "templates.field.example": "Example for {variable}",
  "templates.field.footer": "Footer",
  "templates.field.footer_text": "Footer text",
  "templates.field.buttons": "Buttons",
  "templates.button.add": "Add button",
  "templates.button.quick_reply": "Quick reply",
  "templates.button.url": "Open website",
  "templates.button.phone": "Call",
  "templates.button.remove": "Remove button",
  "templates.button.text": "Button text",
  "templates.button.url_field": "Website address",
  "templates.button.url_hint": "With https://. For a link per customer, end it with {{1}}.",
  "templates.button.url_example": "Example of the address ending",
  "templates.button.phone_field": "Phone with country code",
  "templates.variable.add": "Add variable",
  "templates.format.bold": "Bold",
  "templates.format.italic": "Italic",
  "templates.format.strike": "Strikethrough",
  "templates.format.sample": "text",
  "templates.preview": "What the customer sees",
  "templates.preview_empty": "Write the message to see the preview.",
  "templates.all_options": "See all options",
  "templates.save_draft": "Save draft",
  "templates.submit": "Send to Meta",
  "templates.saved": "Draft saved",
  "templates.submitted": "Sent for Meta's review. It usually takes minutes to 24 hours, and the status updates here on its own.",
  "templates.approved_now": "Meta approved the template {name} right away.",
  "templates.meta_refused": "Meta refused it",
  "templates.pending_issues": "1 fix left before sending|{count} fixes left before sending",
  "templates.ready": "Ready to send to Meta",
  "templates.rules.title": "What Meta checks",
  "templates.rules.1": "Variables in order ({{1}}, {{2}}…), never at the start or end of the message.",
  "templates.rules.2": "A clear, complete message: vague texts or ones made mostly of variables are rejected.",
  "templates.rules.3": "Utility is about something the customer asked for. Offers, discounts or invitations are marketing.",
  "templates.rules.4": "Links on the business's own domain, no URL shorteners.",
  "templates.rules.5": "Never ask for sensitive data such as passwords, full card numbers or ID numbers.",
  "templates.issue.name_format": "Give it a name with letters, numbers or _.",
  "templates.issue.name_too_long": "The name can have up to 512 characters.",
  "templates.issue.language_required": "Choose the language.",
  "templates.issue.header_too_long": "The header can have up to 60 characters.",
  "templates.issue.header_format": "The header is a single line.",
  "templates.issue.header_variables": "The header takes one variable, {{1}}.",
  "templates.issue.header_example_missing": "Write an example for the header variable.",
  "templates.issue.body_required": "Write the message.",
  "templates.issue.body_too_long": "The message can have up to 1,024 characters.",
  "templates.issue.variables_not_sequential": "Variables must go {{1}}, {{2}}, {{3}}… without skipping numbers.",
  "templates.issue.variable_at_edge": "Meta rejects messages that start or end with a variable. Put text before and after it.",
  "templates.issue.example_missing": "Write an example for each variable.",
  "templates.issue.footer_too_long": "The footer can have up to 60 characters.",
  "templates.issue.footer_variables": "The footer takes no variables.",
  "templates.issue.too_many_buttons": "At most 10 buttons.",
  "templates.issue.too_many_url_buttons": "At most 2 website buttons.",
  "templates.issue.too_many_phone_buttons": "At most 1 call button.",
  "templates.issue.buttons_not_grouped": "Keep quick replies together, before or after the website and call buttons.",
  "templates.issue.button_text_required": "Write the button text.",
  "templates.issue.button_text_too_long": "Button text can have up to 25 characters.",
  "templates.issue.button_text_duplicate": "Each button needs a different text.",
  "templates.issue.url_invalid": "Use a full address starting with https://.",
  "templates.issue.url_variable_position": "The link takes one variable, {{1}}, at the end of the address.",
  "templates.issue.url_example_missing": "Write an example of the address ending.",
  "templates.issue.phone_invalid": "Use the phone with + and country code, like +1 415 555 0100.",
  "templates.warning.variables_dense": "Many variables for little text: Meta often rejects this. Write more fixed text.",
  "templates.warning.adjacent_variables": "Two variables in a row, with no text between them, are often rejected.",
  "templates.warning.promotional_utility": "The text looks promotional. Meta will likely classify it as marketing, which costs more.",
  "templates.warning.url_shortener": "Shortened links (bit.ly and similar) are often rejected. Use the full address.",
  "errors.template_name_taken": "This account already has a template with that name and language.",
  "errors.template_not_editable": "This template can't be edited now: in review it waits for Meta, and an approved one can be duplicated.",
  "errors.template_identity_locked": "The name and language can't change once Meta has the template. Duplicate it to use another name.",
  "errors.template_rejected_by_meta": "Meta rejected the template.",
  "errors.template_not_found": "Template not found. Refresh the page.",
  "errors.template_other_account": "This template belongs to another WhatsApp account: only that account's numbers can send it.",
  "presence.title": "My availability",
  "inbox.contact_info": "Contact details",
  "nav.reports": "Reports",
  "reports.title": "Reports",
  "reports.tab.overview": "Overview",
  "reports.tab.team": "Team",
  "reports.tab.outcomes": "Outcomes",
  "reports.tab.gate": "Message review",
  "reports.tab.audit": "Audit",
  "reports.period": "Period",
  "reports.period.7d": "7 days",
  "reports.period.30d": "30 days",
  "reports.period.month": "This month",
  "reports.period.custom": "Custom",
  "reports.from": "From",
  "reports.to": "To",
  "reports.team": "Team",
  "reports.all_teams": "All teams",
  "reports.export": "Export CSV",
  "reports.loading": "Calculating…",
  "reports.empty": "No data in this period.",
  "reports.kpi.opened": "Conversations opened",
  "reports.kpi.closed": "Closed",
  "reports.kpi.success": "Success rate",
  "reports.kpi.first_response": "First response (median)",
  "reports.kpi.handling": "Handling time (median)",
  "reports.kpi.messages": "Messages",
  "reports.kpi.inbound": "received",
  "reports.kpi.outbound": "sent",
  "reports.kpi.meta_cost": "Meta cost",
  "reports.kpi.meta_charged": "1 charged message · estimate|{count} charged messages · estimate",
  "reports.kpi.ai_cost": "AI cost",
  "reports.kpi.p90": "p90",
  "reports.daily": "Per day",
  "reports.daily.opened": "Opened",
  "reports.daily.closed": "Closed",
  "reports.daily.success": "Success",
  "reports.open_by_status": "Open right now",
  "reports.closed_by": "Closed by",
  "reports.closer.member": "People",
  "reports.closer.assistant": "AI assistant",
  "reports.closer.policy": "Automatic policy",
  "reports.closer.contact": "Contact",
  "reports.closer.api": "API",
  "reports.handler_mix": "Handled by",
  "reports.handler.flow": "Flow",
  "reports.handler.assistant": "Assistant",
  "reports.handler.human": "Human",
  "reports.members": "By person",
  "reports.teams": "By team",
  "reports.col.name": "Name",
  "reports.col.assigned": "Assigned",
  "reports.col.closed": "Closed",
  "reports.col.success": "Success",
  "reports.col.first_response": "First response",
  "reports.col.queue_wait": "Queue wait",
  "reports.col.sent": "Sent",
  "reports.col.active": "Open",
  "reports.outcomes": "Outcomes in the period",
  "reports.without_outcome": "Without outcome",
  "reports.col.count": "Count",
  "reports.col.share": "Share",
  "reports.gate.decisions": "Decisions",
  "reports.gate.verdict.approve": "Approved",
  "reports.gate.verdict.rewrite": "Rewritten",
  "reports.gate.verdict.block": "Blocked",
  "reports.gate.actions": "Member action",
  "reports.gate.action.accepted": "Accepted the suggestion",
  "reports.gate.action.edited": "Edited",
  "reports.gate.action.overridden": "Sent anyway",
  "reports.gate.action.cancelled": "Cancelled",
  "reports.gate.action.auto_sent": "Auto-corrected",
  "reports.gate.action.pending": "Pending",
  "reports.gate.latency": "Judge latency",
  "reports.gate.top_rules": "Most triggered rules",
  "reports.gate.review": "Human messages reviewed",
  "reports.gate.none": "No review policy was active in the period.",
  "audit.title": "Audit",
  "audit.search": "Search the action",
  "audit.action": "Action",
  "audit.all_actions": "All actions",
  "audit.actor": "Actor",
  "audit.actor.member": "Person",
  "audit.actor.system": "System",
  "audit.actor.assistant": "Assistant",
  "audit.actor.flow": "Flow",
  "audit.actor.policy": "Policy",
  "audit.when": "When",
  "audit.entity": "Entity",
  "audit.details": "Details",
  "audit.before": "Before",
  "audit.after": "After",
  "audit.load_more": "Load more",
  "audit.empty": "No events in this period.",
  "audit.actor.api_key": "API key",
  "audit.actor.platform_admin": "Platform admin",
  "integrations.title": "Integrations",
  "integrations.api_keys": "API keys",
  "integrations.api_keys_hint": "Send it in the Authorization: ApiKey <key> header. The key is shown only once.",
  "integrations.new_key": "New key",
  "integrations.key_name": "Key name",
  "integrations.key_created": "Copy it now: this key will not be shown again.",
  "integrations.revoke": "Revoke",
  "integrations.last_used": "Last used",
  "integrations.never": "never",
  "integrations.copy": "Copy",
  "integrations.copied": "Copied",
  "integrations.hooks": "Lead intake (inbound webhook)",
  "integrations.hooks_hint": "POST JSON or a form to the hook address. The contact is created or reused and a conversation is opened.",
  "integrations.new_hook": "New hook",
  "integrations.hook_name": "Name",
  "integrations.hook_phone": "Phone path in the payload",
  "integrations.hook_contact_name": "Name path",
  "integrations.hook_fields": "Contact fields (key = path, one per line)",
  "integrations.hook_goal": "Conversation goal",
  "integrations.hook_team": "Default team",
  "integrations.hook_flow": "Starting flow",
  "integrations.hook_url": "Hook address",
  "integrations.hook_created": "Copy the address now: the token will not be shown again.",
  "integrations.rotate": "Rotate token",
  "integrations.active": "Active",
  "integrations.webhooks": "Outgoing webhooks",
  "integrations.webhooks_hint": "We receive events and send a signed POST: DoneTalk-Signature carries t=<time>,v1=<HMAC SHA-256 of \"t.body\">. The old x-donetalk-signature header goes along until 2027-01-21.",
  "integrations.new_webhook": "New webhook",
  "integrations.webhook_url": "Target URL",
  "integrations.events": "Events",
  "integrations.secret_created": "Secret to verify the signature. Copy it now: it will not be shown again.",
  "integrations.test": "Send test",
  "integrations.test_sent": "Test event queued.",
  "integrations.pause": "Pause",
  "integrations.resume": "Resume",
  "integrations.deliveries": "Deliveries",
  "integrations.failures": "consecutive failures",
  "integrations.status.active": "Active",
  "integrations.status.paused": "Paused",
  "integrations.status.failing": "Failing",
  "integrations.event.conversation.opened": "Conversation opened",
  "integrations.event.conversation.closed": "Conversation closed",
  "integrations.event.conversation.assigned": "Conversation assigned",
  "integrations.event.conversation.transferred": "Conversation transferred",
  "integrations.event.conversation.reopened": "Conversation reopened",
  "integrations.event.contact.updated": "Contact updated",
  "integrations.event.message.received": "Message received",
  "integrations.event.message.sent": "Message sent",
  "integrations.event.flow.event": "Flow event",
  "common.edit": "Edit",
  "common.remove": "Remove",
  "contacts.title": "Contacts",
  "contacts.search": "Search by name or phone",
  "contacts.import": "Import CSV",
  "contacts.new": "New contact",
  "contacts.start": "Start conversation",
  "contacts.col.name": "Name",
  "contacts.col.phone": "Phone",
  "contacts.col.tags": "Tags",
  "contacts.col.last_activity": "Last activity",
  "contacts.col.source": "Source",
  "contacts.empty": "No contacts found.",
  "contacts.load_more": "Load more",
  "contacts.blocked": "Blocked",
  "contacts.open_conversation": "Open conversation",
  "contacts.source.inbound": "Inbound",
  "contacts.source.ad": "Ad",
  "contacts.source.import": "Import",
  "contacts.source.api": "API",
  "contacts.source.connector": "Integration",
  "contacts.source.manual": "Manual",
  "import.title": "Import data",
  "import.file": "Choose a CSV file (comma or semicolon separated, with a header row)",
  "import.rows": "{n} rows found",
  "import.map": "Map the columns",
  "import.col.phone": "Phone (required)",
  "import.col.name": "Name",
  "import.col.tags": "Tags (comma separated)",
  "import.col.marketing": "Accepts marketing (yes/no)",
  "import.col.external": "External id",
  "import.col.field": "Contact field",
  "import.col.ignore": "Ignore",
  "import.marketing_all": "Mark everyone as accepting marketing",
  "import.preview": "Preview",
  "import.run": "Import {n} contacts",
  "import.progress": "Importing… {done} of {total}",
  "import.done": "Import finished: {created} new, {updated} updated, {errors} with errors.",
  "import.errors": "Rows with errors",
  "import.reason.invalid_phone": "Invalid phone",
  "start.title": "Start a conversation with a template",
  "start.goal": "Goal",
  "start.team": "Team",
  "start.open_exists": "This contact already has an open conversation.",
  "start.marketing_opted_out": "The contact opted out of marketing messages.",
  "start.blocked": "Contact blocked.",
  "tags.title": "Tags",
  "tags.add": "Add tag",
  "tags.new": "New tag",
  "tags.name": "Name",
  "tags.color": "Color",
  "tags.applies": "Applies to",
  "tags.applies.contact": "Contacts",
  "tags.applies.conversation": "Conversations",
  "tags.applies.both": "Both",
  "tags.usage": "{contacts} contacts · {conversations} conversations",
  "tags.none": "No tags",
  "snippets.title": "Canned replies",
  "snippets.hint": "Type / in the message box to search. Variables: {{contact.first_name}}, {{contact.name}}, {{member.name}}, {{member.first_name}}.",
  "snippets.new": "New reply",
  "snippets.name": "Title",
  "snippets.shortcut": "Shortcut",
  "snippets.body": "Text",
  "snippets.team": "Team (empty = all)",
  "snippets.global": "All teams",
  "snippets.picker": "Canned replies",
  "snippets.no_match": "No reply matches",
  "optout.title": "Opt-out by keyword",
  "optout.hint": "When the contact sends one of these words we record the marketing opt-out and, if configured, reply automatically.",
  "optout.keywords": "Keywords (one per line)",
  "optout.reply": "Automatic reply (optional)",
  "settings.organization": "Outcomes, tags and replies",
  "platform.title": "Platform console",
  "platform.open": "Open the platform console",
  "platform.tab.overview": "Overview",
  "platform.tab.customers": "Customers",
  "platform.tab.plans": "Plans",
  "platform.tab.ai": "AI",
  "platform.tab.admins": "Admins",
  "platform.tab.audit": "Audit",
  "platform.kpi.customers": "Customers",
  "platform.kpi.active": "Active",
  "platform.kpi.trial": "On trial",
  "platform.kpi.failed": "Failed databases",
  "platform.kpi.conversations": "Conversations this month",
  "platform.kpi.messages_out": "Messages sent this month",
  "platform.kpi.ai_cost": "AI cost this month",
  "platform.kpi.meta_cost": "Meta cost this month",
  "platform.days": "Last 14 days",
  "platform.by_lifecycle": "By lifecycle",
  "platform.by_db": "By database state",
  "platform.lifecycle.prospect": "Prospect",
  "platform.lifecycle.trial": "Trial",
  "platform.lifecycle.active": "Active",
  "platform.lifecycle.suspended": "Suspended",
  "platform.lifecycle.churned": "Churned",
  "platform.db.pending": "Pending",
  "platform.db.provisioning": "Provisioning",
  "platform.db.migrating": "Migrating",
  "platform.db.seeding": "Seeding",
  "platform.db.ready": "Ready",
  "platform.db.failed": "Failed",
  "platform.customers.search": "Search by name, identifier or owner",
  "platform.customers.new": "New customer",
  "platform.customers.col.name": "Customer",
  "platform.customers.col.plan": "Plan",
  "platform.customers.col.lifecycle": "Lifecycle",
  "platform.customers.col.db": "Database",
  "platform.customers.col.members": "People",
  "platform.customers.col.created": "Created",
  "platform.customers.empty": "No customers.",
  "platform.customer.slug": "Identifier",
  "platform.customer.name": "Name",
  "platform.customer.legal_name": "Legal name",
  "platform.customer.tax_id": "Tax id",
  "platform.customer.owner_email": "Owner email",
  "platform.customer.owner_name": "Owner name",
  "platform.customer.locale": "Default language",
  "platform.customer.timezone": "Timezone",
  "platform.customer.plan": "Plan",
  "platform.customer.no_plan": "No plan",
  "platform.customer.visibility": "Conversation visibility",
  "platform.visibility.open": "Everyone sees everything",
  "platform.visibility.team": "By team",
  "platform.visibility.own": "Own only",
  "platform.customer.lifecycle": "Lifecycle",
  "platform.customer.created": "Customer created. Owner: {email}.",
  "platform.customer.invite": "Owner access link (shown once)",
  "platform.customer.provision": "Provision database again",
  "platform.customer.provisioned": "Database provisioned: {state}",
  "platform.customer.stats": "Numbers",
  "platform.customer.stat.contacts": "Contacts",
  "platform.customer.stat.open": "Open conversations",
  "platform.customer.stat.closed_month": "Closed this month",
  "platform.customer.stat.channels": "Numbers",
  "platform.customer.stat.flows": "Published flows",
  "platform.customer.stat.assistants": "Active assistants",
  "platform.customer.members": "People",
  "platform.customer.add_owner": "Add owner",
  "platform.customer.usage": "Usage this month",
  "platform.customer.open_workspace": "Open as customer",
  "platform.plans.new": "New plan",
  "platform.plans.code": "Code",
  "platform.plans.name": "Name",
  "platform.plans.limits": "Limits",
  "platform.plans.features": "Included features",
  "platform.plans.customers": "{n} customers",
  "platform.plans.invalid_json": "Invalid JSON",
  "platform.ai.models": "Models",
  "platform.ai.keys": "Platform keys",
  "platform.ai.surfaces": "Routing by task",
  "platform.ai.refresh": "Read the providers' models",
  "platform.ai.sync_pricing": "Update catalog and prices",
  "platform.ai.col.model": "Model",
  "platform.ai.col.provider": "Provider",
  "platform.ai.col.input": "Input / 1M",
  "platform.ai.col.output": "Output / 1M",
  "platform.ai.col.enabled": "Enabled",
  "platform.ai.add_key": "Add key",
  "platform.ai.surface": "Task",
  "platform.ai.default_model": "Default model",
  "platform.admins.add": "Add admin",
  "platform.admins.email": "Email (existing user)",
  "platform.admins.role": "Role",
  "platform.admins.role.super": "Super",
  "platform.admins.role.support": "Support",
  "platform.admins.remove": "Remove",
  "platform.audit.actor": "Who",
  "platform.audit.action": "Action",
  "platform.audit.entity": "Entity",
  "platform.audit.data": "Data",
  "auth.account": "Account",
  "media.unsupported": "File type not accepted by WhatsApp.",
  "media.too_large": "File too large for WhatsApp.",
  "reports.by_tag": "By tag",
  "settings.learning": "Learning",
  "learning.title": "Account learning",
  "learning.hint": "Every week the system analyzes successfully closed conversations and proposes playbook replies, assistant instruction changes, flow questions and knowledge documents. Nothing changes on its own: you approve.",
  "learning.generate": "Analyze now",
  "learning.generating": "Analyzing…",
  "learning.period": "Period",
  "learning.status.generating": "Analyzing",
  "learning.status.ready": "Ready",
  "learning.status.failed": "Failed",
  "learning.status.archived": "Archived",
  "learning.trigger.manual": "Manual",
  "learning.trigger.weekly": "Weekly",
  "learning.stats": "{analyzed} conversations analyzed · {successful} successful",
  "learning.suggestions": "Suggestions",
  "learning.counts": "{proposed} proposed · {applied} applied · {rejected} rejected",
  "learning.summary": "Summary",
  "learning.empty": "No analysis yet. Generate the first one or wait for the weekly run.",
  "learning.no_suggestions": "No suggestions in this report.",
  "learning.kind.playbook_reply": "Playbook reply",
  "learning.kind.prompt_change": "Assistant change",
  "learning.kind.flow_question": "Flow question",
  "learning.kind.knowledge_doc": "Knowledge document",
  "learning.rationale": "Why",
  "learning.evidence": "Evidence",
  "learning.success_rate": "{rate}% success over {n} conversations",
  "learning.approve": "Approve and apply",
  "learning.approve_only": "Approve",
  "learning.reject": "Reject",
  "learning.applied": "Applied",
  "learning.rejected": "Rejected",
  "learning.approved": "Approved",
  "learning.target.collection": "Target collection",
  "learning.target.assistant": "Target assistant",
  "learning.target.team": "Team (empty = all)",
  "learning.body": "Text (you can edit it before applying)",
  "learning.archive": "Archive",
  "learning.prompt_note": "The text goes into the assistant draft. Publish after testing.",
  "brief.generate": "AI summary",
  "brief.generating": "Summarizing…",
  "brief.title": "Conversation summary",
  "brief.empty": "No messages to summarize.",
  "outcome.suggestion": "AI suggestion: {label} · {confidence}%",
  "outcome.suggestion_reason": "Reason",
  "hours.title": "Business hours",
  "hours.new": "New schedule",
  "hours.name": "Name",
  "hours.timezone": "Timezone",
  "hours.weekly": "Days and hours",
  "hours.from": "Opens {day}",
  "hours.to": "Closes {day}",
  "hours.closed": "Closed",
  "hours.none": "No schedule",
  "hours.day.mon": "Monday",
  "hours.day.tue": "Tuesday",
  "hours.day.wed": "Wednesday",
  "hours.day.thu": "Thursday",
  "hours.day.fri": "Friday",
  "hours.day.sat": "Saturday",
  "hours.day.sun": "Sunday",
  "hours.hint": "Outside these hours the flow can answer with the away message and the conversation waits in the queue.",
  "reports.tab.monitor": "Live monitor",
  "monitor.updated": "Updated {time}",
  "monitor.total.open": "Open",
  "monitor.total.waiting_reply": "Waiting for our reply",
  "monitor.total.unanswered": "Unanswered for 15+ min",
  "monitor.total.closed_today": "Closed today",
  "monitor.total.success_today": "Success today",
  "monitor.queues": "Queues",
  "monitor.col.queue": "Queue",
  "monitor.col.waiting": "Queued",
  "monitor.col.oldest": "Oldest wait",
  "monitor.col.active": "Active",
  "monitor.col.online": "Online",
  "monitor.no_team": "No team",
  "monitor.members": "People now",
  "monitor.col.member": "Person",
  "monitor.col.presence": "Availability",
  "monitor.col.load": "Load",
  "monitor.col.oldest_unanswered": "Unanswered for",
  "monitor.alerts": "Alerts",
  "monitor.alert.first_response_over": "{name} has waited {minutes} min for a first reply",
  "monitor.alert.unanswered_over": "{name} unanswered for {minutes} min",
  "monitor.alert.queue_over": "Queue {name} waiting {minutes} min",
  "monitor.no_alerts": "All caught up.",
  "monitor.open": "Open",
  "inbox.window.chip": "{time} left",
  "inbox.window.free_chip": "Ad · free for {time}",
  "inbox.window.closing": "Window closing",
  "fields.title": "Contact fields",
  "fields.hint": "Extra fields shown on the contact panel, in imports and in the intake hook. Tick «AI can fill» so the assistant stores the value during the conversation.",
  "fields.new": "New field",
  "fields.label": "Field name",
  "fields.key": "Key (API and imports)",
  "fields.type": "Type",
  "fields.options": "Options (one per line)",
  "fields.ai": "AI can fill",
  "fields.ai_hint": "Hint for the AI (how to spot the value)",
  "fields.required": "Required",
  "fields.active": "Active",
  "fields.type.text": "Text",
  "fields.type.number": "Number",
  "fields.type.date": "Date",
  "fields.type.boolean": "Yes/no",
  "fields.type.select": "Option list",
  "fields.type.phone": "Phone",
  "fields.type.email": "Email",
  "fields.type.cpf": "CPF",
  "fields.type.cnpj": "CNPJ",
  "fields.key_taken": "A field with that key already exists.",
  "policy.priority": "Priority",
  "select.search": "Search…",
  "select.empty": "No option found",
  "inbox.action.open": "Open",
  "inbox.action.copy_phone": "Copy phone",
  "message.reply": "Reply",
  "message.copy": "Copy text",
  "message.download": "Download file",
  "message.copied": "Copied",
  "message.replying": "Replying to",
  "contact.media": "Media, links and docs",
  "contact.media.tab.media": "Media",
  "contact.media.tab.docs": "Docs",
  "contact.media.tab.links": "Links",
  "contact.media.empty": "Nothing to show",
  "inbox.reconnecting": "Reconnecting…",
  "composer.failed": "Could not send",
  "composer.attach.label": "Attach",
  "composer.attach.document": "Document",
  "composer.attach.media": "Photos & videos",
  "composer.attach.camera": "Camera",
  "composer.attach.audio": "Audio",
  "composer.attach.contact": "Contact",
  "composer.attach.poll": "Poll",
  "composer.attach.event": "Event",
  "composer.attach.sticker": "New sticker",
  "composer.mic_denied": "Could not access the microphone. Allow it in the browser or attach an audio file.",
  "composer.mic_unavailable": "Microphone unavailable",
  "composer.voice_note": "Voice message",
  "composer.edit": "Edit message",
  "composer.reply": "Reply",
  "composer.cancel_reference": "Cancel reply or edit",
  "composer.voice_discard": "Discard recording",
  "composer.voice_preview": "Play back the recording",
  "composer.voice_resume": "Resume recording",
  "composer.voice_pause": "Pause recording",
  "composer.voice_send": "Send voice message",
  "composer.no_snippet": "No reply found",
  "composer.expressions": "Emoji, GIFs and stickers",
  "composer.placeholder": "Type a message",
  "composer.save_edit": "Save edit",
  "composer.send": "Send",
  "composer.voice": "Voice message",
  "media.pages": "{count} page|{count} pages",
  "media.composer_label": "Send files",
  "media.preparing": "Preparing file…",
  "media.remove": "Remove file",
  "media.remove_file": "Remove {name}",
  "media.no_preview": "No preview available",
  "media.drop_more": "Drop to add",
  "media.drop_here": "Drop files to send",
  "media.caption": "Type a message",
  "media.caption_none": "Audio and stickers take no caption",
  "media.emoji": "Emoji",
  "media.files": "Selected files",
  "media.add_more": "Add file",
  "media.refused_count": "{count} file will not be sent|{count} files will not be sent",
  "media.send": "Send {count} file|Send {count} files",
  "media.error.type": "WhatsApp does not accept {ext} files through the official API.",
  "media.error.too_large": "Larger than WhatsApp's limit for this file type ({max}).",
  "media.error.empty": "The file is empty.",
  "media.error.heic": "This browser cannot open HEIC photos. Use DoneTalk in Safari or export the photo as JPG.",
  "media.error.conversion": "This file could not be prepared.",
  "media.error.gate": "The caption needs review before sending.",
  "media.error.network": "Connection failed while sending.",
  "media.note.converted_jpeg": "Goes as a JPG photo, the format WhatsApp accepts.",
  "media.note.compressed": "Photo compressed to fit WhatsApp's 5 MB limit.",
  "media.note.as_text": "Goes as a text file, keeping its name.",
  "media.note.sticker": "Becomes a 512 × 512 sticker.",
  "media.open": "Open media",
  "media.download_named": "Download {name}",
  "media.retry": "Try again",
  "media.discard": "Discard",
  "media.album": "Album with {count} items",
  "media.album_more": "{count} more items",
  "media.audio.play": "Play",
  "media.audio.pause": "Pause",
  "media.audio.position": "Audio position",
  "media.audio.rate": "Playback speed",
  "media.viewer.label": "Media viewer",
  "media.viewer.you": "You",
  "media.viewer.previous": "Previous",
  "media.viewer.next": "Next",
  "media.viewer.item": "Item {n} of {total}",
  "camera.title": "Take photo",
  "camera.denied": "Could not access the camera. Allow it in the browser.",
  "camera.shoot": "Take photo",
  "share_contact.title": "Send contact",
  "share_contact.search": "Search contacts",
  "share_contact.empty": "No contacts with WhatsApp found.",
  "share_contact.count": "{count} of {max} selected",
  "share_contact.send": "Send",
  "media.caption_refused": "This file will not be sent",
  "delivery.pending": "Pending",
  "delivery.sent": "Sent",
  "delivery.delivered": "Delivered",
  "delivery.read": "Read",
  "delivery.failed": "Not sent",
  "delivery.help.pending": "Waiting for a connection or send confirmation.",
  "delivery.help.sent": "Accepted by the service; delivery is not yet confirmed.",
  "delivery.help.delivered": "Delivered to the recipient.",
  "delivery.help.read": "Reading confirmed by the recipient.",
  "delivery.help.failed": "Sending failed. You can try again.",
  "delivery.demo.title": "Delivery states",
  "delivery.demo.description": "Choose a state to inspect or simulate sending. This demo is local and does not send messages.",
  "delivery.demo.states": "Message states",
  "delivery.demo.scenario": "Network condition",
  "delivery.demo.normal": "Normal",
  "delivery.demo.slow": "Slow network",
  "delivery.demo.offline": "Offline",
  "delivery.demo.failure": "Send failure",
  "delivery.demo.start": "Simulate sending",
  "delivery.demo.reconnect": "Restore connection",
  "delivery.demo.message": "All set! I will send you the details here.",
  "delivery.demo.error": "This message could not be sent.",
  "delivery.demo.discarded": "Message discarded. Simulate a new send to start again.",
  "delivery.played": "Played",
  "delivery.info.title": "Message info",
  "delivery.info.at": "{day} at {time}",
  "delivery.info.code": "Meta code: {code}",
  "delivery.info.no_read": "WhatsApp only reports a read when the contact opens the chat and keeps read receipts on.",
  "meta.pricing.title": "Meta charge",
  "meta.pricing.estimate_hint": "Estimated from Meta's public rate card. Volume tiers can lower it; Meta's invoice is what counts.",
  "meta.pricing.free_customer_service": "Free · within the 24-hour customer service window",
  "meta.pricing.free_entry_point": "Free · free entry point window from an ad",
  "meta.pricing.charged_unknown": "Charged by Meta · {category}",
  "meta.pricing.unknown_currency_hint": "The amount shows once the WhatsApp account at Meta has a currency.",
  "meta.pricing.category.marketing": "Marketing",
  "meta.pricing.category.marketing_lite": "Marketing (MM Lite)",
  "meta.pricing.category.utility": "Utility",
  "meta.pricing.category.authentication": "Authentication",
  "meta.pricing.category.authentication-international": "International authentication",
  "meta.pricing.category.service": "Service",
  "meta.pricing.category.referral_conversion": "Free entry point",
  "meta.market.north_america": "North America",
  "meta.market.rest_of_africa": "Rest of Africa",
  "meta.market.rest_of_asia_pacific": "Rest of Asia Pacific",
  "meta.market.rest_of_central_eastern_europe": "Rest of Central & Eastern Europe",
  "meta.market.rest_of_latin_america": "Rest of Latin America",
  "meta.market.rest_of_middle_east": "Rest of Middle East",
  "meta.market.rest_of_western_europe": "Rest of Western Europe",
  "meta.market.other": "Other countries",
  "delivery.retry.window": "More than 24 hours since the customer's last message: send a template to resume.",
  "delivery.retry.final": "This failure must be fixed before sending again.",
  "delivery.error.131047": "More than 24 hours since the customer's last message. Send a template to resume the conversation.",
  "delivery.error.131026": "Not delivered: the number may not have WhatsApp, be outdated, or have blocked the business.",
  "delivery.error.131049": "Meta held it back to protect engagement: marketing message limit for this contact.",
  "delivery.error.131050": "The contact asked not to receive marketing messages.",
  "delivery.error.131051": "Message type not accepted by WhatsApp.",
  "delivery.error.131053": "Media upload failed: format or size not accepted by WhatsApp.",
  "delivery.error.131056": "Too many messages to the same contact in a short time. Wait and try again.",
  "delivery.error.130429": "The number's sending limit was reached. Try again shortly.",
  "delivery.error.131048": "Sending limited by Meta after recent blocks or reports.",
  "delivery.error.131042": "Payment problem on the WhatsApp Business account: currency, payment method or credit limit. Check Billing & payments in Meta Business Suite.",
  "delivery.error.131031": "The WhatsApp Business account is locked by Meta.",
  "delivery.error.368": "Sending blocked for violating WhatsApp policies.",
  "delivery.error.131000": "Unexpected error at Meta. Try again.",
  "delivery.error.131005": "The number's token cannot send. Reconnect the number.",
  "delivery.error.132000": "The number of variables does not match the approved template.",
  "delivery.error.132001": "The template does not exist in this language or is not approved yet.",
  "delivery.error.132015": "Meta paused the template for low quality.",
  "delivery.error.132016": "Meta disabled the template.",
  "delivery.error.133010": "The business number is not registered on the WhatsApp API.",
  "delivery.error.130472": "The contact is in a Meta experiment that holds back marketing messages.",
  "delivery.error.credential_invalid": "The number's credential could not be read. Reconnect it in Settings › Numbers.",
  "delivery.error.media_missing": "This message's file was not found for sending.",
  "delivery.error.contact_without_identity": "The contact has no WhatsApp number.",
  "message.edited": "edited",
  "message.contact": "Contact",
  "message.options": "Message options",
  "message.quote_unavailable": "Message not loaded",
  "message.quote.photo": "Photo",
  "message.quote.video": "Video",
  "message.quote.voice": "Voice message",
  "message.quote.audio": "Audio",
  "message.quote.sticker": "Sticker",
  "message.quote.contact": "Contact",
  "outcomes.title": "Outcomes",
  "outcomes.new": "New outcome",
  "outcomes.hint": "Every conversation ends with an outcome. Successful ones count as results in reports and learning.",
  "outcomes.name": "Name",
  "outcomes.category": "Type",
  "outcomes.category.success": "Success",
  "outcomes.category.neutral": "Neutral",
  "outcomes.category.negative": "Unsuccessful",
  "outcomes.category.invalid": "Invalid",
  "outcomes.requires_note": "Ask for a note when closing",
  "outcomes.reopen": "Allow reopening the conversation",
  "outcomes.used": "Used in {count} conversation|Used in {count} conversations",
  "outcomes.unused": "Not used yet",
  "outcomes.note": "asks for a note",
  "outcomes.move_up": "Move up",
  "outcomes.move_down": "Move down",
  "outcomes.archived_hint": "Archived: no longer offered when closing, but kept in history and reports.",
  "errors.validation_failed": "Check the fields and try again.",
  "errors.last_active_outcome": "Keep at least one outcome active: every conversation needs one to be closed.",
  "errors.outcome_not_found": "That outcome no longer exists.",
  "errors.forbidden": "You are not allowed to do this.",
  "common.done": "Done",
  "handler.hybrid": "Hybrid",
  "numbers.connected": "Connected",
  "numbers.off": "Off",
  "numbers.display_name": "Display name",
  "numbers.name.approved": "Approved by Meta",
  "numbers.name.pending": "Under review by Meta",
  "numbers.name.declined": "Declined by Meta",
  "numbers.name.expired": "Expired",
  "numbers.quality.green": "High",
  "numbers.quality.yellow": "Medium",
  "numbers.quality.red": "Low",
  "numbers.quality.unknown": "Not rated",
  "numbers.health.ok": "Ready to send messages",
  "numbers.health.limited": "Sending limited by Meta",
  "numbers.health.blocked": "Something blocks sending messages",
  "numbers.health.unknown": "Not checked with Meta yet",
  "numbers.health.checked": "Checked {when}",
  "numbers.health.check": "Check now",
  "numbers.health.meta_code": "Meta code: {code}",
  "numbers.health.code.141006": "Meta has no valid payment method. Without one the business cannot start conversations with templates. Add a card in WhatsApp Manager.",
  "numbers.manager": "Open in WhatsApp Manager",
  "numbers.pin.show": "Show PIN",
  "numbers.pin.title": "Two-step verification PIN",
  "numbers.pin.fresh_title": "Number connected. Keep the PIN",
  "numbers.pin.explain": "{number} was registered on the official API with this two-step verification PIN:",
  "numbers.pin.keep": "It is kept here, encrypted. You will need it if you ever move the number to another platform.",
  "numbers.pin.copy": "Copy PIN",
  "numbers.pin.copied": "PIN copied",
  "numbers.meta.title": "Connect a WhatsApp number",
  "numbers.meta.hint": "The connection happens in Meta's official window, with nothing to install. When you finish, you come back here.",
  "numbers.meta.before": "You will need",
  "numbers.meta.req_facebook": "The Facebook account of whoever runs the business",
  "numbers.meta.req_number": "A free number, or the business's WhatsApp Business number (it keeps working on the phone)",
  "numbers.meta.req_code": "That number's phone nearby, to get the code by SMS or call",
  "numbers.meta.connect": "Connect with Meta",
  "numbers.meta.step1": "Sign in with Facebook",
  "numbers.meta.step2": "Choose or create the business portfolio",
  "numbers.meta.step3": "Display name, category and number",
  "numbers.meta.step4": "Confirm the number with the code",
  "numbers.meta.unavailable": "Connecting through Meta's window is not set up on this platform yet. Use the manual connection or contact support.",
  "numbers.meta.connected": "{number} connected",
  "numbers.meta.cancelled": "Meta's window closed before finishing. Nothing changed.",
  "numbers.meta.sdk_blocked": "Meta's window could not open. Check for an ad or pop-up blocker.",
  "numbers.manual.toggle": "Manual connection (advanced)",
  "errors.waba_not_found": "Meta did not say which WhatsApp account was chosen. Connect again and finish every step of the window.",
  "errors.waba_without_number": "The WhatsApp account was connected but has no number yet. Connect again and add the number in Meta's window.",
  "errors.phone_number_required": "That account has more than one number. Connect again and pick the number in Meta's window.",
  "errors.pin_not_found": "No PIN is kept here for this number.",
  "errors.account_without_credential": "The WhatsApp account lost access. Connect the number again.",
  "errors.channel_not_found": "That number no longer exists.",
  "numbers.name.unknown": "Not reported by Meta yet",
  "numbers.health.info.display_name_pending": "Meta has not approved the display name yet. The message limit goes up once it is approved.",
  "numbers.token_soon": "Meta's access to this number expires on {date}. It renews automatically; if it does not, reconnect the number so service does not stop.",
  "numbers.token_expired": "Meta's access to this number expired on {date}. Reconnect the number to send and receive messages again.",
  "numbers.reconnect": "Reconnect with Meta",
  "platform.customer.billing": "Meta billing",
  "platform.customer.billing.customer": "The customer pays Meta with their own card",
  "platform.customer.billing.partner": "Partner credit line (Nuvvun pays and bills the customer)",
  "numbers.meta.billing_partner": "Meta charges messages to our partner's credit line: no card needed",
  "nav.onboarding": "Setup",
  "common.copy_link": "Copy link",
  "common.link_copied": "Link copied",
  "errors.channel_unavailable": "Connect a WhatsApp number first.",
  "errors.step_required": "This step is required and can't be skipped.",
  "errors.onboarding_incomplete": "Some required steps are still open.",
  "errors.onboarding_not_answered": "Answer the questionnaire first.",
  "errors.assistant_not_published": "Publish the assistant before choosing it.",
  "onboarding.stage.welcome": "Welcome",
  "onboarding.stage.whatsapp": "WhatsApp",
  "onboarding.stage.team": "Team",
  "onboarding.stage.organization": "Organization",
  "onboarding.stage.entry": "First contact",
  "onboarding.stage.outbound": "Outbound messages",
  "onboarding.stage.golive": "Rehearsal and go-live",
  "onboarding.stage.welcome.summary": "Tell us about the company so the journey fits you.",
  "onboarding.stage.whatsapp.summary": "Connect the company's official number to DoneTalk.",
  "onboarding.stage.team.summary": "Who attends, in which queues and at what times.",
  "onboarding.stage.organization.summary": "How conversations end and how the team organizes itself.",
  "onboarding.stage.entry.summary": "What customers get when they send their first message.",
  "onboarding.stage.outbound.summary": "To message customers first, Meta requires approved templates.",
  "onboarding.stage.golive.summary": "An end-to-end test with your phone; then open it to the team.",
  "onboarding.step.welcome.questionnaire": "Quick questionnaire",
  "onboarding.step.whatsapp.connect": "Connect through Meta",
  "onboarding.step.whatsapp.payment": "Payment method at Meta",
  "onboarding.step.team.invite": "Invite people",
  "onboarding.step.team.queues": "Teams (queues)",
  "onboarding.step.team.hours": "Opening hours",
  "onboarding.step.organization.outcomes": "Outcomes",
  "onboarding.step.organization.snippets": "Canned replies",
  "onboarding.step.organization.autoclose": "Automatic closing",
  "onboarding.step.organization.tags": "Tags",
  "onboarding.step.entry.first_contact": "First contact",
  "onboarding.step.entry.after_hours": "After hours",
  "onboarding.step.entry.assistant": "AI assistant",
  "onboarding.step.outbound.templates": "Approved templates",
  "onboarding.step.outbound.optout": "Opt-out",
  "onboarding.step.golive.rehearsal": "Full rehearsal",
  "onboarding.step.golive.tour": "Team tour",
  "onboarding.step.golive.live": "Go live",
  "onboarding.when.welcome.questionnaire": "Done when answered or skipped.",
  "onboarding.when.whatsapp.connect": "Done when the number is active. The display name stays in review and can be used meanwhile.",
  "onboarding.when.whatsapp.payment": "Done when a card is on file. Without it no templates go out, and from October 1, 2026 no replies beyond the month's 1,000 free ones.",
  "onboarding.when.team.invite": "Done when an invitation is sent or you choose to attend alone.",
  "onboarding.when.team.queues": "Done when a team has people.",
  "onboarding.when.team.hours": "Done when the hours are saved and linked to the teams.",
  "onboarding.when.organization.outcomes": "Done when the list is reviewed, with the successful ones marked.",
  "onboarding.when.organization.snippets": "Done with three or more.",
  "onboarding.when.organization.autoclose": "Done with one active rule.",
  "onboarding.when.organization.tags": "Done with one or more.",
  "onboarding.when.entry.first_contact": "Done when a menu, assistant or team is chosen and published.",
  "onboarding.when.entry.after_hours": "Done when the message is published with the menu.",
  "onboarding.when.entry.assistant": "Done when published, with knowledge.",
  "onboarding.when.outbound.templates": "Done when Meta approves a template.",
  "onboarding.when.outbound.optout": "Done when the words are saved. The confirmation reply is optional.",
  "onboarding.when.golive.rehearsal": "Done when the test conversation ends with an outcome.",
  "onboarding.when.golive.tour": "Done when the invited team has seen the tour.",
  "onboarding.when.golive.live": "Done when every required step is done.",
  "onboarding.done.welcome.questionnaire": "Questionnaire answered",
  "onboarding.done.whatsapp.connect": "Number connected",
  "onboarding.done.whatsapp.payment": "Payment method on file at Meta",
  "onboarding.done.team.invite": "Invitations sent",
  "onboarding.done.team.queues": "Teams with people",
  "onboarding.done.team.hours": "Hours linked to the teams",
  "onboarding.done.organization.outcomes": "Outcomes reviewed",
  "onboarding.done.organization.snippets": "Canned replies created",
  "onboarding.done.organization.autoclose": "Automatic closing on",
  "onboarding.done.organization.tags": "Tags created",
  "onboarding.done.entry.first_contact": "First contact published",
  "onboarding.done.entry.after_hours": "After-hours message published",
  "onboarding.done.entry.assistant": "Assistant published, with knowledge",
  "onboarding.done.outbound.templates": "Template approved by Meta",
  "onboarding.done.outbound.optout": "Opt-out set",
  "onboarding.done.golive.rehearsal": "Full rehearsal done",
  "onboarding.done.golive.tour": "The team saw the tour",
  "onboarding.done.golive.live": "Live",
  "onboarding.lead.welcome.questionnaire": "Tell us a bit about the company. From the answers, the journey suggests teams, outcomes, canned replies and the welcome message.",
  "onboarding.lead.whatsapp.connect": "Connect the company's official number in Meta's window. It takes about 10 minutes.",
  "onboarding.lead.whatsapp.payment": "Add a card at Meta. Without it no templates go out, and from October 1, 2026 replies also stop after the month's 1,000 free ones per number. Messages are paid directly to Meta.",
  "onboarding.lead.team.invite": "Invite the company's people and pick each one's role. They get the invitation by email. It takes about 5 minutes.",
  "onboarding.lead.team.queues": "Create queues by subject and add people to each one.",
  "onboarding.lead.team.hours": "Link the opening hours to the teams.",
  "onboarding.lead.organization.outcomes": "Review how conversations end and mark the ones that count as success.",
  "onboarding.lead.organization.snippets": "Prepare the replies the team writes the most.",
  "onboarding.lead.organization.autoclose": "Turn on automatic closing so no conversation stays open by mistake.",
  "onboarding.lead.organization.tags": "Create tags to mark and filter contacts and conversations.",
  "onboarding.lead.entry.first_contact": "Choose what customers get on their first message: a menu, the assistant or straight to the team.",
  "onboarding.lead.entry.after_hours": "Write the message customers get after hours.",
  "onboarding.lead.entry.assistant": "Publish an AI assistant with the company's knowledge.",
  "onboarding.lead.outbound.templates": "Create a follow-up and a reminder template and send them for Meta's approval.",
  "onboarding.lead.outbound.optout": "Set the opt-out words and the reply.",
  "onboarding.lead.golive.rehearsal": "Walk your customer's path with your phone, from “Hi” to the outcome.",
  "onboarding.lead.golive.tour": "Send the short tour for the team to see on first access.",
  "onboarding.lead.golive.live": "All set: open customer service to the team.",
  "onboarding.level.required": "Required",
  "onboarding.level.recommended": "Recommended",
  "onboarding.level.optional": "Optional",
  "onboarding.status.done": "Done",
  "onboarding.status.now": "Now",
  "onboarding.status.step_done": "Done",
  "onboarding.status.skipped": "Skipped",
  "onboarding.hub.title": "Setup",
  "onboarding.hub.started": "Started on {date}.",
  "onboarding.hub.left": "About {minutes} minutes of work left.",
  "onboarding.hub.no_left": "Every stage is done.",
  "onboarding.hub.done_count": "{done} of {total} stages done",
  "onboarding.hub.now": "Now · stage {n} · {stage}",
  "onboarding.hub.start": "Start",
  "onboarding.hub.skip_now": "Skip for now",
  "onboarding.hub.open": "Open",
  "onboarding.hub.resume": "Resume",
  "onboarding.hub.steps_progress": "{done} of {total} steps · about {minutes} min",
  "onboarding.hub.minutes": "about {minutes} min",
  "onboarding.hub.meta_review": "plus Meta's review",
  "onboarding.hub.help_title": "Need help?",
  "onboarding.hub.help_text": "A Nuvvun specialist does this stage with you on a call.",
  "onboarding.hub.help_cta": "Talk to a specialist",
  "onboarding.hub.share_title": "Share the setup",
  "onboarding.hub.share_text": "Invite whoever handles WhatsApp or the team as an admin. They see this same panel.",
  "onboarding.hub.share_cta": "Invite to help",
  "onboarding.hub.end_title": "When you're done",
  "onboarding.hub.end_text": "The setup leaves the menu after go-live and stays in Settings › Account if you want to review it.",
  "onboarding.hub.go_live_ready": "Everything required is ready.",
  "onboarding.hub.live_since": "Live since {date}.",
  "onboarding.detail.connected": "{number} connected",
  "onboarding.detail.name_review": "name in review by Meta",
  "onboarding.detail.name_approved": "name approved",
  "onboarding.detail.name_declined": "name declined by Meta",
  "onboarding.detail.paid_by_partner": "Nuvvun pays Meta for you",
  "onboarding.detail.solo": "You'll attend alone for now",
  "onboarding.detail.invited": "1 person invited|{count} people invited",
  "onboarding.detail.teams": "1 team with people|{count} teams with people",
  "onboarding.detail.snippets": "1 canned reply|{count} canned replies",
  "onboarding.detail.tags": "1 tag|{count} tags",
  "onboarding.detail.templates_approved": "1 approved|{count} approved",
  "onboarding.detail.templates_pending": "1 in review by Meta|{count} in review by Meta",
  "onboarding.detail.from_questionnaire": "From the questionnaire",
  "onboarding.detail.suggestion_ready": "Suggestion ready",
  "onboarding.detail.entry_menu": "Welcome menu published",
  "onboarding.detail.entry_team": "Straight to the team",
  "onboarding.detail.entry_assistant": "AI assistant on first contact",
  "onboarding.detail.tour_pending": "1 person hasn't seen it|{count} people haven't seen it",
  "onboarding.welcome.eyebrow": "Welcome",
  "onboarding.welcome.title": "Hi, {name}. Let's get DoneTalk ready for {company}.",
  "onboarding.welcome.lead": "In 7 short stages you connect WhatsApp, build the team and run a test conversation from your phone. Stop and resume whenever you like: the setup stays in the menu until go-live.",
  "onboarding.q.title": "Tell us a bit about {company}",
  "onboarding.q.lead": "It takes 2 minutes. From the answers, DoneTalk suggests teams, outcomes, canned replies and the welcome message. You review everything before applying it.",
  "onboarding.q.purposes": "What will you do over WhatsApp?",
  "onboarding.purpose.sell": "Sell",
  "onboarding.purpose.support": "Serve customers",
  "onboarding.purpose.tech_support": "Tech support",
  "onboarding.purpose.billing": "Billing",
  "onboarding.purpose.scheduling": "Scheduling",
  "onboarding.q.segment": "Industry",
  "onboarding.segment.real_estate": "Real estate",
  "onboarding.segment.education": "Education",
  "onboarding.segment.health": "Health",
  "onboarding.segment.retail": "Retail",
  "onboarding.segment.services": "Services",
  "onboarding.segment.finance": "Finance",
  "onboarding.segment.automotive": "Automotive",
  "onboarding.segment.travel": "Travel",
  "onboarding.segment.other": "Other",
  "onboarding.q.team_size": "How many people will attend?",
  "onboarding.size.solo": "Just me",
  "onboarding.size.small": "2 to 5",
  "onboarding.size.medium": "6 to 20",
  "onboarding.size.large": "More than 20",
  "onboarding.q.hours": "Opening hours",
  "onboarding.q.hours_to": "to",
  "onboarding.q.add_hours": "Add hours",
  "onboarding.q.remove_hours": "Remove hours",
  "onboarding.q.website": "Company website (optional)",
  "onboarding.q.website_hint": "AI reads the site to suggest canned replies and the assistant's knowledge.",
  "onboarding.q.submit": "Build my setup",
  "onboarding.q.skip": "Skip and see the list of steps",
  "onboarding.q.refining": "Tailoring the suggestions to {company}…",
  "onboarding.page.eyebrow": "Setup · stage {n} of 7",
  "onboarding.page.key_moment": "key moment",
  "onboarding.page.ready_when": "Done when",
  "onboarding.page.back": "Back to setup",
  "onboarding.page.faq": "Common questions",
  "onboarding.page.minutes": "about {minutes} minutes",
  "onboarding.page.close_guide": "Close the guide",
  "onboarding.org.title": "Organize customer service",
  "onboarding.org.lead": "These suggestions come from the questionnaire. Review, adjust and apply; nothing changes before that.",
  "onboarding.org.badge_ai": "AI suggestions",
  "onboarding.org.badge_presets": "Suggestions for your industry",
  "onboarding.org.outcomes_hint": "Every conversation ends with one. They feed reports and learning.",
  "onboarding.org.add_outcome": "Add outcome",
  "onboarding.org.outcome_label": "Outcome name",
  "onboarding.org.snippets_hint": "In the composer, type / and the shortcut. The variables become the contact's and the attendant's names.",
  "onboarding.org.tags_hint": "To mark contacts and conversations and filter later.",
  "onboarding.org.add_tag": "Add",
  "onboarding.org.tag_name": "New tag",
  "onboarding.org.autoclose_hint": "No conversation stays open by mistake.",
  "onboarding.org.autoclose_rule": "No reply from the contact for {days} days: close as “{outcome}”",
  "onboarding.org.window_rule": "24-hour window expired: move to “Waiting for contact”",
  "onboarding.org.selected": "1 suggestion selected. You can edit everything in Settings later.|{count} suggestions selected. You can edit everything in Settings later.",
  "onboarding.org.later": "Review later",
  "onboarding.org.apply": "Apply and continue",
  "onboarding.org.applied": "Applied. Everything stays in Settings to edit.",
  "onboarding.org.guide_title": "How conversations end",
  "onboarding.org.guide_text": "Outcomes are the heart of DoneTalk: they tell what worked and what didn't. Mark as success the ones that count as results.",
  "onboarding.org.why_title": "Why this is its own page",
  "onboarding.org.why_text": "It gathers four settings that live on different screens. After applying, each one shows in its place in Settings.",
  "onboarding.org.ready_text": "Outcomes reviewed. The rest is recommended.",
  "onboarding.org.none": "Answer the questionnaire to get suggestions.",
  "onboarding.entry.title": "How conversations start",
  "onboarding.entry.lead": "Choose what customers get when they send the first message.",
  "onboarding.entry.suggested": "Suggested",
  "onboarding.entry.mode.menu": "Welcome menu",
  "onboarding.entry.mode.menu_text": "Customers pick a subject and land in the right queue.",
  "onboarding.entry.mode.assistant": "AI assistant",
  "onboarding.entry.mode.assistant_text": "Answers with the company's knowledge and calls the team when needed.",
  "onboarding.entry.mode.team": "Straight to the team",
  "onboarding.entry.mode.team_text": "No automation: the message joins the queue and someone replies.",
  "onboarding.entry.message": "Welcome message",
  "onboarding.entry.options": "Options and where each goes",
  "onboarding.entry.option": "Option {n}",
  "onboarding.entry.add_option": "Add option",
  "onboarding.entry.remove_option": "Remove option",
  "onboarding.entry.options_hint": "Up to 3 options show as buttons on WhatsApp; 4 to 10, as a list.",
  "onboarding.entry.team": "Receiving team",
  "onboarding.entry.after_hours": "After hours",
  "onboarding.entry.after_hours_hint": "Sent before the menu when someone writes after hours. Leave it blank to send nothing.",
  "onboarding.entry.assistant_pick": "Assistant",
  "onboarding.entry.no_assistant": "No published assistant yet. Create one in Settings › AI assistants and come back.",
  "onboarding.entry.open_assistants": "Open assistants",
  "onboarding.entry.behind": "Behind the scenes this becomes a published flow; you can open it in the builder any time.",
  "onboarding.entry.open_builder": "Open in the builder",
  "onboarding.entry.publish": "Publish",
  "onboarding.entry.published": "Published. The next conversations start this way.",
  "onboarding.entry.no_teams": "Create the teams in the Team stage before setting up the first contact.",
  "onboarding.entry.open_team": "Open teams",
  "onboarding.entry.preview": "What the customer sees",
  "onboarding.entry.preview_hi": "Hi",
  "onboarding.entry.list_button": "See options",
  "onboarding.entry.guide_title": "The first impression",
  "onboarding.entry.guide_text": "The menu sorts subjects before anyone picks up, and each conversation lands in the right queue.",
  "onboarding.entry.ai_title": "Want the AI assistant?",
  "onboarding.entry.ai_text": "You can start with the menu and turn the assistant on later, with the knowledge base ready.",
  "onboarding.entry.ready_text": "The first contact published. The after-hours message is recommended.",
  "onboarding.rehearsal.title": "Full rehearsal",
  "onboarding.rehearsal.lead": "Walk your customer's path with your phone. You see every piece working: number, welcome, queue, reply and outcome.",
  "onboarding.rehearsal.start": "Start the rehearsal",
  "onboarding.rehearsal.restart": "Restart the rehearsal",
  "onboarding.rehearsal.send_title": "Send “Hi” to {company}",
  "onboarding.rehearsal.send_text": "Point your phone's camera at the code or open the link on your phone. The message already carries the test code.",
  "onboarding.rehearsal.open_whatsapp": "Open in WhatsApp",
  "onboarding.rehearsal.test_note": "This conversation is marked as a test and stays out of the reports.",
  "onboarding.rehearsal.live_title": "Follow it live",
  "onboarding.rehearsal.s.received": "Message received",
  "onboarding.rehearsal.s.received_text": "With the test code, from your phone",
  "onboarding.rehearsal.s.automated": "Welcome sent",
  "onboarding.rehearsal.s.automated_text": "The published first contact replied",
  "onboarding.rehearsal.s.queued": "Joined the queue",
  "onboarding.rehearsal.s.queued_text": "The conversation reached a team",
  "onboarding.rehearsal.s.taken": "Take the conversation and reply",
  "onboarding.rehearsal.s.taken_text": "As anyone on the team would",
  "onboarding.rehearsal.s.closed": "Close with an outcome",
  "onboarding.rehearsal.s.closed_text": "Choose how the conversation ended",
  "onboarding.rehearsal.s.monitor": "See it on the live monitor",
  "onboarding.rehearsal.s.monitor_text": "The queue and response time show in Reports › Live",
  "onboarding.rehearsal.open_inbox": "Open in the inbox",
  "onboarding.rehearsal.open_monitor": "Open the monitor",
  "onboarding.rehearsal.blocked": "There was already an open conversation with that phone, and the test needs a new one. Close the open conversation and send the message again.",
  "onboarding.rehearsal.open_blocked": "Open that conversation",
  "onboarding.rehearsal.done": "Rehearsal done in {minutes} min, with the outcome “{outcome}”.",
  "onboarding.rehearsal.no_number": "Connect the number in the WhatsApp stage to run the rehearsal.",
  "onboarding.rehearsal.waiting": "Waiting for your message…",
  "onboarding.live.title_done": "{company} is live",
  "onboarding.live.lead_done": "The team can attend now, and the short tour shows to each person on first access.",
  "onboarding.live.title_ready": "Ready to go live",
  "onboarding.live.lead_ready": "Everything required is ready. When you go live, the setup leaves the menu and the short tour shows to each team member on first access.",
  "onboarding.live.title_pending": "A few steps left",
  "onboarding.live.lead_pending": "Finish the required steps to unlock go-live.",
  "onboarding.live.cta": "Go live",
  "onboarding.live.resend_tour": "Send the tour to the team again",
  "onboarding.live.tour_resent": "The tour will show to the team again.",
  "onboarding.live.open_inbox": "Open the inbox",
  "onboarding.live.not_set": "Not set",
  "onboarding.live.beyond": "Go further",
  "onboarding.live.beyond.review.title": "Message review",
  "onboarding.live.beyond.review.text": "AI reviews what the team sends in shadow mode, blocking nothing, so you can tune the rules.",
  "onboarding.live.beyond.import.title": "Import contacts",
  "onboarding.live.beyond.import.text": "Bring your base from a spreadsheet, with each contact's consent.",
  "onboarding.live.beyond.integrations.title": "Integrations",
  "onboarding.live.beyond.integrations.text": "Forms, CRM and API: leads come in straight as conversations.",
  "onboarding.live.beyond.reports.title": "Reports and monitor",
  "onboarding.live.beyond.reports.text": "Queues, response times and outcomes, live and by period.",
  "onboarding.live.beyond.learning.title": "Weekly learning",
  "onboarding.live.beyond.learning.text": "Every Monday, suggestions drawn from the conversations that worked.",
  "onboarding.guide.whatsapp.title": "Connect the company's WhatsApp",
  "onboarding.guide.whatsapp.text": "It's the official number your customers will see. The connection uses Meta's official API, and everything it receives shows up in the conversations.",
  "onboarding.guide.whatsapp.q1": "Can I use the number that's already on WhatsApp?",
  "onboarding.guide.whatsapp.a1": "Yes. With the account deleted in the app, it moves fully to DoneTalk; or, if you prefer, keep the WhatsApp Business app alongside with the coexistence option.",
  "onboarding.guide.whatsapp.a1_soon": "Yes, after deleting its account in the app. Keeping the WhatsApp Business app alongside is coming soon.",
  "onboarding.guide.whatsapp.q2": "How much does it cost?",
  "onboarding.guide.whatsapp.a2": "Meta charges per delivered message, on the card on file with Meta: templates always, at their category's rate (marketing, utility or authentication). From October 1, 2026, replies within 24 hours are charged too, after the month's 1,000 free ones per number. People who come from a click-to-WhatsApp ad get 72 free hours. Each message's cost shows in Message info, in the reports and in Settings › Costs and limits.",
  "onboarding.guide.whatsapp.a2_partner": "Nuvvun pays Meta for the templates sent and bills it in your plan. Replies within 24 hours of the customer's message are free.",
  "onboarding.guide.whatsapp.q3": "The name wasn't approved. Now what?",
  "onboarding.guide.whatsapp.a3": "We tell you here, on the number's card. Send another name through WhatsApp Manager following Meta's rules: the name must relate to the company.",
  "onboarding.guide.payment_title": "Payment method at Meta",
  "onboarding.guide.payment_text": "Needed to send templates and, from October 1, 2026, for replies beyond the month's 1,000 free ones per number: without a card, Meta stops delivering them. Payment goes directly to Meta.",
  "onboarding.guide.payment_cta": "Open payments at Meta",
  "onboarding.guide.payment_partner": "Nuvvun pays Meta for you; no card needed.",
  "onboarding.guide.team.title": "Build the team",
  "onboarding.guide.team.text": "Each new conversation joins a queue and goes to whoever is online with the fewest open conversations.",
  "onboarding.guide.team.roles": "The roles",
  "onboarding.guide.team.role_operator": "Attendant: replies to the conversations of their teams.",
  "onboarding.guide.team.role_manager": "Manager: on top of that, invites people, publishes flows and assistants and creates campaigns.",
  "onboarding.guide.team.role_admin": "Administrator: sets up everything, like you, including numbers, costs and integrations.",
  "onboarding.guide.team.suggested": "Teams suggested by the questionnaire",
  "onboarding.guide.team.create": "Create these teams",
  "onboarding.guide.team.created": "Teams created. Now add people to each one.",
  "onboarding.guide.team.solo": "I'll attend alone for now",
  "onboarding.guide.team.ready": "One invitation sent. Teams and hours are recommended.",
  "onboarding.guide.outbound.title": "Message customers first",
  "onboarding.guide.outbound.text": "To resume a stalled conversation or remind someone of a visit, Meta requires an approved template. Start with a follow-up and a reminder.",
  "onboarding.guide.outbound.categories": "Meta's categories",
  "onboarding.guide.outbound.utility": "Utility: notices about something the customer already asked for, like a reminder, confirmation or status.",
  "onboarding.guide.outbound.marketing": "Marketing: offers and follow-ups. It costs more per message, and Meta may change the category in review.",
  "onboarding.guide.outbound.suggested": "Suggested templates",
  "onboarding.guide.outbound.use": "Use this suggestion",
  "onboarding.guide.outbound.optout": "Opt-out",
  "onboarding.guide.outbound.optout_text": "Whoever writes one of the opt-out words (like STOP) no longer receives marketing templates. Check the words and, if you like, write a confirmation reply.",
  "onboarding.guide.outbound.optout_cta": "Open opt-out",
  "onboarding.guide.outbound.ready": "One approved template. You can go live without it and come back later.",
  "onboarding.guide.entry.title": "AI assistant",
  "onboarding.guide.entry.text": "Answers with the company's knowledge and calls the team when needed. Publish it here, then choose it in the First contact stage.",
  "onboarding.guide.entry.ready": "Published, with knowledge. It's optional.",
  "tour.step": "{n} of {total}",
  "tour.skip": "Skip tour",
  "tour.next": "Next",
  "tour.done": "Start attending",
  "tour.1.title": "Take a conversation from the queue",
  "tour.1.text": "New conversations from your teams show here. Open one and tap “Take” to keep it.",
  "tour.2.title": "Reply as on WhatsApp",
  "tour.2.text": "Write as usual. Type / to use a canned reply with the customer's name filled in.",
  "tour.3.title": "Transfer with a note",
  "tour.3.text": "If another person or team should continue, transfer and leave a note with what was done.",
  "tour.4.title": "Close with an outcome",
  "tour.4.text": "When you finish, choose how the conversation ended. That feeds the reports and learning.",
  "platform.customer.onboarding": "Setup",
  "platform.customer.onboarding_live": "Live since {date}",
  "platform.customer.onboarding_progress": "{done} of {total} stages · now: {stage}",
  "platform.customer.onboarding_pending": "Pending: {steps}",
  "platform.customer.onboarding_none": "Not started yet",
  "permissions.open": "Permissions",
  "permissions.title": "{name}'s permissions",
  "permissions.lead": "Each permission follows the role ({role}) or applies to this person only: allowed or denied.",
  "permissions.readonly": "You can only change the permissions of people below your role.",
  "permissions.role_yes": "Role: yes",
  "permissions.role_no": "Role: no",
  "permissions.allow": "Allow",
  "permissions.deny": "Deny",
  "permissions.exceptions": "1 exception to the role|{count} exceptions to the role",
  "permissions.group.conversations": "Conversations",
  "permissions.group.contacts": "Contacts",
  "permissions.group.flows": "Flows",
  "permissions.group.assistants": "AI assistants",
  "permissions.group.members": "Team",
  "permissions.group.channels": "Numbers and templates",
  "permissions.group.policies": "Policies",
  "permissions.group.other": "Other",
  "permission.conversations.read": "See conversations",
  "permission.conversations.write": "Reply",
  "permission.conversations.assign": "Assign to someone",
  "permission.conversations.transfer": "Transfer and hand back",
  "permission.conversations.close": "Close with an outcome",
  "permission.conversations.send_template": "Send templates (outbound)",
  "permission.contacts.read": "See contacts",
  "permission.contacts.write": "Edit and import contacts",
  "permission.contacts.export": "Export contacts",
  "permission.flows.read": "See flows",
  "permission.flows.write": "Edit flows",
  "permission.flows.publish": "Publish flows",
  "permission.assistants.read": "See assistants",
  "permission.assistants.write": "Edit assistants",
  "permission.assistants.publish": "Publish assistants",
  "permission.members.read": "See the team",
  "permission.members.manage": "Invite and manage people",
  "permission.channels.read": "See numbers and templates",
  "permission.channels.manage": "Connect numbers and create templates",
  "permission.policies.read": "See policies",
  "permission.policies.manage": "Edit policies",
  "permission.reports.read": "See reports and the monitor",
  "permission.audit.read": "See the audit log",
  "permission.settings.manage": "Change company settings",
  "permission.api.use": "Use the API",
  "errors.permission_above_own_level": "You can't grant a permission you don't have yourself.",
  "errors.member_above_own_level": "That person is at your level or above.",
  "errors.cannot_modify_self": "You can't change your own permissions.",
  "nav.main": "Main navigation",
  "common.search": "Search",
  "composer.poll.title": "Create poll",
  "composer.poll.question": "Question",
  "composer.poll.question_placeholder": "Ask a question",
  "composer.poll.options": "Options",
  "composer.poll.option": "Option {n}",
  "composer.poll.option_placeholder": "Add text",
  "composer.poll.move_up": "Move option {n} up",
  "composer.poll.remove": "Remove option {n}",
  "composer.poll.add": "Add option",
  "composer.poll.multiple": "Allow multiple answers",
  "composer.poll.anonymous": "Hide voters' names",
  "composer.poll.end": "Set an end time",
  "composer.poll.ends_at": "Ends at",
  "composer.event.title": "Create event",
  "composer.event.name": "Event name",
  "composer.event.name_placeholder": "E.g. Project chat",
  "composer.event.when": "Date and time",
  "composer.event.description": "Description",
  "composer.event.description_placeholder": "Add more details",
  "composer.event.call_link": "WhatsApp call link",
  "composer.contact.title": "Share contact",
  "composer.contact.demo_hint": "Pick a demo contact.",
  "composer.contact.pick": "Contact to share",
  "composer.contact.share": "Share",
  "composer.contact.message": "Contact: {name}",
  "emoji.pick_reaction": "Choose a reaction",
  "emoji.panel": "Emojis, GIFs and stickers",
  "emoji.back_to_quick": "Back to quick reactions",
  "emoji.close": "Close expressions",
  "emoji.search_reaction": "Search reaction",
  "emoji.search_emoji": "Search emoji",
  "emoji.search_gif": "Search GIFs",
  "emoji.search_sticker": "Search stickers",
  "emoji.category.smileys": "Smileys and people",
  "emoji.category.animals": "Animals and nature",
  "emoji.category.food": "Food and drink",
  "emoji.category.activities": "Activities",
  "emoji.category.travel": "Travel and places",
  "emoji.category.objects": "Objects",
  "emoji.category.symbols": "Symbols",
  "emoji.category.flags": "Flags",
  "message.select": "Select message {text}",
  "message.poll.pick_many": "Select one or more options",
  "message.poll.pick_one": "Select one option",
  "message.see_reactions": "See reactions",
  "message.react": "React to message",
  "reaction.quick": "Quick reactions",
  "reaction.with": "React with {emoji}",
  "reaction.more": "More emojis",
  "reaction.error.window": "The 24-hour window closed: WhatsApp only takes reactions while it is open.",
  "reaction.error.too_old": "WhatsApp only takes reactions on messages up to 30 days old.",
  "reaction.error.not_allowed": "WhatsApp doesn't take reactions on this message.",
  "reaction.error.failed": "Couldn't send the reaction.",
  "chat.unread": "1 unread message|{count} unread messages",
  "builder.default_option": "Option {n}",
  "builder.script_default": "// vars: the flow's variables; contact: the contact's name and fields\nreturn { result: vars.answer };",
  "snippets.body_placeholder": "Hi {{contact.first_name}}, this is {{member.first_name}} from {company}.",
  "message.poll.votes": "1 vote|{count} votes",
  "message.poll.anonymous": "Anonymous",
  "message.event.going": "Going",
  "message.event.join": "I'll join",
  "auth.forgot": "Forgot my password",
  "auth.forgot_help": "If the e-mail does not arrive, ask an admin of your company: in Settings › Team they can create a link for you to set a new password.",
  "auth.mfa.title": "Two-step verification",
  "auth.mfa.lead": "Enter the 6-digit code shown in the authenticator app on your phone.",
  "auth.mfa.recovery_lead": "No phone? Use one of the recovery codes you saved. Each works once.",
  "auth.mfa.code": "App code",
  "auth.mfa.recovery_code": "Recovery code",
  "auth.mfa.submit": "Confirm",
  "auth.mfa.use_recovery": "Use a recovery code",
  "auth.mfa.use_app": "Use the app code",
  "auth.mfa.back": "Sign in with another account",
  "account.title": "My account",
  "account.mfa.title": "Two-step verification",
  "account.mfa.on": "On",
  "account.mfa.off": "Off",
  "account.mfa.on_lead": "Since {since}, signing in asks for the authenticator app code after the password.",
  "account.mfa.off_lead": "Protect your account: after the password, signing in asks for a code from the authenticator app on your phone (Google Authenticator, Microsoft Authenticator or another).",
  "account.mfa.enable": "Turn on",
  "account.mfa.disable": "Turn off",
  "account.mfa.disabled": "Two-step verification turned off.",
  "account.mfa.regenerate": "New recovery codes",
  "account.mfa.codes_left": "1 recovery code left|{count} recovery codes left",
  "account.mfa.code_or_recovery": "App code or recovery code",
  "account.mfa.setup_title": "Turn on two-step verification",
  "account.mfa.setup_step1": "Install an authenticator app on your phone, if you don't have one.",
  "account.mfa.setup_step2": "In the app, add an account and scan this QR code.",
  "account.mfa.setup_step3": "Enter the 6-digit code the app shows.",
  "account.mfa.qr_label": "QR code for the authenticator app",
  "account.mfa.manual": "Can't scan it? Type this key in the app:",
  "account.mfa.confirm": "Confirm and turn on",
  "account.mfa.codes_title": "Save your recovery codes",
  "account.mfa.codes_lead": "If you lose your phone, each code opens your account once. They won't show again: copy or download them and keep them somewhere safe.",
  "account.mfa.copy": "Copy",
  "account.mfa.download": "Download",
  "account.mfa.done": "I saved them",
  "account.mfa.codes_copied": "Codes copied.",
  "account.mfa.codes_file_title": "DoneTalk recovery codes · {email}",
  "account.mfa.codes_hint": "Each code works once, in place of the app code.",
  "account.password.title": "Password",
  "account.password.change": "Change password",
  "account.password.current": "Current password",
  "account.password.new": "New password",
  "account.password.confirm": "Repeat the new password",
  "account.password.hint": "At least 10 characters, with letters and numbers.",
  "account.password.save": "Save password",
  "account.password.changed": "Password changed. Your other open sessions were signed out.",
  "account.password.mismatch": "The two new passwords don't match.",
  "reset.title": "Set a new password",
  "reset.save": "Save password",
  "reset.done": "Password set. Sign in with it.",
  "reset.mfa_stays": "Two-step verification stays on.",
  "reset.to_login": "Go to sign in",
  "team.reset_link": "New password link",
  "team.reset_link_title": "Link for {name} to set a new password",
  "team.reset_link_lead": "Send this link only to that person. It works once, until {until}, and signs out their open sessions.",
  "team.reset_link_copy": "Copy link",
  "team.reset_link_copied": "Link copied.",
  "errors.too_many_attempts": "Too many attempts. Wait a few minutes and try again.",
  "errors.mfa_code_invalid": "Wrong code. Check the app and enter the current code.",
  "errors.mfa_code_used": "That code was already used. Wait for the next one in the app.",
  "errors.mfa_challenge_expired": "Time for the code ran out. Sign in with your password again.",
  "errors.mfa_already_enabled": "Two-step verification is already on.",
  "errors.mfa_not_enabled": "Two-step verification is not on.",
  "errors.mfa_not_set_up": "Start again to get a QR code.",
  "errors.current_password_wrong": "The current password is wrong.",
  "errors.password_reset_invalid": "This link no longer works: it was used or is over 24 hours old. Ask the admin for a new one.",
  "errors.password_reset_needs_support": "This person also uses the platform at another company. For security, only Nuvvun's support can issue the new password.",
  "errors.invite_not_found": "This invite no longer exists. Ask whoever invited you for a new one.",
  "errors.invite_expired": "This invite expired. Ask whoever invited you for a new one.",
  "errors.already_member": "You are already a member of this customer: open the workspace directly.",
  "errors.member_not_found": "That person is no longer on the team.",
  "errors.user_blocked": "This access is blocked.",
  "errors.session_invalid": "Your session ended. Sign in again.",
  "platform.access.mfa_reset": "Turn off two-step verification",
  "platform.access.mfa_title": "Turn off {name}'s two-step verification",
  "platform.access.mfa_lead": "Only for someone who lost their phone and recovery codes, after confirming who they are another way. Their open sessions end and they turn it on again in My account.",
  "platform.access.mfa_confirm": "Turn off",
  "platform.access.mfa_done": "{name}'s two-step verification is off.",
  "platform.access.password_lead": "The link works once, for 24 hours, and ends the person's open sessions. Send it only to them, after confirming who they are.",
  "platform.access.password_confirm": "Make link",
  "platform.access.reason": "Reason (kept in the audit log)",
  "platform.access.reason_placeholder": "E.g. asked on support WhatsApp, confirmed by a call",
  "errors.platform_super_required": "Only a platform super admin can do this for someone on Nuvvun's team.",
  "errors.user_not_found": "That person no longer exists.",
  "security.title": "Protect your account",
  "security.lead": "Managers, admins and owners need two-step verification: after the password, signing in asks for a code from the authenticator app on your phone. It takes a minute.",
  "security.leave": "Sign out ({email})",
  "errors.mfa_required": "Turn on two-step verification to go on.",
  "settings.privacy": "Data and privacy",
  "privacy.retention.title": "How long to keep",
  "privacy.retention.lead": "After the period, the content goes and the numbers stay: conversations remain in the reports, with times, outcomes and costs, without the messages, files and notes. The messages' period counts from when the conversation closed.",
  "privacy.retention.messages": "Messages",
  "privacy.retention.media": "Photos, audio, video and documents",
  "privacy.retention.audit": "Audit log",
  "privacy.retention.technical": "Technical copies (Meta's raw webhooks, webhook deliveries and knowledge searches) stay 30 to 90 days. The audit log keeps at least 6 months, as Brazil's Marco Civil requires.",
  "privacy.retention.last_run": "Last cleanup: {when} · {conversations} conversations and {files} files",
  "privacy.keep.forever": "Keep forever",
  "privacy.keep.years": "1 year|{count} years",
  "privacy.keep.days": "1 day|{count} days",
  "privacy.export.title": "Full export",
  "privacy.export.lead": "A ZIP file with all the company's data: contacts, conversations with their messages, team, templates, flows, assistants, knowledge base and audit log. It stays available for 7 days. Passwords and keys never go in it.",
  "privacy.export.media": "Include photos, audio, video and documents",
  "privacy.export.request": "Create export",
  "privacy.export.requested": "Export requested. It shows here when it is ready.",
  "privacy.export.with_media": "with files",
  "privacy.export.until": "available until {when}",
  "privacy.export.download": "Download",
  "privacy.export.status.queued": "Queued",
  "privacy.export.status.running": "Creating",
  "privacy.export.status.ready": "Ready",
  "privacy.export.status.failed": "Failed",
  "privacy.export.status.expired": "Expired",
  "privacy.subjects.title": "Data subject requests",
  "privacy.subjects.lead": "To answer someone asking for a copy of their data or its erasure, open the contact: Export data and Erase data are at the end of the panel.",
  "contact.privacy": "Privacy",
  "contact.export_data": "Export this contact's data",
  "contact.erase.open": "Erase this contact's data",
  "contact.erase.title": "Erase {name}'s data",
  "contact.erase.lead": "Use it when the person asks for their data to be erased. It cannot be undone.",
  "contact.erase.goes": "Goes: name, number, fields, tags, every message, file and note.",
  "contact.erase.stays": "Stays: the conversations in the reports, with nothing that identifies the person.",
  "contact.erase.confirm": "The person asked, and I understand it cannot be undone",
  "contact.erase.submit": "Erase data",
  "contact.erase.done": "Contact's data erased.",
  "message.purged": "Content removed by the privacy policy",
  "errors.contact_has_open_conversation": "Close this contact's open conversation before erasing the data.",
  "errors.contact_not_found": "That contact no longer exists.",
  "errors.export_in_progress": "An export is already being created. Wait for it to finish.",
  "errors.export_not_ready": "That export is not ready yet or has expired.",
  "errors.export_not_found": "That export no longer exists.",
  "errors.export_too_large": "The export went over 2 GB. Create it without the files or contact support.",
  "numbers.app.title": "WhatsApp Business on the phone",
  "numbers.app.lead": "The number stays on the phone app. What is sent there shows here, and Meta copies the contacts and the last 180 days of chats once, if the business agreed in the app.",
  "numbers.app.contacts": "Address book contacts",
  "numbers.app.history": "Earlier chats",
  "numbers.app.not_requested": "Not requested yet",
  "numbers.app.requested": "Requested from Meta, arriving",
  "numbers.app.running": "Copying: {progress}%",
  "numbers.app.contacts_done": "1 contact received|{count} contacts received",
  "numbers.app.history_done": "Done · 1 message|Done · {count} messages",
  "numbers.app.declined": "The business did not share its history in the app",
  "numbers.app.failed": "Meta did not accept the request",
  "numbers.app.retry": "Ask again",
  "errors.app_sync_expired": "Meta only hands over the app's copy in the first 24 hours after connecting. To get it again, disconnect in the app and connect once more.",
  "errors.not_coexistence": "That number is not on the WhatsApp Business app.",
  "message.deleted_text": "Message deleted",
  "message.from_phone": "Sent from the phone",
  "contact.history_app": "WhatsApp Business history",
  "deletion.title": "Data deletion request",
  "deletion.received": "We received your request (code {code}) on {when}.",
  "deletion.done": "Done: DoneTalk keeps no data from your Facebook profile. Connecting a number leaves the company with access to its own WhatsApp Business account only.",
  "deletion.business": "WhatsApp conversations belong to the company that serves you. To ask for their deletion, contact the company; to disconnect a number, it uses Settings › Numbers or Meta's WhatsApp Manager.",
  "deletion.not_found": "We found no request with code {code}.",
  "errors.deletion_request_not_found": "Request not found.",
  "crm.note.title": "WhatsApp conversation",
  "crm.note.outcome": "Outcome: {outcome}",
  "crm.note.attendant": "Agent: {name}",
  "crm.note.team": "Team: {name}",
  "crm.note.goal": "Goal: {goal}",
  "crm.note.summary": "Summary",
  "crm.note.messages": "Messages: {inbound} from the contact, {outbound} from the business",
  "crm.note.open": "Open the conversation in DoneTalk",
  "crm.title": "CRM",
  "crm.lead": "Connect OutboundPro or Pipedrive: each closed conversation becomes a note on the person (and on their open deal), and the contact panel shows their open deals.",
  "crm.kind.outboundpro": "OutboundPro",
  "crm.kind.pipedrive": "Pipedrive",
  "crm.provider": "CRM",
  "crm.token": "API token",
  "crm.token_hint.outboundpro": "In OutboundPro, under Settings › API and tokens.",
  "crm.token_hint.pipedrive": "In Pipedrive, under Personal preferences › API.",
  "crm.token_kept": "Token saved. Leave blank to keep the current one.",
  "crm.base_url": "API address",
  "crm.create_persons": "Create the person in the CRM when the number is not there",
  "crm.log_conversations": "Log each closed conversation as a note",
  "crm.deal_outcome": "A success outcome marks the open deal won; a negative one, lost",
  "crm.connect": "Connect",
  "crm.save": "Save",
  "crm.remove": "Disconnect",
  "crm.connected_as": "Connected as {user}",
  "crm.status.active": "Active",
  "crm.status.error": "Failing",
  "crm.tasks": "{done} conversations logged last week · {pending} queued",
  "crm.dead": "1 conversation could not be logged|{count} conversations could not be logged",
  "crm.last_error": "Last error: {error}",
  "crm.saved": "CRM connected.",
  "crm.removed": "CRM disconnected.",
  "crm.card.title": "In {crm}",
  "crm.card.none": "That number is not in {crm} yet.",
  "crm.card.create": "Create person in {crm}",
  "crm.card.deals": "Open deals",
  "crm.card.no_deals": "No open deals.",
  "crm.card.open": "Open in {crm}",
  "crm.card.error": "Could not reach {crm} right now.",
  "errors.crm_token_rejected": "The CRM refused that token. Check you copied all of it and that it is still valid.",
  "errors.crm_unreachable": "Could not reach the CRM. Check the address and try again.",
  "errors.crm_address_refused": "That address cannot be used.",
  "errors.crm_error": "The CRM answered with an error.",
  "errors.connector_not_found": "That connector no longer exists.",
  "templates.header.kind": "Header type",
  "templates.header.text": "Text",
  "templates.header.image": "Image",
  "templates.header.video": "Video",
  "templates.header.document": "Document",
  "templates.header.sample_none": "No sample file",
  "templates.header.sample_kept": "Sample file saved",
  "templates.header.sample_choose": "Choose file",
  "templates.header.sample_hint_image": "JPG or PNG up to 5 MB. Meta reviews with the sample; each send carries the image you choose.",
  "templates.header.sample_hint_video": "MP4 up to 16 MB. Meta reviews with the sample; each send carries the video you choose.",
  "templates.header.sample_hint_document": "PDF up to 100 MB. Meta reviews with the sample; each send carries the document you choose.",
  "templates.issue.header_media_sample_missing": "Choose a sample file: Meta needs it to review.",
  "templates.issue.header_media_type": "That file type does not fit this header.",
  "templates.issue.header_media_too_large": "The file is over this type's limit.",
  "templates.issue.header_conflict": "The header is text or media, not both.",
  "template.header_file": "Header file",
  "template.header_file_hint": "This template starts with {kind}: choose the file for this send.",
  "template.header_file_choose": "Choose file",
  "errors.template_sample_missing": "The header's sample file is gone. Choose it again before sending to Meta.",
  "errors.header_media_required": "Choose this template's header file.",
  "platform.customer.billing_unavailable": "The partner credit line becomes available once the solution with a Meta Solution Partner is registered.",
  "platform.customer.billing_stale": "This customer is set to the partner credit line, but no solution is registered: Meta still asks for their card. Save to switch back to the customer's card.",
  "errors.meta_solution_missing": "Register the solution with the Meta Solution Partner before using the partner credit line.",
  "contact.ai_cost": "AI cost",
  "contact.ai_cost_hint": "AI calls made for this conversation (assistant, summaries and message review), in dollars, as the providers charge.",
  "tags.color.blue": "Blue",
  "tags.color.green": "Green",
  "tags.color.yellow": "Yellow",
  "tags.color.red": "Red",
  "tags.color.purple": "Purple",
  "tags.color.light_gray": "Light gray",
  "tags.color.brown": "Brown",
  "tags.color.orange": "Orange",
  "tags.color.dark_gray": "Dark gray",
  "tags.color.pink": "Pink",
  "tags.color.custom": "Other color",
  "onboarding.org.add_snippet": "Add reply",
  "onboarding.org.snippet_shortcut": "shortcut",
  "onboarding.org.snippet_body": "Reply text",
  "integrations.event.contact.consent_changed": "Consent changed",
  "integrations.event.message.delivered": "Message delivered",
  "integrations.event.message.read": "Message read",
  "integrations.event.message.failed": "Message failed",
  "errors.integration_template_only": "Through the API only approved templates can be sent. Text and files are sent by people and go through the message review.",
  "errors.members_only": "Only a person on the team can do this, not an API key.",
  "event.gate_held_assistant": "The message review held a reply from the assistant and handed the conversation to a person: “{draft}”",
  "event.gate_held_flow": "The message review held a message from the flow and handed the conversation to a person: “{draft}”",
  "inbox.gate_logged": "Sent. The message review flagged this message for the manager.",
  "policy.gate.shadow_of": "Mode being calibrated",
  "policy.gate.shadow_hint": "In shadow, messages go out as written and nobody sees anything. The review notes what the chosen mode would have done; the numbers are in Reports › Message review.",
  "reports.gate.action.held": "Held and handed to a person",
  "reports.gate.action.shadowed": "Checked in shadow",
  "reports.gate.authors": "Who wrote it",
  "reports.gate.author.member": "People",
  "reports.gate.author.assistant": "Assistant",
  "reports.gate.author.flow": "Flows",
  "reports.gate.shadow": "In shadow",
  "reports.gate.shadow_hint": "What the mode being calibrated would have done with the messages checked in shadow.",
  "reports.gate.simulated.pass": "Would have sent it as written",
  "reports.gate.simulated.rewrite": "Would have sent it corrected",
  "reports.gate.simulated.review": "Would have asked for review",
  "reports.gate.simulated.block": "Would have blocked it",
  "weekday.short.sun": "Sun",
  "weekday.short.mon": "Mon",
  "weekday.short.tue": "Tue",
  "weekday.short.wed": "Wed",
  "weekday.short.thu": "Thu",
  "weekday.short.fri": "Fri",
  "weekday.short.sat": "Sat",
  "node.template": "Send template",
  "node.field.template": "Approved template",
  "node.template.none": "No approved template yet. Create one and send it to Meta in Settings › Message templates.",
  "node.template.variable": "Value for {{{name}}}",
  "node.template.header_link": "Public link to the header file",
  "node.template.button": "End of button {n}'s link",
  "node.template.hint": "Templates can be sent even after the 24 hours. Use {{contact.name}} or {{vars.x}} in the values.",
  "node.wait.mode": "Wait",
  "node.wait.mode.seconds": "For a while",
  "node.wait.mode.until": "Until a date and time",
  "node.wait.mode.at": "Until a time of day",
  "node.wait.amount": "How long",
  "node.wait.unit": "Unit",
  "node.wait.unit.minutes": "minutes",
  "node.wait.unit.hours": "hours",
  "node.wait.unit.days": "days",
  "node.wait.until": "Date and time",
  "node.wait.until_hint": "A variable holding the date, such as {{vars.visit_date}} or {{contact.fields.callback}}. Accepts 02/10/2026 15:30, a date alone (at 9am) or ISO. A date already past goes on at once.",
  "node.wait.at": "Time",
  "node.wait.weekdays": "Days of the week",
  "node.wait.time_zone": "Time zone",
  "builder.exit_invalid_date": "Invalid date",
  "builder.wait_until_summary": "until {when}",
  "builder.wait_at_summary": "until {time}",
  "builder.wait_at_days_summary": "until {time} · {days}",
  "builder.wait_minutes": "{n} min",
  "builder.wait_hours": "{n} h",
  "builder.wait_days": "{n} days",
  "builder.flow_settings": "Flow settings",
  "builder.exception_target": "On an error, go to",
  "builder.exception_none": "End the flow",
  "builder.inactivity_minutes": "Reply time limit (minutes)",
  "builder.timeout_target": "After the time limit, go to",
  "builder.timeout_end": "End the flow",
  "builder.inactivity_hint": "Applies to menus and questions: if the contact does not answer in time, the flow takes the chosen path. 0 turns it off.",
  "simulator.template": "Sends the template {name}",
  "simulator.assistant": "The assistant takes the conversation",
  "simulator.wait": "Waits until {until}",
  "simulator.transfer": "Hands over to a person",
  "simulator.close": "Closes with the outcome {outcome}",
  "simulator.vars": "Variables:",
  "simulator.no_vars": "none",
  "simulator.assistant_waiting": "Here the assistant would talk with the contact.",
  "simulator.assistant_done": "End the assistant and go on",
  "assistant.versions": "Published versions",
  "assistant.version": "Version {n}",
  "assistant.version_active": "In use",
  "assistant.restore": "Restore",
  "assistant.restored": "Version {from} is back in use as version {n}.",
  "context.from": "From {source}",
  "context.open": "Open in the system",
  "context.updated": "Updated {when}",
  "simulator.status.running": "running",
  "simulator.status.waiting": "waiting for the contact",
  "simulator.status.completed": "done",
  "simulator.status.failed": "stopped with an error",
  "simulator.status.handed_off": "with a person",
  "assistant.tool.transfer_to_human": "Hand over to a person",
  "assistant.tool.close_conversation": "Close with an outcome",
  "assistant.tool.set_contact_field": "Save a contact detail",
  "assistant.tool.end_assistant": "Return to the flow",
  "assistant.tool.start_flow": "Start a flow",
  "assistant.tool_hint.transfer_to_human": "When the contact asks for a person, is upset, or the request is beyond what the assistant can do.",
  "assistant.tool_hint.close_conversation": "When the goal was reached or the contact clearly declined.",
  "assistant.tool_hint.set_contact_field": "Keeps what the contact told (name, document, e-mail, preference).",
  "assistant.tool_hint.end_assistant": "Inside a flow: ends the assistant's part and the flow goes on.",
  "assistant.tool_hint.start_flow": "Calls a flow for a scripted task (booking, a form, a payment).",
  "assistant.start_flow_hint": "Published flows marked “The AI assistant can start this flow” (in the builder, under Triggers) are available.",
  "builder.assistant_tool": "The AI assistant can start this flow",
  "builder.assistant_tool_when": "When the assistant should use it",
  "builder.assistant_tool_placeholder": "E.g.: when the contact wants to book a visit",
  "contact.ad": "Ad",
  "reports.by_source": "By source",
  "reports.by_ad": "By ad",
  "reports.col.source": "Source",
  "reports.col.opened": "Opened",
  "reports.col.ad": "Ad",
  "email.greeting": "Hi {name},",
  "email.signature": "The DoneTalk team",
  "email.reset.subject": "Create a new password on DoneTalk",
  "email.reset.body": "We received a request to create a new password for your account. Use the button below to choose it.",
  "email.reset.button": "Create a new password",
  "email.reset.expires": "The link is valid for {count} hour and can be used once.|The link is valid for {count} hours and can be used once.",
  "email.reset.ignore": "If it was not you, ignore this e-mail: your password stays the same.",
  "email.invite.subject": "{inviter} invited you to {workspace} on DoneTalk",
  "email.invite.body": "{inviter} invited you to serve {workspace}'s customers on WhatsApp through DoneTalk. Accept the invitation and create your password.",
  "email.invite.button": "Accept the invitation",
  "email.invite.expires": "The invitation is valid for {count} day.|The invitation is valid for {count} days.",
  "auth.forgot_lead": "We send a link to the e-mail above. With it you create a new password.",
  "auth.forgot_send": "Send the link by e-mail",
  "auth.forgot_sent": "If there is an account for {email}, the link is on its way. It is valid for 1 hour.",
  "auth.forgot_email_first": "Type your e-mail above first.",
  "team.invite_emailed": "Invitation sent to {email}. The link below works too.",
  "inbox.view.mentions": "Mentions",
  "message.forward": "Forward",
  "message.pin": "Pin",
  "message.unpin": "Unpin",
  "message.remove": "Delete",
  "message.restore": "Restore message",
  "message.restored": "Message restored",
  "message.removed_by": "Deleted by {name} · {when}",
  "message.removed_show": "Show the deleted message",
  "message.removed_hide": "Hide the deleted message",
  "message.someone": "someone on the team",
  "message.pinned_label": "Pinned message",
  "pin.banner": "Go to the pinned message",
  "pin.done": "Message pinned for the team. The contact doesn't see it.",
  "pin.undone": "Message unpinned",
  "pin.not_loaded": "That pinned message is older than what is loaded in the conversation.",
  "selection.count": "1 item selected|{count} items selected",
  "selection.cancel": "Cancel selection",
  "remove.title": "Delete the message?|Delete {count} messages?",
  "remove.hint": "It disappears from this conversation for the team, with who deleted it and when on record. The contact still sees it on WhatsApp: Meta doesn't allow deleting it there.",
  "remove.confirm": "Delete",
  "remove.done": "Message deleted|{count} messages deleted",
  "forward.title": "Forward message|Forward {count} messages",
  "forward.search": "Search a conversation or a colleague",
  "forward.chats": "Conversations",
  "forward.chats_hint": "Open conversations inside the 24-hour window are listed: outside it, WhatsApp only takes templates.",
  "forward.no_chats": "No conversation has an open window right now.",
  "forward.team": "Team",
  "forward.team_hint": "Gets it in a note on this conversation",
  "forward.comment": "A note for your colleague (optional)",
  "forward.send": "Forward",
  "forward.done": "Forwarded to 1 recipient.|Forwarded to {count} recipients.",
  "forward.failed": "Not sent to {name}: {reason}.",
  "forward.reason.window": "the 24-hour window closed",
  "forward.reason.closed": "the conversation was closed",
  "forward.held": "Some messages were held by the message review and not sent.",
  "forward.received": "{name} forwarded messages to you. See Mentions.",
  "notes.forwarded_to": "Forwarded to {names}",
  "permission.conversations.view_hidden": "See deleted messages",
  "event.info.open": "Event details",
  "event.info.title": "Event details",
  "event.info.who": "Who",
  "event.info.when": "When",
  "event.info.from": "From",
  "event.info.to": "To",
  "event.info.reason": "Reason",
  "event.info.note": "Note",
  "event.info.until": "Until",
  "event.info.outcome": "Outcome",
  "event.info.queue": "Queue",
  "event.actor.contact": "The contact",
  "event.actor.flow": "Automated flow",
  "event.actor.assistant": "AI assistant",
  "event.actor.api": "Integration",
  "event.actor.policy": "Automatic rule",
  "event.actor.system": "DoneTalk (automatic)",
  "event.reason.first_reply": "Replied first",
  "event.reason.self": "Took the conversation",
  "event.reason.distribution": "Automatic distribution",
  "event.reason.manual": "Manual assignment",
  "event.reason.integration": "Integration",
  "event.reason.business_app_reply": "Replied from the WhatsApp Business app",
  "composer.voice_preview_pause": "Pause the playback",
  "inbox.row_options": "Options for the conversation with {name}",
  "permission.conversations.send_marketing": "Send a one-off marketing template",
  "permission.campaigns.read": "View campaigns",
  "permission.campaigns.write": "Create and edit campaigns",
  "permission.campaigns.start": "Start, pause and cancel campaigns",
  "permission.campaigns.approve": "Approve campaigns",
  "permission.costs.read": "View costs",
  "permission.costs.manage": "Change budgets and spending limits",
  "permissions.group.campaigns": "Campaigns",
  "permissions.group.costs": "Costs",
  "email.cost_alert.subject": "DoneTalk · {workspace}: {title}",
  "email.cost_alert.cta": "See the costs",
  "email.cost_alert.why": "You get this notice because you follow the company's costs in DoneTalk. Who receives it is set in Settings › Costs and limits.",
  "cost.scope.company": "The company",
  "cost.scope.team": "The {name} team",
  "cost.alert.budget_threshold.title": "{scope} went past {threshold}% of the month's budget",
  "cost.alert.budget_threshold.text": "{spent} of {amount} spent this month.",
  "cost.alert.forecast_over.title": "{scope} is on course to pass the budget on day {day}",
  "cost.alert.forecast_over.text": "At the current pace the month ends at {forecast} against a budget of {amount}.",
  "cost.alert.daily_spike.title": "Today's spend is {factor}× the usual",
  "cost.alert.daily_spike.text": "{spent} so far; the usual for this weekday is {usual}.",
  "cost.alert.category_changed.title": "A template changed category",
  "cost.alert.category_changed.text": "Meta moved “{name}” from {from} to {to}: each send costs more. It went out {volume} times in the last 30 days.",
  "cost.alert.campaign_costly.title": "Campaign expensive per reply",
  "cost.alert.campaign_costly.text": "“{name}” costs {perReply} per reply; the campaigns' average is {average}.",
  "errors.marketing_not_allowed": "You are not allowed to send marketing templates. Ask a manager.",
  "errors.budget_limit_reached": "The month's budget is used up: this send needs someone who approves campaigns.",
  "nav.campaigns": "Campaigns",
  "settings.costs": "Costs and limits",
  "reports.tab.costs": "Costs",
  "reports.period.last_month": "Last month",
  "reports.period.90d": "Last 90 days",
  "costs.view.overview": "Overview",
  "costs.view.meta": "Estimate × Meta",
  "costs.view.trends": "Trends and alerts",
  "costs.mixed_currencies": "Some numbers are billed in another currency: the values below add up only those billed in {currency}.",
  "costs.kpi.meta": "Meta cost",
  "costs.kpi.delta": "{delta}% vs the previous period",
  "costs.kpi.confirmed": "{value} confirmed by Meta",
  "costs.kpi.ai": "AI",
  "costs.kpi.ai_no_rate": "In dollars: today's rate has not arrived yet",
  "costs.kpi.per_conversation": "Per conversation",
  "costs.kpi.conversations": "1 conversation with replies|{count} conversations with replies",
  "costs.kpi.per_success": "Per sale",
  "costs.kpi.successes": "1 success outcome|{count} success outcomes",
  "costs.kpi.forecast": "Month forecast",
  "costs.kpi.forecast_hint": "{spent} in {day} of {days} days",
  "costs.daily": "Cost per day",
  "costs.previous_period": "Previous period",
  "costs.who": "What generated the cost",
  "costs.by.source": "Source",
  "costs.by.team": "Team",
  "costs.by.channel": "Number",
  "costs.by.member": "Person",
  "costs.source.campaign": "Campaigns",
  "costs.source.member": "People",
  "costs.source.flow": "Flows",
  "costs.source.assistant": "Assistant",
  "costs.source.api": "Integrations and API",
  "costs.source.system": "System",
  "costs.no_team": "No team",
  "costs.templates": "Templates that cost most",
  "costs.col.template": "Template",
  "costs.col.category": "Category",
  "costs.col.charged": "Charged",
  "costs.col.cost": "Cost",
  "costs.col.day": "Day",
  "costs.col.estimated": "Estimated at the time",
  "costs.col.meta": "Meta's value",
  "costs.col.difference": "Difference",
  "costs.col.status": "Status",
  "costs.projection.badge": "From October 1",
  "costs.projection.title": "Under the new pricing, replying would cost {value}",
  "costs.projection.text": "The period had {messages} service messages. {free} would be free ({numbers} numbers × 1,000 a month); {chargeable} would be charged.",
  "costs.top_conversations": "Most expensive conversations",
  "costs.period_note": "Costs by the day Meta charged them (delivery), {from} to {to}. Meta's confirmed value replaces the estimate the next day.",
  "costs.meta.days": "Day by day",
  "costs.meta.last_sync": "Meta checked at {at}",
  "costs.meta.never": "Meta has not been checked yet",
  "costs.meta.sync": "Check now",
  "costs.meta.synced": "Meta checked: 1 group confirmed|Meta checked: {count} groups confirmed",
  "costs.meta.sync_errors": "Meta did not answer for 1 account|Meta did not answer for {count} accounts",
  "costs.meta.status.confirmed": "Confirmed",
  "costs.meta.status.partial": "1 message without Meta's figure|{count} messages without Meta's figure",
  "costs.meta.status.estimated": "Estimated",
  "costs.meta.status.no_cost": "Meta does not report the value",
  "costs.meta.empty": "No charged messages in the period.",
  "costs.meta.how": "How the value arrives",
  "costs.meta.how_1": "At once: Meta says each delivered message's category and whether it was charged; DoneTalk prices it from the public rate card of the contact's market.",
  "costs.meta.how_2": "The next day: Meta's pricing report brings the value per day, number, country and category. It replaces the estimate and spreads the difference over the day's messages.",
  "costs.meta.how_3": "Monthly: Meta's invoice is the final reference. Volume discounts on utility and authentication only show here and on the invoice.",
  "costs.meta.credit_line": "If the company pays Meta through a partner's credit line, Meta does not report the value: the estimate stays.",
  "costs.meta.quota": "Free service messages this month",
  "costs.meta.quota_used": "{used} of {free}",
  "costs.meta.quota_over": "The {free} free ones are used up",
  "costs.meta.quota_hint": "Since October 1, 2026 each number has 1,000 free service messages a month, with no rollover. After that each reply is charged.",
  "costs.meta.tiers": "Volume tier",
  "costs.meta.tier_open": "from {from}",
  "costs.meta.tier_range": "{from} to {to}",
  "costs.meta.tiers_hint": "Meta discounts utility and authentication when the month's volume passes certain tiers, across all the company's Meta accounts.",
  "costs.trends.months": "Cost per month",
  "costs.trends.meta": "Meta",
  "costs.trends.ai": "AI",
  "costs.trends.forecast": "Forecast",
  "costs.trends.forecast_hint": "The month should end at {value} at the current pace ({day} of {days} days).",
  "costs.save.title": "Where to save",
  "costs.save.split_title": "Split replies cost.",
  "costs.save.split_text": "Each reply goes out in {perReply} messages on average. After the month's 1,000 free ones, joining them would save about {value} a month.",
  "costs.save.ads_title": "Click-to-WhatsApp ads:",
  "costs.save.ads_text": "the 72 hours after the ad are free, templates included. 1 conversation came from an ad in the last 30 days.|the 72 hours after the ad are free, templates included. {count} conversations came from ads in the last 30 days.",
  "costs.save.utility_title": "Utility costs 9× less than marketing.",
  "costs.save.utility_text": "Payment, order and appointment notices should be utility; Meta decides the category and may change it.",
  "costs.save.quota_title": "Each number has 1,000 free replies a month.",
  "costs.save.quota_text": "Track it in Estimate × Meta.",
  "costs.alerts.title": "Alerts",
  "costs.alerts.dismiss": "Dismiss alert",
  "costs.alerts.none": "No open alerts.",
  "costs.settings.lead": "Spending governance: how much each area may spend a month, who is warned and what happens at the limit. Everything goes to the audit trail.",
  "costs.settings.budgets": "Monthly budget · Meta + AI",
  "costs.settings.budgets_lead": "In reais, adding what Meta charged and AI at today's dollar. Without a budget, nothing is limited.",
  "costs.settings.spent": "{spent} of {amount}",
  "costs.settings.forecast": "Forecast: {value} at month end",
  "costs.settings.monthly": "Per month (R$)",
  "costs.settings.team": "Team",
  "costs.settings.add_team": "Add team",
  "costs.settings.campaign_budget": "Each campaign can have its own budget, set on it.",
  "costs.settings.saved": "Saved.",
  "costs.settings.limit": "When the budget reaches 100%",
  "costs.limit.notify": "Only warn",
  "costs.limit.notify_hint": "Nothing stops. Good to start and understand spend.",
  "costs.limit.pause_campaigns": "Pause campaigns and hold one-off marketing",
  "costs.limit.pause_campaigns_hint": "Campaigns pause; a one-off marketing template only goes out from someone who approves campaigns. Recommended.",
  "costs.limit.pause_paid": "Pause every paid send that is not a reply",
  "costs.limit.pause_paid_hint": "Campaigns, flows and one-off templates stop until someone who approves campaigns releases them.",
  "costs.settings.never_blocked": "Never stopped: replies inside a conversation and access codes. A customer who wrote is always answered.",
  "costs.settings.alerts": "Warnings",
  "costs.settings.who_hears": "Who receives them, besides the notice on the costs screen:",
  "costs.settings.email": "Also by e-mail",
  "costs.settings.approval": "Campaign approval",
  "costs.settings.approval_on": "Ask for approval before large campaigns",
  "costs.settings.approval_amount": "When the campaign may cost more than (R$)",
  "costs.settings.approval_audience": "Or goes to more than (people)",
  "costs.settings.approval_hint": "Approvers: people allowed to approve campaigns (owners and admins). The author never approves their own.",
  "costs.settings.frequency": "Marketing frequency",
  "costs.settings.frequency_days": "Days between marketing campaigns",
  "costs.settings.frequency_hint": "A contact who got a marketing campaign stays out of the next ones for this many days. 0 turns it off.",
  "costs.settings.who_spends": "Who can spend",
  "costs.settings.who_spends_hint": "Each role's default. Per-person exceptions are in Team › Permissions.",
  "costs.settings.insights": "Meta template insights",
  "costs.settings.insights_lead": "Turns on, at Meta, each template's spend, cost per delivery and button clicks. Meta does not allow turning it off again, and it does not work for European or Japanese accounts.",
  "costs.settings.insights_active": "On",
  "costs.settings.insights_enable": "Turn on insights",
  "costs.settings.insights_confirm_title": "Turn on template insights?",
  "costs.settings.insights_confirm": "Template insights for the account {name} will be turned on at Meta. This cannot be undone.",
  "costs.settings.insights_on": "Template insights turned on.",
  "contact.costs.title": "This conversation's cost",
  "contact.costs.bucket.marketing": "Marketing",
  "contact.costs.bucket.utility": "Utility",
  "contact.costs.bucket.authentication": "Authentication",
  "contact.costs.bucket.service": "Service",
  "contact.costs.bucket.other": "Other",
  "contact.costs.ai": "AI",
  "contact.costs.messages": "1 message|{count} messages",
  "contact.costs.messages_free": "1 message, {free} free|{count} messages, {free} free",
  "contact.costs.quota_over": "This number's 1,000 free service messages ran out on {day}. Until the month ends each reply is charged.",
  "contact.costs.contact_year": "This contact: 1 conversation in 12 months, {value}|This contact: {count} conversations in 12 months, {value}",
  "meta.pricing.free_quota": "Free · within this number's 1,000 service messages of the month",
  "meta.pricing.confirmed": "Confirmed by Meta on {day}",
  "segments.title": "Segments",
  "segments.new": "New segment",
  "segments.everyone_item": "All contacts",
  "segments.note": "A segment is a saved, named filter. Whoever starts meeting the conditions joins by itself; whoever stops, leaves.",
  "segments.save": "Save segment",
  "segments.update": "Update segment",
  "segments.delete": "Delete segment",
  "segments.saved": "Segment saved.",
  "segments.name": "Segment name",
  "segments.add_condition": "Condition",
  "segments.remove_condition": "Remove condition",
  "segments.field": "Field",
  "segments.condition": "Condition",
  "segments.value": "Value",
  "segments.value_days": "Days",
  "segments.add": "Add",
  "segments.everyone": "All contacts",
  "segments.days": "1 day|{count} days",
  "segments.field.tag": "Tag",
  "segments.field.source": "Contact origin",
  "segments.field.last_outcome": "Last outcome",
  "segments.field.last_conversation": "Last conversation",
  "segments.field.created": "Signed up",
  "segments.field.marketing": "Marketing",
  "segments.field.name": "Name",
  "segments.op.eq": "is",
  "segments.op.neq": "is not",
  "segments.op.has": "has",
  "segments.op.not_has": "does not have",
  "segments.op.contains": "contains",
  "segments.op.empty": "is empty",
  "segments.op.not_empty": "is filled",
  "segments.op.gt": "greater than",
  "segments.op.lt": "less than",
  "segments.op.none": "never had",
  "segments.op.days_gt": "more than … ago",
  "segments.op.days_lt": "less than … ago",
  "segments.marketing.opted_in": "Accepts",
  "segments.marketing.opted_out": "Declined",
  "segments.marketing.unknown": "No record",
  "segments.col.last_outcome": "Last outcome",
  "segments.col.marketing": "Marketing",
  "segments.total": "1 contact|{count} contacts",
  "segments.marketing_ok": "1 can receive marketing|{count} can receive marketing",
  "segments.selected": "1 selected|{count} selected",
  "segments.clear": "Clear selection",
  "segments.add_tag": "Add tag",
  "segments.apply": "Apply",
  "segments.tagged": "Tag applied to 1 contact.|Tag applied to {count} contacts.",
  "segments.export": "Export",
  "segments.create_campaign": "Create campaign",
  "segments.select": "Select {name}",
  "segments.select_all": "Select all on the page",
  "segments.fields_note": "The fields are the contact's. Spreadsheets, Pipedrive, OutboundPro and the other integrations fill these same fields, so a segment does not depend on where a contact came from.",
  "segments.import_tag": "Import {when}",
  "campaigns.new": "New campaign",
  "campaigns.new_name": "New campaign",
  "campaigns.lead": "An approved template sent to a segment of contacts, with the cost per reply and per sale.",
  "campaigns.kpi.count": "Campaigns this month",
  "campaigns.kpi.reached": "People reached",
  "campaigns.kpi.cost": "Cost this month",
  "campaigns.kpi.per_reply": "Cost per reply",
  "campaigns.tab.all": "All",
  "campaigns.tab.draft": "Drafts",
  "campaigns.tab.pending_approval": "To approve",
  "campaigns.tab.scheduled": "Scheduled",
  "campaigns.tab.running": "Sending",
  "campaigns.tab.done": "Done",
  "campaigns.status.draft": "Draft",
  "campaigns.status.pending_approval": "Awaiting approval",
  "campaigns.status.scheduled": "Scheduled",
  "campaigns.status.running": "Sending",
  "campaigns.status.paused": "Paused",
  "campaigns.status.completed": "Completed",
  "campaigns.status.cancelled": "Cancelled",
  "campaigns.status.scheduled_at": "Scheduled · {at}",
  "campaigns.col.campaign": "Campaign",
  "campaigns.col.status": "Status",
  "campaigns.col.audience": "Audience",
  "campaigns.col.delivered": "Delivered",
  "campaigns.col.replied": "Replied",
  "campaigns.col.sales": "Sales",
  "campaigns.col.cost": "Cost",
  "campaigns.col.per_reply": "Per reply",
  "campaigns.col.sent": "Sent",
  "campaigns.col.read": "Read",
  "campaigns.col.replied_at": "Replied",
  "campaigns.up_to": "up to {value}",
  "campaigns.empty": "No campaigns here.",
  "campaigns.replies_note": "Replies become conversations with the “Campaign” source, in the team, flow or assistant chosen on the campaign.",
  "campaigns.name": "Campaign name",
  "campaigns.save_draft": "Save draft",
  "campaigns.saved": "Draft saved.",
  "campaigns.step.1": "Audience",
  "campaigns.step.2": "Message",
  "campaigns.step.3": "Sending and replies",
  "campaigns.step.4": "Review",
  "campaigns.next.2": "Next: message",
  "campaigns.next.3": "Next: sending",
  "campaigns.next.4": "Next: review",
  "campaigns.source.segment": "Contact segment",
  "campaigns.source.segment_hint": "A segment made in Contacts, always up to date",
  "campaigns.source.filter": "Filter for this campaign only",
  "campaigns.source.filter_hint": "The same conditions as Contacts, without saving",
  "campaigns.source.contacts": "Chosen contacts",
  "campaigns.source.contacts_hint": "1 contact chosen in Contacts|{count} contacts chosen in Contacts",
  "campaigns.source.import": "Import a spreadsheet",
  "campaigns.source.import_hint": "Contacts join with their fields and become the “Import” segment",
  "campaigns.which_segment": "Which segment",
  "campaigns.edit_in_contacts": "Edit in Contacts",
  "campaigns.who_enters": "Who is in",
  "campaigns.fields_note": "Segments are made in Contacts, from contact fields. Coming from Contacts › Create campaign, the audience is already chosen.",
  "campaigns.frozen_note": "When the campaign starts sending, its list freezes: whoever joins the segment later does not get this campaign.",
  "campaigns.who_receives": "Who receives it",
  "campaigns.found": "Found",
  "campaigns.skip.blocked": "Blocked contact",
  "campaigns.skip.no_whatsapp": "No WhatsApp number",
  "campaigns.skip.opted_out": "Asked not to get promotions",
  "campaigns.skip.duplicate": "Repeated number",
  "campaigns.skip.frequency": "Got marketing recently",
  "campaigns.skip.open_conversation": "In a conversation right now",
  "campaigns.skip.cancelled": "Campaign cancelled",
  "campaigns.receive": "Will receive",
  "campaigns.skip_note": "“Asked not to get promotions” and the marketing frequency cannot be unticked; the frequency is set in Settings › Costs and limits.",
  "campaigns.samples": "Examples: {names}",
  "campaigns.pick_audience": "Pick a segment or build a filter.",
  "campaigns.template": "Template",
  "campaigns.number": "Number",
  "campaigns.approved_template": "Approved template",
  "campaigns.quality": "Quality {q}",
  "campaigns.template_hint": "Only approved templates of this number's account show. The price per delivery shows in the review.",
  "campaigns.variables": "Variables",
  "campaigns.var.from": "Comes from",
  "campaigns.var.format": "Format",
  "campaigns.var.fallback": "If empty",
  "campaigns.var.text": "Text",
  "campaigns.var.first_name": "First name",
  "campaigns.var.name": "Name",
  "campaigns.var.phone": "Phone",
  "campaigns.var.field": "Field: {name}",
  "campaigns.var.fixed": "Fixed text",
  "campaigns.var.button": "Link ending of button {n}",
  "campaigns.format.none": "As it is",
  "campaigns.format.title": "Title Case",
  "campaigns.format.first": "First word only",
  "campaigns.format.upper": "UPPERCASE",
  "campaigns.format.lower": "lowercase",
  "campaigns.header": "Header file ({kind})",
  "campaigns.header_choose": "Choose file",
  "campaigns.media.image": "photo",
  "campaigns.media.video": "video",
  "campaigns.media.document": "document",
  "campaigns.buttons": "Buttons",
  "campaigns.quick_reply": "Quick reply",
  "campaigns.when_tapped": "When tapped",
  "campaigns.button.route": "Opens a conversation like the reply",
  "campaigns.button.optout": "Takes the contact out of marketing",
  "campaigns.button.none": "Only counts the tap",
  "campaigns.preview": "Preview · {name}",
  "campaigns.prev_sample": "Previous example",
  "campaigns.next_sample": "Next example",
  "campaigns.missing": "Missing value for {slots}: Meta would refuse this message.",
  "campaigns.test_phone": "Send a test to",
  "campaigns.send_test": "Send test",
  "campaigns.test_hint": "The test goes to that WhatsApp, opens a test conversation for you and does not count in the campaign's numbers.",
  "campaigns.test_sent": "Test sent.",
  "campaigns.when": "When",
  "campaigns.when_now": "Now",
  "campaigns.when_later": "Schedule",
  "campaigns.start_at": "Starts at",
  "campaigns.window": "Sends only on these days and hours (Brasília time):",
  "campaigns.from": "From",
  "campaigns.to": "To",
  "campaigns.window_hint": "Speed is automatic: it keeps within Meta's daily limit of new people, across all the company's numbers and sends. With no day ticked, it sends at any time.",
  "campaigns.stop": "Stops by itself if",
  "campaigns.stop_template": "Meta pauses or rejects the template",
  "campaigns.stop_quality": "The number's quality drops to low",
  "campaigns.stop_optout": "More than 3% ask to stop",
  "campaigns.stop_budget": "The campaign's budget runs out",
  "campaigns.budget": "Campaign budget (R$)",
  "campaigns.stop_hint": "When it stops, it tells the author and shows why. Resuming is one click.",
  "campaigns.on_reply": "When someone replies",
  "campaigns.reply.team": "Opens a conversation in the team",
  "campaigns.reply.team_hint": "Distributed like other conversations",
  "campaigns.reply.flow": "Starts a flow",
  "campaigns.reply.flow_hint": "A published flow leads the conversation",
  "campaigns.reply.assistant": "The assistant answers",
  "campaigns.reply.assistant_hint": "With the campaign's message as context",
  "campaigns.reply.pick_team": "Team",
  "campaigns.reply.pick_flow": "Flow",
  "campaigns.reply.pick_assistant": "Assistant",
  "campaigns.reply.default_team": "The number's default team",
  "campaigns.goal": "Conversation goal",
  "campaigns.success_days": "Days to count the sale",
  "campaigns.success_hint": "Sale = a conversation opened by the reply and closed with a success outcome within {days} days. If the contact was in two campaigns, only the last one counts.",
  "campaigns.summary": "Summary",
  "campaigns.people": "1 person|{count} people",
  "campaigns.starts": "Starts",
  "campaigns.estimate": "Estimated cost",
  "campaigns.market": "Market",
  "campaigns.price": "Price",
  "campaigns.up_to_col": "Up to",
  "campaigns.total": "Total",
  "campaigns.estimate_hint": "“Up to” because only delivered messages are charged; who hit the day's marketing limit is not charged. Replies the campaign opens cost too (service) and count in the results.",
  "campaigns.checks": "Before sending",
  "campaigns.check.template": "Template approved",
  "campaigns.check.number": "Number can send · quality {quality}",
  "campaigns.check.days": "Ends in 1 day (limit of {limit} new people a day)|Ends in {days} days (limit of {limit} new people a day)",
  "campaigns.check.unlimited": "No daily limit at Meta",
  "campaigns.check.budget": "{scope}: {spent} of {amount}; with this campaign, up to {after}",
  "campaigns.needs_approval": "Needs approval",
  "campaigns.needs_approval_hint": "The campaign goes over the amount or audience the company's rule wants approved.",
  "campaigns.ask": "Ask",
  "campaigns.request_approval": "Request approval",
  "campaigns.ready_hint": "All set. The campaign starts now or at the scheduled time.",
  "campaigns.schedule": "Schedule",
  "campaigns.send_now": "Send now",
  "campaigns.submitted.pending_approval": "Approval requested.",
  "campaigns.submitted.running": "Campaign sending.",
  "campaigns.submitted.scheduled": "Campaign scheduled.",
  "campaigns.byline": "Created by {who} · {at}",
  "campaigns.api": "integration",
  "campaigns.approved_by": "approved by {name}",
  "campaigns.duplicate": "Duplicate",
  "campaigns.banner.running": "Sending · {sent} of {total}. It keeps to the campaign's hours and Meta's daily limit.",
  "campaigns.banner.scheduled": "Scheduled for {at}.",
  "campaigns.banner.pending": "Waiting for an admin's approval.",
  "campaigns.pause_reason.member": "Paused by a person.",
  "campaigns.pause_reason.template_paused": "Paused by itself: Meta paused or rejected the template.",
  "campaigns.pause_reason.quality_low": "Paused by itself: the number's quality dropped.",
  "campaigns.pause_reason.optout_rate": "Paused by itself: many people asked to stop.",
  "campaigns.pause_reason.budget": "Paused by itself: the campaign's budget ran out.",
  "campaigns.pause_reason.company_budget": "Paused by itself: the month's budget reached its limit.",
  "campaigns.pause_reason.channel_unavailable": "Paused by itself: the number cannot send.",
  "campaigns.pause": "Pause",
  "campaigns.resume": "Resume",
  "campaigns.cancel": "Cancel campaign",
  "campaigns.approve": "Approve",
  "campaigns.reject": "Reject with a reason",
  "campaigns.reject_reason": "Reason",
  "campaigns.kpi.campaign_cost": "Campaign cost",
  "campaigns.kpi.estimated": "Estimated: up to {value}",
  "campaigns.kpi.with_conversations": "With the conversations",
  "campaigns.kpi.follow_hint": "+ {value} from replies (service)",
  "campaigns.kpi.per_sale": "Per sale",
  "campaigns.funnel": "Funnel",
  "campaigns.funnel_step.audience": "Audience",
  "campaigns.funnel_step.sent": "Sent",
  "campaigns.funnel_step.delivered": "Delivered",
  "campaigns.funnel_step.read": "Read",
  "campaigns.funnel_step.replied": "Replied",
  "campaigns.funnel_step.sales": "Sales",
  "campaigns.sale_rule": "Sale = a conversation the campaign opened, closed with a success outcome within {days} days.",
  "campaigns.link": "Link",
  "campaigns.links_hint": "Link clicks come from Meta's template insights, up to 2 days late, and add up every send of the template on the campaign's days.",
  "campaigns.failures": "Not delivered · {count}",
  "campaigns.no_failures": "No failures.",
  "campaigns.retry": "Retry those that can be",
  "campaigns.requeued": "1 person back in the queue.|{count} people back in the queue.",
  "campaigns.skipped_title": "Left out",
  "campaigns.people_title": "People",
  "campaigns.filter.all": "All",
  "campaigns.filter.delivered": "Delivered",
  "campaigns.filter.read": "Read",
  "campaigns.filter.replied": "Replied",
  "campaigns.filter.success": "Sales",
  "campaigns.filter.failed": "Failed",
  "campaigns.filter.skipped": "Left out",
  "campaigns.filter.queued": "Queued",
  "campaigns.recipient.queued": "Queued",
  "campaigns.recipient.sending": "Sending",
  "campaigns.recipient.sent": "Sent",
  "campaigns.recipient.delivered": "Delivered",
  "campaigns.recipient.read": "Read",
  "campaigns.recipient.failed": "Not delivered",
  "campaigns.recipient.replied": "Replied",
  "campaigns.recipient.success": "Bought",
  "campaigns.recipient.skip.blocked": "Left out: blocked",
  "campaigns.recipient.skip.no_whatsapp": "Left out: no WhatsApp",
  "campaigns.recipient.skip.opted_out": "Left out: declines promotions",
  "campaigns.recipient.skip.duplicate": "Left out: repeated number",
  "campaigns.recipient.skip.frequency": "Left out: got marketing recently",
  "campaigns.recipient.skip.open_conversation": "Left out: in a conversation",
  "campaigns.recipient.skip.cancelled": "Left out: campaign cancelled",
  "campaigns.recipient.skip.other": "Left out",
  "campaigns.failure.131049": "The person's daily marketing limit",
  "campaigns.failure.131026": "Number without WhatsApp",
  "campaigns.failure.131050": "Blocked marketing in WhatsApp",
  "campaigns.failure.131047": "Outside the 24-hour window",
  "campaigns.failure.131051": "Message type not accepted",
  "campaigns.failure.132015": "Template paused by Meta",
  "campaigns.failure.135000": "Meta's sending pace",
  "campaigns.failure.131042": "Payment problem at Meta",
  "campaigns.failure.variable_missing": "A variable had no value",
  "campaigns.failure.cancelled": "Campaign cancelled",
  "campaigns.failure.unknown": "Reason not given",
  "campaigns.failure.other": "Error {code}",
  "campaigns.next.tomorrow": "Retries by itself tomorrow · not charged",
  "campaigns.next.mark": "Not retried",
  "campaigns.next.optout": "Leaves marketing",
  "campaigns.next.retry": "Can be retried",
  "campaigns.open_conversation": "Open conversation",
  "campaigns.no_people": "Nobody here.",
  "errors.campaign_not_editable": "This campaign left draft and cannot be edited.",
  "errors.campaign_audience_empty": "Nobody to receive it: check the audience.",
  "errors.campaign_not_pending": "This campaign is not waiting for approval.",
  "errors.campaign_own_approval": "The campaign's author cannot approve it.",
  "errors.campaign_wrong_status": "The campaign's status does not allow this.",
  "errors.campaign_not_found": "Campaign not found.",
  "errors.segment_not_found": "Segment not found.",
  "errors.template_without_media_header": "This template has no file header.",
  "errors.upload_used": "This file was already used; choose it again.",
  "errors.template_not_approved": "The template is not approved by Meta.",
  "campaigns.var.slot_header": "Header {name}",
  "campaigns.var.slot_body": "Body {name}",
  "campaigns.check.missing": "1 person would get an empty variable: fill “If empty”|{count} people would get an empty variable: fill “If empty”",
  "campaigns.not_ready_hint": "Fix the items marked above to send.",
  "fx.approx_today": "≈ {value} today",
  "fx.approx": "≈ {value}",
  "fx.rate": "Today's dollar: US$ 1 = {rate} (PTAX of {day})",
  "fx.no_rate": "The dollar rate has not arrived yet",
  "fx.ai_note": "AI is charged in dollars and converted at today's dollar: US$ 1 = {rate} (PTAX of {day}).",
  "platform.ai.pricing_synced": "Price updated for {count} model|Prices updated for {count} models",
  "platform.ai.last_sync": "Last catalog update: {when}, price of {count} model. LiteLLM's public table is read every day at 3:15 (Brasília).|Last catalog update: {when}, prices of {count} models. LiteLLM's public table is read every day at 3:15 (Brasília).",
  "platform.ai.alert.retiring": "{model} will be retired by the provider on {date}.",
  "platform.ai.alert.price_moved": "{model}: the {field} price moved from {from} to {to} per million tokens. Check it before passing it on.",
  "platform.ai.alert.input": "input",
  "platform.ai.alert.output": "output",
  "platform.ai.unpriced": "No price in the table (AI on these models counts as zero): {models}",
  "platform.ai.retires": "retires on {date}",
  "platform.ai.synced_at": "Price from LiteLLM's table on {when}",
  "page.back_to": "Back to {name}",
  "page.unsaved": "Unsaved changes",
  "page.leave_title": "Leave without saving?",
  "page.leave_text": "The changes on this page have not been saved and will be lost.",
  "page.leave": "Leave without saving",
  "page.stay": "Keep editing",
  "chips.remove": "Remove {value}",
  "assistants.lead": "Who answers for the business while no person is there. Click an assistant to open it.",
  "assistants.empty": "No assistants yet. Create the first one and test it before publishing.",
  "assistants.speaks_as": "Speaks as {name} · {tone}",
  "assistants.no_tone": "no tone set",
  "assistants.no_persona": "No persona set",
  "assistants.now": "Now",
  "assistants.consults": "Reads",
  "assistants.hands_to": "Hands over to",
  "assistants.running": "{count} conversation|{count} conversations",
  "assistants.none_now": "None right now",
  "assistants.never_published": "Never published",
  "assistants.collections": "{count} collection|{count} collections",
  "assistants.consults_nothing": "Nothing yet",
  "assistants.same_team": "The current team's queue",
  "assistants.published_on": "Version {n} · published on {day}",
  "assistants.created_on": "Changed on {day}",
  "assistants.show_archived": "Show archived ({count})|Show archived ({count})",
  "assistants.show_active": "Back to active ones",
  "assistants.unpublished": "Unpublished changes",
  "assistants.live": "Live · version {n}",
  "assistants.not_found": "This assistant no longer exists.",
  "assistants.default_name": "New assistant",
  "assistants.save_draft": "Save draft",
  "assistants.tab.voice": "How it speaks",
  "assistants.tab.knows": "What it knows and does",
  "assistants.tab.handoff": "When it hands over to a person",
  "assistants.tab.versions": "Versions and use",
  "assistants.field.name": "Internal name",
  "assistants.field.persona": "Name the contact sees",
  "assistants.instructions_hint": "Write it as if explaining the job to someone new on the team: the business, what to answer, what never to promise and when to call someone.",
  "assistants.creativity.low": "more predictable",
  "assistants.creativity.mid": "balanced",
  "assistants.creativity.high": "more creative",
  "assistants.knows.title": "What it reads",
  "assistants.knows.hint": "Knowledge base collections it reads before answering.",
  "assistants.knows.none": "No collections yet.",
  "assistants.knows.open": "Open the knowledge base",
  "assistants.does.title": "What it can do",
  "assistants.does.hint": "Actions the assistant takes on its own during the conversation.",
  "assistants.handoff.title": "When it hands over to a person",
  "assistants.handoff.keywords": "When the contact says",
  "assistants.handoff.keywords_placeholder": "agent, human",
  "assistants.handoff.hint": "It also hands over when it cannot answer or the contact asks, if “Hand over to a person” is on in “What it knows and does”.",
  "assistants.limits.title": "Reply limits",
  "assistants.limits.blocked": "Words it never uses",
  "assistants.limits.blocked_placeholder": "guaranteed, interest-free",
  "assistants.limits.hint": "If a reply has one of these words, the safety text is sent instead.",
  "assistants.versions.none": "No version published yet.",
  "assistants.runs.title": "Recent conversations",
  "assistants.runs.none": "It has not handled anyone yet.",
  "assistants.runs.turns": "{count} reply|{count} replies",
  "assistants.run.running": "Handling",
  "assistants.run.completed": "Completed",
  "assistants.run.handed_off": "Handed over",
  "assistants.run.cancelled": "Stopped",
  "assistants.run.failed": "Failed",
  "assistants.test.title": "Test",
  "assistants.test.open": "Test",
  "assistants.test.close": "Close the test",
  "assistants.test.draft": "With what is on screen",
  "assistants.test.restart": "Start over",
  "assistants.test.empty": "Write as if you were the contact. The assistant answers with what is on screen, even if unsaved.",
  "assistants.test.placeholder": "Write as the contact",
  "assistants.test.send": "Send test message",
  "assistants.test.typing": "Replying",
  "assistants.test.note": "Nothing is sent to WhatsApp and nothing goes into the reports. The AI cost shows in AI usage as a test.",
  "assistants.test.consulted": "Read: {sources}",
  "assistants.test.handoff": "Would hand over to a person ({team}). Reason: {reason}",
  "assistants.test.closes": "Would close the conversation as {outcome}",
  "assistants.test.set_field": "Would save on the contact: {field} = {value}",
  "assistants.test.start_flow": "Would start the flow {flow}",
  "assistants.test.end": "Would return the conversation to the flow",
  "assistants.test.exit_keyword": "The contact said “{keyword}”: would hand over to a person ({team})",
  "assistants.test.exit_field": "The field {field} was filled: would hand over to a person ({team})",
  "assistants.test.max_turns": "Reached the reply limit: would hand over to a person ({team})",
  "assistants.test.ended": "The test ended here. Start over to test again.",
  "assistants.test.closed_hint": "The test is closed. “Test” at the top opens it again, on any tab.",
  "knowledge.lead": "What assistants read to answer, organized in collections.",
  "knowledge.empty": "No collections yet. Create one and add texts, site pages or PDFs.",
  "knowledge.new_collection_button": "New collection",
  "knowledge.collection_name": "Collection name",
  "knowledge.collection_hint": "Then add content and tick the collection on the assistants that should read it.",
  "knowledge.create": "Create",
  "knowledge.card.contents": "{count} item|{count} items",
  "knowledge.card.ready": "All ready",
  "knowledge.card.processing": "Processing",
  "knowledge.card.empty": "Empty",
  "knowledge.card.failed": "{count} failed|{count} failed",
  "knowledge.card.used_by": "Used by",
  "knowledge.card.unused": "No assistant reads it. Tick it in “What it reads” on the assistant.",
  "knowledge.not_found": "This collection no longer exists.",
  "knowledge.page.used_by": "Used by {names}",
  "knowledge.page.empty": "No content yet. Use “Add content”.",
  "knowledge.rename": "Rename",
  "knowledge.col.content": "Content",
  "knowledge.col.source": "Source",
  "knowledge.col.chunks": "Passages",
  "knowledge.col.status": "Status",
  "knowledge.failed_generic": "This content could not be read.",
  "knowledge.retry": "Try again",
  "knowledge.remove": "Remove {name}",
  "knowledge.test.title": "Test the search",
  "knowledge.test.hint": "Write a customer's question and see the passages the assistant would read before answering.",
  "knowledge.test.question": "Question",
  "knowledge.test.placeholder": "How long does delivery take?",
  "knowledge.test.search": "Search",
  "knowledge.test.very_close": "very close",
  "knowledge.test.close": "close",
  "knowledge.test.far": "loosely related",
  "knowledge.test.nothing": "No similar passage. Content about this is missing.",
  "knowledge.test.advice": "If the right passage does not show, content is missing or it is written differently from how customers ask.",
  "learning.lead": "Every week the AI reads the closed conversations and suggests improvements. Nothing changes without your approval.",
  "learning.waiting": "{count} suggestion waiting for you|{count} suggestions waiting for you",
  "learning.waiting_hint": "From the {period} report. Approved ones become canned replies, assistant changes or knowledge content.",
  "learning.review_now": "Review now",
  "learning.row_counts": "{analyzed} conversations read · {applied} applied",
  "learning.to_review": "{count} to review|{count} to review",
  "learning.reviewed": "Reviewed",
  "learning.show_archived": "Show archived ({count})|Show archived ({count})",
  "learning.show_current": "Back to current ones",
  "learning.period_range": "{from} to {to}",
  "learning.week_of": "Week of {period}",
  "learning.filter.proposed": "To review",
  "learning.filter.applied": "Applied",
  "learning.filter.rejected": "Rejected",
  "learning.filter_empty.proposed": "Nothing to review in this report.",
  "learning.filter_empty.applied": "No suggestion applied yet.",
  "learning.filter_empty.rejected": "No suggestion rejected.",
  "learning.body_editable": "Text (you can edit it before approving)",
  "learning.evidence_count": "See {count} example conversation|See the {count} example conversations",
  "learning.approve_draft": "Approve as a draft",
  "learning.the_week": "The week",
  "learning.stat.analyzed": "Conversations read",
  "learning.stat.successful": "Closed with success",
  "learning.stat.suggestions": "Suggestions",
  "policy.lead": "Automatic rules for conversations, so nobody has to remember.",
  "policy.empty": "No policies yet.",
  "policy.kind_hint.lifecycle": "Closes or prioritizes idle conversations",
  "policy.kind_hint.gate": "Checks what the team writes before it is sent",
  "policy.inactive": "Off",
  "policy.new_title": "What does the new policy do?",
  "policy.kind_choice.lifecycle": "Closes, prioritizes or marks as waiting after some time without a reply.",
  "policy.kind_choice.gate": "Stops words, promises and sensitive data, with or without AI review.",
  "policy.continue": "Continue",
  "policy.not_found": "This policy no longer exists.",
  "policy.scope_team": "team {name}",
  "policy.applies_to": "Applies to",
  "policy.when": "When",
  "policy.rule_kind": "What happens",
  "policy.when_kind.no_inbound_for": "the contact does not reply",
  "policy.when_kind.unanswered_new_for": "a new conversation gets no first reply",
  "policy.when_kind.window_expired": "the 24-hour window closes",
  "policy.for": "for",
  "policy.hours_word": "hours",
  "policy.then_close": "close as",
  "policy.then_priority": "priority",
  "policy.then_waiting": "mark as waiting for the contact",
  "policy.remove_rule": "Remove rule",
  "policy.sentence.no_inbound_for": "When the contact does not reply for {hours} hours → close as {outcome}",
  "policy.sentence.unanswered_new_for": "When a new conversation gets no first reply for {hours} hours → priority {priority}",
  "policy.sentence.window_expired": "When the 24-hour window closes → mark as waiting for the contact",
  "policy.practice.title": "What it looks like",
  "policy.practice.t0": "Start",
  "policy.practice.t1": "Then",
  "policy.practice.t2": "{hours} h later",
  "policy.practice.last_message": "The contact sends their last message.",
  "policy.practice.reply": "The team replies, and the contact does not come back.",
  "policy.practice.closed": "Closed as {outcome} by the policy. Reports show it as closed automatically.",
  "policy.practice.other": "The rules apply to the conversations of the whole company or of the chosen team.",
  "policy.practice.many": "Only the most specific rule applies to each conversation: the campaign's, then the number's, the team's and last the company's. Rules of the same level apply together: the first to fire acts.",
  "policy.advanced": "Advanced",
  "policy.gate.when_fails": "When a message does not pass",
  "policy.mode_card.log": "Just record",
  "policy.mode_card.suggest": "Suggest to the agent",
  "policy.mode_card.auto_fix": "Fix and send",
  "policy.mode_card.block": "Block",
  "policy.mode_hint.log": "Sends it as written and notes it for the reports.",
  "policy.mode_hint.suggest": "Shows the problem and a fixed version. The agent chooses.",
  "policy.mode_hint.auto_fix": "Replaces it with the fixed text on its own.",
  "policy.mode_hint.block": "Does not send. The agent rewrites it.",
  "policy.gate.checks": "What the review checks",
  "policy.gate.blocked_chips": "Never lets through",
  "policy.gate.blocked_placeholder": "guaranteed, interest-free",
  "policy.gate.phrases": "Promises, as example phrases",
  "policy.gate.phrases_placeholder": "I guarantee it, surely approved",
  "policy.gate.phrases_hint": "Catches the phrase in any case, without accents or with up to three words in between: “guarantee it arrives” catches “I guarantee your order arrives”.",
  "policy.gate.domains_chips": "Links only to these sites",
  "policy.gate.judge_label": "AI review",
  "policy.gate.judge_hint": "A second AI reads the message with the guidance below.",
  "policy.summary.blocks": "Never lets through: {words}",
  "policy.summary.pii": "stops card and ID numbers",
  "policy.summary.links": "links only to {count} site|links only to {count} sites",
  "policy.summary.judge_on": "AI review on",
  "policy.summary.judge_off": "no AI review",
  "policy.example.title": "What the agent sees",
  "policy.example.draft": "I guarantee your credit is approved today, interest-free!",
  "policy.example.hint": "The example follows what you choose above.",
  "policy.example.log.title": "Sent as written",
  "policy.example.log.text": "The review notes that it promised approval and said “interest-free”; it shows in the reports.",
  "policy.example.suggest.title": "Not sent: promises approval and says “interest-free”",
  "policy.example.suggest.text": "Suggestion: “I can check the conditions and explain how approval works.” The agent uses it or edits it.",
  "policy.example.auto_fix.title": "Sent already fixed",
  "policy.example.auto_fix.text": "The contact gets: “I can check the conditions and explain how approval works.”",
  "policy.example.block.title": "Not sent",
  "policy.example.block.text": "The agent sees why and has to rewrite the message.",
  "templates.not_found": "This template no longer exists.",
  "errors.ai_key_missing": "No AI key is set up. Add one in Settings › AI and keys or contact support.",
  "errors.ai_budget_exceeded": "This month's AI spending limit was reached.",
  "errors.ai_provider_error": "The AI provider did not answer properly. Try again in a moment.",
  "errors.ai_provider_timeout": "The AI provider took too long to answer. Try again.",
  "errors.ai_surface_not_configured": "No AI model was chosen for this task. Contact support.",
  "errors.ai_capability_unsupported": "The chosen AI model cannot do this.",
  "errors.ai_provider_unsupported": "This AI provider is not supported.",
  "templates.cannot_edit": "Only drafts and templates Meta rejected or paused can be edited. To change an approved one, duplicate it.",
  "ai.calls.test": "test",
  "settings.fields": "Contact fields",
  "settings.optout": "Opt-out",
  "settings.hours": "Business hours",
  "settings.search": "Search settings",
  "settings.search_empty": "Nothing found for “{query}”.",
  "settings.in_section": "in {section}",
  "settings.find.numbers": "whatsapp, connect, phone, number, official api, quality, pin, coexistence, meta",
  "settings.find.templates": "template, hsm, meta, approval, marketing, utility, outbound message",
  "settings.find.optout": "stop, unsubscribe, opt-out, consent",
  "settings.find.members": "members, invite, agents, users, roles, permissions, password, access, login",
  "settings.find.teams": "groups, distribution, capacity, round robin, queue, auto assign",
  "settings.find.hours": "office hours, time zone, weekend, holiday, away",
  "settings.find.assistants": "bot, chatbot, persona, instructions, ai, test",
  "settings.find.knowledge": "documents, pdf, site, faq, content, collection",
  "settings.find.learning": "suggestions, improvements, weekly report, analysis",
  "settings.find.policies": "auto close, message review, gate, blocked words, promises, priority, regex",
  "settings.find.outcomes": "result, sale, close, closing reason, success",
  "settings.find.tags": "labels, colors, classify",
  "settings.find.snippets": "shortcuts, quick replies, canned messages, playbook",
  "settings.find.fields": "id number, contact data, custom fields, segmentation, import",
  "settings.find.budgets": "budget, spending limit, cost, money",
  "settings.find.limit": "pause, block sending, over budget",
  "settings.find.cost_alerts": "alerts, cost warnings, email, notification",
  "settings.find.approval": "approve campaign, approval",
  "settings.find.frequency": "frequency, interval, how many messages, marketing, days",
  "settings.find.spenders": "who can send marketing, sending permissions",
  "settings.find.insights": "metrics, clicks, template analytics",
  "settings.find.ai_keys": "ai keys, openai, anthropic, gemini, claude, gpt, own key, api key",
  "settings.find.ai_usage": "ai usage, ai cost, tokens, calls, ai budget",
  "settings.find.api_keys": "api keys, token, integration, developer",
  "settings.find.hooks": "inbound webhook, lead capture, form, site, ads",
  "settings.find.webhooks": "webhooks, events, notifications, callback, integration",
  "settings.find.crm": "crm, pipedrive, outboundpro, deals, pipeline",
  "settings.find.retention": "retention, delete data, keep, files",
  "settings.find.export": "export, backup, download data, copy",
  "settings.find.subjects": "gdpr, data subject, delete contact, rights, personal data",
  "fields.lead": "What the business records about each contact. Segments, campaigns, imports, integrations and the assistant use these fields.",
  "fields.ai_short": "AI fills it",
  "fields.used_by": "Tick “AI can fill it” for the assistant to save the value during the conversation.",
  "fields.options_chips": "Options",
  "fields.options_placeholder": "Type an option and press Enter",
  "optout.keywords_chips": "Words that opt out of marketing",
  "optout.keywords_placeholder": "stop, unsubscribe",
  "optout.effect": "Whoever opts out gets no more campaigns or marketing templates until they ask to come back. Utility messages and conversations they start go on as usual.",
  "hours.lead": "When each team answers. Outside the hours the conversation waits in the queue and the flow can reply with the away message.",
  "hours.used_by": "used by {teams}",
  "hours.unused": "no team uses it",
  "hours.empty": "No schedules yet. Create one and pick it for each team in Team and people.",
  "hours.where": "Each team picks its schedule in Team and people. In flows, the “Business hours” step splits the path between inside and outside the hours.",
  "hours.short.mon": "Mon",
  "hours.short.tue": "Tue",
  "hours.short.wed": "Wed",
  "hours.short.thu": "Thu",
  "hours.short.fri": "Fri",
  "hours.short.sat": "Sat",
  "hours.short.sun": "Sun",
  "hours.span": "{from} to {to}",
  "hours.always_closed": "Always closed",
  "team.hours_hint": "The schedules each team can pick are in",
  "settings.group.channel": "Channel and messages",
  "settings.group.service": "Service",
  "settings.group.ai": "Artificial intelligence",
  "settings.group.account": "Account",
  "settings.marketing": "Marketing rules",
  "settings.outcomes": "Outcomes",
  "settings.tags": "Tags",
  "settings.snippets": "Canned replies",
  "marketing.lead": "Who gets marketing and how often: opting out, the gap between messages, when a campaign needs approval and who can send.",
  "marketing.who": "Who can send and approve",
  "tags.lead": "Colored labels for contacts and conversations, to filter, segment and report.",
  "costs.settings.ai_limit": "AI spending limit",
  "costs.settings.ai_limit_hint": "In dollars, as AI providers charge. At the limit it only warns or stops AI until next month.",
  "ai.lead": "The keys AI uses and this month's usage. The spending limit is in Costs and limits.",
  "ai.own_keys_hint": "Uses the business's own keys instead of the platform's.",
  "ai.limit_is": "Monthly AI limit: {value}.",
  "ai.no_limit": "No monthly AI limit.",
  "ai.limit_where": "Change it in Costs and limits",
  "settings.find.marketing": "marketing, campaigns, rules, consent, bulk sending",
  "settings.find.ai_limit": "ai limit, ai budget, ai spending, dollar, block ai",
  "numbers.lead": "The business's WhatsApp numbers, connected through Meta's official API, with each one's health.",
  "team.lead": "Who answers and in which team. Roles give the permissions; exceptions are set on each person.",
  "integrations.lead": "How other systems talk to DoneTalk: CRM, API keys, lead intake and event webhooks.",
  "privacy.lead": "How long data is kept, the account's full copy and people's data requests.",
  "platform.group.customers": "Customers",
  "platform.group.business": "Commercial",
  "platform.group.platform": "Platform",
  "platform.lead.overview": "How the platform is doing: customers, conversations, messages and this month's costs.",
  "platform.lead.customers": "Every company on DoneTalk. Add them, follow their setup and look after people's access.",
  "platform.lead.plans": "What each customer buys: every plan's limits and features.",
  "platform.lead.ai": "The platform's AI keys, available models, prices and which model does each task.",
  "platform.lead.admins": "Who at Nuvvun uses this console and what they can do.",
  "platform.lead.audit": "Everything Nuvvun's team did in the console: who, when and what.",
  "platform.trial_over": "Trial over",
  "platform.trial_until": "Trial until {date}",
  "platform.people": "1 person|{count} people",
  "platform.invited": "1 pending invitation|{count} pending invitations",
  "platform.onboarding_short": "{done} of {total} stages",
  "platform.action.customer_created": "Customer created",
  "platform.action.customer_updated": "Details or situation changed",
  "platform.action.owner_added": "Owner added",
  "platform.action.provisioned": "Database created",
  "platform.action.provision_failed": "Database creation failed",
  "platform.action.password_link": "New-password link made",
  "platform.action.mfa_reset": "Two-step verification turned off",
  "platform.action.plan_created": "Plan created",
  "platform.action.plan_updated": "Plan changed",
  "platform.action.admin_added": "Admin added",
  "platform.action.admin_removed": "Admin removed",
  "platform.filter.all": "All",
  "platform.owner_and_more": "{email} and {count} more",
  "platform.no_owner": "No owner",
  "platform.created_on": "Created on {date}",
  "platform.db_state": "Database: {state}",
  "platform.customers.none_match": "No customer with that name or in that situation.",
  "platform.customers.empty_lead": "No customers yet. Add the first one: the owner gets an invitation to set a password and start the setup.",
  "platform.start.trial": "On a 14-day trial",
  "platform.start.active": "Active (paying customer)",
  "platform.new.create": "Add customer",
  "platform.new.done_title": "Customer added: {name}",
  "platform.new.done_active": "{email} already has a DoneTalk account and can open this customer now.",
  "platform.new.done_emailed": "We sent the invitation to {email}. If it does not arrive, send this link:",
  "platform.new.done_link": "The e-mail was not sent. Send {name} this link to set a password:",
  "platform.new.link_hint": "The invitation lasts 7 days and works once. Send it through a safe channel, such as the person's WhatsApp.",
  "platform.new.open": "Open the customer",
  "platform.new.another": "Add another",
  "platform.new.company": "Company",
  "platform.new.slug_taken": "That identifier belongs to another customer. Pick another one.",
  "platform.new.slug_hint": "Customer identifier: {slug}. It shows in integrations and the API, never in screen addresses. Lowercase letters, numbers and hyphens; it cannot change later.",
  "platform.new.owner": "Account owner",
  "platform.new.owner_hint": "The owner gets an invitation to set their own password. Nobody at Nuvvun picks or sees it.",
  "platform.new.start": "How it starts",
  "platform.new.start_hint": "On trial the customer uses everything for 14 days; afterwards switch it to Active under Plan and situation.",
  "platform.link_copied": "Link copied",
  "common.copy": "Copy",
  "common.loading": "Loading…",
  "platform.page.summary": "Summary",
  "platform.page.company": "Details",
  "platform.page.people": "People",
  "platform.page.plan": "Plan and situation",
  "platform.page.numbers": "Numbers",
  "platform.page.usage": "Usage",
  "platform.page.history": "History",
  "platform.summary.account": "Account",
  "platform.summary.address": "Identifier",
  "platform.summary.created": "Customer since",
  "platform.summary.database": "Database",
  "platform.summary.owners": "Owners",
  "platform.company.slug_fixed": "The identifier {slug} does not change, so the customer's integrations keep working.",
  "platform.people.title": "1 person|{count} people",
  "platform.people.never": "never signed in",
  "platform.people.seen": "last seen: {when}",
  "platform.people.mfa_on": "two-step on",
  "platform.people.mfa_off": "two-step off",
  "platform.people.reinvite": "Resend invitation",
  "platform.people.password_link": "Make a new-password link",
  "platform.people.hint": "The rest of the customer's team is invited by the owner, under Settings › Team and people.",
  "platform.people.invite_title": "{name}'s invitation",
  "platform.people.seated": "{email} already had an account and can now open it as owner.",
  "platform.people.password_title": "New-password link for {name}",
  "platform.people.send_invite": "Invite",
  "platform.lifecycle_hint.trial": "Trial: the customer uses everything until the 14-day trial ends.",
  "platform.lifecycle_hint.active": "Active: paying customer with normal access.",
  "platform.lifecycle_hint.suspended": "Suspended: nobody at the company can sign in and automations stop until you reactivate it. Data is kept.",
  "platform.lifecycle_hint.churned": "Churned: the customer left. Nobody signs in and automations stop; data follows the agreed retention.",
  "platform.plan.trial_ends": "The trial ends on {date}.",
  "platform.numbers.empty": "No numbers here.",
  "platform.numbers.account": "Account {name} ({id})",
  "platform.numbers.method.embedded_signup": "Meta sign-up",
  "platform.numbers.method.coexistence": "alongside the WhatsApp Business app",
  "platform.numbers.method.token": "system token",
  "platform.numbers.since": "since {date}",
  "platform.numbers.quality": "Quality {value}",
  "platform.numbers.can_send.AVAILABLE": "Can send",
  "platform.numbers.can_send.LIMITED": "Limited sending",
  "platform.numbers.can_send.BLOCKED": "Blocked by Meta",
  "platform.numbers.status.active": "Active",
  "platform.numbers.status.pending": "Pending",
  "platform.numbers.status.disabled": "Disabled",
  "platform.numbers.status.error": "Error",
  "platform.usage.title": "Usage in {month}",
  "platform.usage.conversations_opened": "Conversations opened",
  "platform.usage.conversations_closed": "Conversations closed",
  "platform.usage.messages_inbound": "Messages received",
  "platform.usage.messages_outbound": "Messages sent",
  "platform.usage.active_contacts": "Active contacts",
  "platform.usage.day": "Day",
  "platform.usage.empty": "No activity this month yet.",
  "platform.confirm.suspended.title": "Suspend {name}?",
  "platform.confirm.suspended.lead": "Nobody at the company can sign in, and flows, assistants and campaigns stop until you reactivate it. Nothing is deleted.",
  "platform.confirm.suspended.button": "Suspend",
  "platform.confirm.churned.title": "Close {name}?",
  "platform.confirm.churned.lead": "Use it when the customer has left. Nobody signs in and automations stop. Data follows the agreed retention until it is deleted.",
  "platform.confirm.churned.button": "Close",
  "platform.admins.count": "1 admin|{count} admins",
  "platform.admins.you": "you",
  "platform.admins.since": "since {date}",
  "platform.admins.only_super": "Only Super admins add or remove people.",
  "platform.admins.roles_title": "What each role can do",
  "platform.admins.role_hint.super": "everything: customers, plans, AI, admins and anyone's access, including Nuvvun's team.",
  "platform.admins.role_hint.support": "adds and follows customers and helps their people with access; does not change admins.",
  "platform.admins.email_label": "E-mail",
  "platform.admins.name": "Name",
  "platform.admins.new_account": "That e-mail has no account yet. Enter the name: the account is created and you get a link for the person to set a password.",
  "platform.admins.added": "{name} is now an admin.",
  "platform.admins.remove_title": "Remove {name} from the console?",
  "platform.admins.remove_lead": "The person stops seeing the console right away. Their account stays.",
  "platform.admins.link_title": "{name}'s access link",
  "platform.admins.link_lead": "Send this link for the person to set a password. It lasts 3 days and works once.",
  "platform.attention.title": "Needs attention",
  "platform.attention.none": "Nothing needs attention right now.",
  "platform.attention.db_failed": "The database was not created",
  "platform.attention.trial_over": "The trial ended on {date}",
  "platform.attention.trial_ending": "The trial ends on {date}",
  "platform.attention.invite_pending": "The owner has not accepted the invitation yet",
  "platform.attention.urgent": "Fix",
  "platform.attention.soon": "Follow up",
  "settings.plan": "Plan",
  "settings.find.plan": "plan subscription price limits contract quota customers served",
  "plan.lead": "What the company contracted, what is included and how much of each limit is in use.",
  "plan.none": "No plan set yet: nothing is limited. Talk to Nuvvun to choose yours.",
  "plan.on_request": "On request",
  "plan.per_month": "{price}/month",
  "plan.usage": "Use right now",
  "plan.label.customers_month": "Customers served this month",
  "plan.label.channels": "WhatsApp numbers",
  "plan.label.members": "People",
  "plan.label.flows_published": "Published flows",
  "plan.label.assistants_active": "Active assistants",
  "plan.label.ai_usd_month": "Platform-paid AI this month",
  "plan.short.channels": "Numbers",
  "plan.short.ai_usd_month": "AI per month",
  "plan.feature.campaigns": "Campaigns",
  "plan.feature.api": "API and integrations",
  "plan.feature.gate": "Review of what is said before sending",
  "plan.feature.sso": "Sign-in with the company account (SSO)",
  "plan.feature.dedicated_db": "Database server of its own",
  "plan.extra_hint": "Beyond {quota} customers served in the month, each extra customer costs {price}.",
  "plan.change_hint": "To change plans, talk to Nuvvun. At a limit only new things are blocked: what already works keeps working.",
  "plan.no_limit": "{used} · no limit",
  "plan.used_of": "{used} of {limit}",
  "plan.limit.channels": "1 WhatsApp number|{count} WhatsApp numbers",
  "plan.limit.members": "1 person|{count} people",
  "plan.limit.flows_published": "1 published flow|{count} published flows",
  "plan.limit.assistants_active": "1 active assistant|{count} active assistants",
  "plan.limit.ai_usd_month": "US$ {max} of AI per month",
  "plan.limit.customers_month": "{max} customers served per month",
  "errors.plan_limit": "Your plan allows {what}. To get more, talk to Nuvvun. What already works keeps working.",
  "platform.plans.active": "Active",
  "platform.plans.inactive": "Inactive",
  "platform.plans.customers_count": "1 customer on this plan|{count} customers on this plan",
  "platform.plans.empty": "No plans yet.",
  "platform.plans.identity": "Plan",
  "platform.plans.description": "Description for the customer",
  "platform.plans.translations": "Name and description in English and Spanish",
  "platform.plans.name_en": "Name in English",
  "platform.plans.name_es": "Name in Spanish",
  "platform.plans.description_en": "Description in English",
  "platform.plans.description_es": "Description in Spanish",
  "platform.plans.sort": "Order in the list",
  "platform.plans.price": "Price",
  "platform.plans.monthly": "Monthly fee (R$)",
  "platform.plans.extra": "Each customer served beyond the quota (R$)",
  "platform.plans.price_hint": "Empty monthly fee = on request. Meta's messages are always separate: the customer pays Meta directly.",
  "platform.plans.unlimited": "No limit",
  "platform.plans.limits_hint": "Empty = no limit. The customer is warned from 80%, and at the limit only new things are blocked.",
  "platform.plans.features_hint": "Shown to the customer under Settings › Plan.",
  "platform.plans.hint.customers_month": "Contacts who wrote in the month, once each. Never blocks: the excess is billed.",
  "platform.plans.hint.channels": "Connected numbers. Blocks connecting one more.",
  "platform.plans.hint.members": "People with access, invitations included. Blocks inviting one more.",
  "platform.plans.hint.flows_published": "Blocks publishing one more flow.",
  "platform.plans.hint.assistants_active": "Blocks activating one more assistant.",
  "platform.plans.hint.ai_usd_month": "In dollars, only what the platform pays; the customer's own AI key does not count. At the limit, AI stops until the month turns.",
  "email.support.subject": "Nuvvun support entered {workspace}'s DoneTalk",
  "email.support.body_view": "{who}, from Nuvvun support, entered {workspace}'s DoneTalk to look only, until {until}.",
  "email.support.body_edit": "{who}, from Nuvvun support, entered {workspace}'s DoneTalk allowed to adjust settings, until {until}.",
  "email.support.reason": "Reason: {reason}",
  "email.support.button": "See or end the access",
  "email.support.why": "You get this notice because you own the account. Everything support does is in the Audit log, and you can turn support access off under Settings › Data and privacy.",
  "platform.support.enter": "Enter as support",
  "platform.support.open": "Open as support",
  "platform.support.until": "Support until {time}",
  "platform.support.end": "End access",
  "platform.support.title": "Enter {name} as support",
  "platform.support.lead": "The access is recorded for Nuvvun and for the customer, the owners get an e-mail and the customer can end it at any time.",
  "platform.support.reason": "Reason (the customer sees it)",
  "platform.support.reason_placeholder": "E.g. Maria asked for help setting up the welcome flow",
  "platform.support.duration": "For how long",
  "platform.support.minutes.30": "30 minutes",
  "platform.support.minutes.60": "1 hour",
  "platform.support.minutes.120": "2 hours",
  "platform.support.minutes.240": "4 hours",
  "platform.support.level": "What you can do",
  "platform.support.level.view": "Look only",
  "platform.support.level.edit": "Adjust settings",
  "platform.support.level_hint.view": "Sees everything like an auditor, without changing anything.",
  "platform.support.level_hint.edit": "Changes settings like an admin. Does not touch owners or the plan.",
  "platform.support.confirm": "Enter",
  "platform.support.off": "This customer turned support access off. One of their admins turns it back on under Settings › Data and privacy.",
  "platform.support.ended": "Support access ended.",
  "platform.action.support_started": "Support access started",
  "platform.action.support_ended": "Support access ended",
  "support.banner": "You are in {name} as Nuvvun support, {level}, until {time}",
  "support.leave": "End and leave",
  "support.title": "Nuvvun support access",
  "support.lead": "When you ask for help, someone from Nuvvun can come in for a limited time, with the reason recorded. Owners get an e-mail, everything is in the Audit log and you can end it at any time.",
  "support.allow": "Let Nuvvun support come in when needed",
  "support.none": "Nobody from support is here now.",
  "support.session": "{name} · {level} · until {time}",
  "support.session_reason": "Reason: {reason}",
  "support.end": "End",
  "support.level.view": "looking only",
  "support.level.edit": "allowed to adjust settings",
  "errors.support_access_off": "Support access is off for this customer.",
  "errors.customer_not_open": "This customer is not active now.",
  "errors.support_cannot_change_consent": "Only the company itself turns support access on or off.",
  "settings.find.support": "support nuvvun access help consent",
  "phone.ddi": "Country code",
  "phone.number": "Number",
  "phone.invalid": "Check the number. For this country it looks like {example}",
  "template.no_number": "No WhatsApp number connected yet. Templates come from the number's WhatsApp account: connect one to use them.",
  "template.connect_number": "Connect a number",
  "template.sync_now": "Sync with Meta",
  "template.create": "Create template",
  "template.synced": "1 template brought from Meta.|{count} templates brought from Meta.",
  "template.synced_none": "Meta returned no template for this account.",
  "mobile.tab.you": "You",
  "mobile.company": "Company",
  "mobile.switch_company": "Switch company",
  "mobile.mfa_setup": "To use the app, turn on two-step verification in DoneTalk on a computer (Security) and sign in again.",
  "mobile.soon": "Coming in the next version of the app.",
  "mobile.signin_title": "Sign in to DoneTalk",
  "mobile.today": "Today",
  "push.queue.title": "New conversation in the queue",
  "push.assigned.title": "Conversation assigned to you",
  "push.assigned.body": "{name} is now yours.",
  "push.campaign.title": "Campaign waiting for your approval",
  "push.cost.title": "Cost alert",
  "push.cost.body": "See Costs and limits.",
  "mobile.faceid": "Open with Face ID",
  "mobile.faceid_reason": "Unlock DoneTalk",
  "mobile.locked": "DoneTalk is locked.",
  "mobile.unlock": "Unlock",
  "mobile.notifications": "Notifications",
  "mobile.security": "Security and Face ID",
  "mobile.faceid_hint": "The app asks for Face ID when it opens and after a minute away.",
  "mobile.mfa_hint": "To turn it off or create new recovery codes, use DoneTalk on a computer.",
  "mobile.group.service_hint": "hours, outcomes…",
  "mobile.group.ai": "Automation and AI",
  "mobile.group.ai_hint": "flows, assistants…",
  "mobile.group.account": "Company account",
  "mobile.group.account_hint": "plan, costs…",
  "mobile.push.lead": "DoneTalk notifies this phone when:",
  "mobile.push.rule.message": "a message arrives in one of your conversations",
  "mobile.push.rule.queue": "a conversation enters your team's queue",
  "mobile.push.rule.assigned": "someone hands you a conversation",
  "mobile.push.rule.mention": "someone mentions you in a note",
  "mobile.push.rule.campaign": "a campaign is waiting for your approval",
  "mobile.push.rule.cost": "a cost limit is about to be reached",
  "mobile.push.presence": "The queue only notifies people who are Online. While you are Offline, messages and conversations handed to you stay silent; mentions, approvals and costs always notify.",
  "mobile.push.system": "Phone notification settings",
  "mobile.numbers.approved": "1 approved|{count} approved",
  "mobile.numbers.sending": "Sending",
  "mobile.numbers.sync_templates": "Sync templates",
  "mobile.numbers.connect_other": "Connect another number",
  "mobile.numbers.connect_hint": "Opens Meta's official window in a browser inside the app. You sign in to DoneTalk with your e-mail, then to the Facebook account that manages the company, pick the business portfolio and confirm the number by SMS.",
  "mobile.team.more": "Teams, hours and permissions",
  "mobile.team.role_changed": "Role changed",
  "mobile.flows.starts": "Starts when",
  "mobile.flows.trigger.channel_default": "A new conversation on the number",
  "mobile.flows.trigger.keyword": "A message with: {words}",
  "mobile.flows.trigger.out_of_hours": "A message outside business hours",
  "mobile.flows.trigger.api": "A call through the API",
  "mobile.flows.trigger.template_reply": "A reply to a template",
  "mobile.flows.trigger.assistant_tool": "The AI assistant starts the flow",
  "mobile.flows.trigger.manual": "A person starts the flow",
  "mobile.flows.trigger.none": "No trigger yet",
  "mobile.flows.version_line": "Version {n} published",
  "mobile.flows.draft_line": "draft with changes",
  "mobile.flows.not_published": "Not published yet",
  "mobile.flows.changed": "changed",
  "mobile.flows.other_blocks": "Other blocks",
  "mobile.flows.phone_note": "On the phone: view, test, publish, roll back and edit texts. To change paths and blocks, use a computer or an iPad.",
  "mobile.flows.edit_text": "Edit text",
  "mobile.flows.publish_confirm": "New conversations use the new version. Those already in the flow finish on the version they started with.",
  "mobile.flows.restore_confirm": "Go back to version {n}? It is published again, as a new version.",
  "mobile.flows.no_draft": "Nothing new to publish",
  "mobile.mfa_hint_off": "To turn it on, use DoneTalk on a computer: it shows the QR code for the authenticator app.",
  "contact.marketing": "Marketing messages",
  "contact.marketing_hint": "Marketing campaigns reach people who accept and people with no record. People who declined are left out.",
  "onboarding.guide.team.role_supervisor": "Supervisor: follows the queues, assigns, transfers and sees the reports.",
  "onboarding.guide.team.role_auditor": "Auditor: sees everything without changing anything.",
  "onboarding.guide.team.hours_next": "After the teams, link the business hours to them. Outside the hours, conversations wait in the queue.",
  "onboarding.guide.team.hours_cta": "Open business hours",
  "onboarding.guide.hours.title": "Business hours",
  "onboarding.guide.hours.text": "The questionnaire's hours are already saved here. They still need to be linked to the teams: outside them, conversations wait in the queue and the entry can send the away message.",
  "onboarding.guide.hours.no_teams": "There are no teams yet. Create the teams first and come back to link the hours.",
  "onboarding.guide.hours.without": "1 team has no hours yet.|{count} teams have no hours yet.",
  "onboarding.guide.hours.link": "Use these hours for the teams",
  "onboarding.guide.hours.linked": "Hours linked to 1 team.|Hours linked to {count} teams.",
  "onboarding.guide.hours.all_linked": "Every team already has hours.",
  "onboarding.guide.hours.where_title": "Different hours per team",
  "onboarding.guide.hours.where_text": "Create another schedule here and pick it on the team, in Team and people.",
  "onboarding.guide.hours.ready": "The hours saved and linked to the teams. It is recommended.",
  "onboarding.guide.whatsapp.ready": "The number is active. The display name is still under review, and it can be used meanwhile.",
  "onboarding.guide.optout.title": "People who do not want marketing",
  "onboarding.guide.optout.frequency_title": "Frequency and approval",
  "onboarding.guide.optout.frequency_text": "This same screen holds the gap between campaigns for the same contact and when a campaign needs approval. The defaults already protect the company; adjust them before the first campaign.",
  "onboarding.guide.optout.ready": "The words and the reply saved. It is recommended.",
  "onboarding.guide.optout.back_templates": "Back to templates",
  "onboarding.guide.budget.title": "Monthly budget",
  "onboarding.guide.budget.text": "Say how much the company may spend per month on Meta and AI. Without a budget nothing is limited: it is how to avoid a surprise on the bill before the campaigns.",
  "onboarding.guide.budget.limit_title": "What happens at the limit",
  "onboarding.guide.budget.limit_text": "Start with “Only notify” to learn the spend. Later, campaigns or every paid send can pause when the budget reaches 100%. Whoever manages costs gets the alerts.",
  "onboarding.guide.budget.short": "Set how much the company may spend per month on Meta and AI, and what happens near the limit.",
  "onboarding.guide.budget.cta": "Open costs and limits",
  "onboarding.guide.budget.ready": "A monthly budget saved for the company. It is recommended.",
  "onboarding.guide.knowledge.title": "Knowledge base",
  "onboarding.guide.knowledge.text": "What the assistant knows about the company: the website, PDFs and texts. It answers only with what is here.",
  "onboarding.guide.knowledge.ready_count": "1 document ready in the base.|{count} documents ready in the base.",
  "onboarding.guide.knowledge.none": "The assistant only counts as ready with at least one document in the knowledge base.",
  "onboarding.guide.knowledge.cta": "Open knowledge base",
  "onboarding.guide.knowledge.back": "Back to assistants",
  "onboarding.rehearsal.ready_text": "The test conversation closed with an outcome.",
  "onboarding.step.outbound.budget": "Monthly budget",
  "onboarding.when.outbound.budget": "Done when the company has a monthly budget.",
  "onboarding.done.outbound.budget": "Monthly budget set",
  "onboarding.lead.outbound.budget": "Set how much the company may spend per month on Meta and AI, and what happens near the limit.",
  "onboarding.detail.budget": "Up to {amount} a month",
  "onboarding.live.beyond.campaigns.title": "Campaigns",
  "onboarding.live.beyond.campaigns.text": "An approved template to a contact segment, with cost per reply and per sale.",
  "onboarding.live.beyond.costs.title": "Costs and limits",
  "onboarding.live.beyond.costs.text": "What Meta and AI cost, per number, team and campaign, with budget and alerts.",
  "onboarding.guide.hours.text_empty": "Create here the hours the company attends and link them to the teams: outside them, conversations wait in the queue and the entry can send the away message.",
  "onboarding.guide.hours.create_first": "Create the first schedule with “New schedule”. Then it can go to every team at once.",
  "push.number_code.title": "Your WhatsApp code arrived",
  "push.number_code.body": "{code} is the code for {number}.",
  "push.number_return.title": "Number not on WhatsApp yet",
  "push.number_return.body": "If {number} is not connected to WhatsApp, it is returned on {date}, free of charge.",
  "numbers.connect.two_paths": "Use a number the company already has, or get one right here.",
  "numbers.connect.own_title": "I already have a number",
  "numbers.connect.own_price": "No extra cost",
  "numbers.connect.own_time": "about 10 minutes",
  "numbers.connect.rent_title": "Get a number through DoneTalk",
  "numbers.connect.new": "New",
  "numbers.connect.rent_text": "A new mobile number just for the company's WhatsApp. No SIM card and no phone: Meta's code arrives here.",
  "numbers.connect.rent_ddd": "You choose the area code",
  "numbers.connect.rent_fast": "Ready in about 5 minutes",
  "numbers.connect.rent_app": "Works through DoneTalk; it cannot be used in the WhatsApp Business phone app",
  "numbers.connect.rent_cta": "Get a number",
  "numbers.connect.rent_ask": "Ask an Owner or Administrator",
  "numbers.connect.rent_billing": "with the plan, from activation on",
  "numbers.rent.title": "Get a number",
  "numbers.rent.lead": "Choose the area code. The number itself is drawn from those available.",
  "numbers.rent.search": "City, state or area code",
  "numbers.rent.ddds": "Available area codes",
  "numbers.rent.out_of_stock": "Area code {ddd} has no numbers right now. Try another or come back later.",
  "numbers.rent.none": "No area code found.",
  "numbers.rent.summary": "Mobile number with area code {ddd}",
  "numbers.rent.per_month": "{price} per month",
  "numbers.rent.cond_billing": "Billed with the plan from the day the number is activated on WhatsApp.",
  "numbers.rent.cond_owner": "The number is supplied by Nuvvun and stays with your company while you are a customer. If you leave, you can ask for the line to be transferred ({fee}).",
  "numbers.rent.cond_cancel": "You can cancel at any time: it takes effect at the end of the cycle, and the current month is charged in full.",
  "numbers.rent.cond_app": "It works only through DoneTalk, on WhatsApp's official API; it cannot be used in the WhatsApp Business phone app.",
  "numbers.rent.plan_place": "It counts toward the plan's number limit: this will be {n} of {max}.",
  "numbers.rent.plan_full": "The plan is at its number limit",
  "numbers.rent.sandbox": "Salvy's test environment: the number is fake, gets no real SMS and is not billed. Only Nuvvun's team sees this option.",
  "numbers.rent.accept": "I have read and accept the",
  "numbers.rent.terms": "conditions of the rented number",
  "numbers.rent.confirm": "Get it for {price}/month",
  "numbers.rent.done": "Number ready. Now connect it to WhatsApp.",
  "numbers.rented.awaiting": "Waiting for the code",
  "numbers.rented.sandbox": "Test (sandbox)",
  "numbers.rented.not_billed": "Not billed yet",
  "numbers.rented.your_number": "Your new number",
  "numbers.rented.copy_number": "Copy number",
  "numbers.rented.number_copied": "Number copied, without +55",
  "numbers.rented.phase1_title": "Now connect the number to WhatsApp",
  "numbers.rented.phase1_step1": "Click “Connect with Meta” and sign in with the Facebook of whoever manages the company.",
  "numbers.rented.phase1_step2": "When Meta asks for the number, choose to add a new number and paste the number above.",
  "numbers.rented.phase1_step3": "Choose to get the code by SMS (this number takes no calls).",
  "numbers.rented.phase1_step4": "Copy the code that shows up here and paste it in Meta's window.",
  "numbers.rented.phase1_hint": "If you need to stop, the number stays here. Billing starts only once it is active.",
  "numbers.rented.phase2_title": "Connect to the company's WhatsApp",
  "numbers.rented.phase2_lead": "In Meta's window you only pick the business and the WhatsApp account. DoneTalk adds the number, confirms the code and registers it, with nothing to type.",
  "numbers.rented.display_name": "Name customers will see",
  "numbers.rented.phase2_start": "Connect with Meta",
  "numbers.rented.step_rented": "Number rented with area code {ddd}",
  "numbers.rented.step_adding": "Adding the number to the WhatsApp account",
  "numbers.rented.step_requesting": "Asking Meta for the code",
  "numbers.rented.step_awaiting": "Waiting for the SMS with the code",
  "numbers.rented.step_verifying": "Confirming the code",
  "numbers.rented.step_registering": "Registering with the security PIN",
  "numbers.rented.phase2_failed": "It did not work: {reason}",
  "numbers.rented.retry": "Try again",
  "numbers.rented.returns": "If it is not connected to WhatsApp by {date}, the number is returned free of charge.",
  "numbers.rented.swap": "Swap the number",
  "numbers.rented.swap_confirm": "Return this number and get another? It has not been used, so nothing is charged.",
  "numbers.rented.simulate": "Simulate Meta's SMS",
  "numbers.rented.code_title": "WhatsApp code",
  "numbers.rented.code_at": "Arrived at {time} by SMS",
  "numbers.rented.copy_code": "Copy code",
  "numbers.rented.code_copied": "Code copied",
  "numbers.rented.code_arrived": "The WhatsApp code arrived",
  "numbers.rented.code_waiting": "Waiting for Meta's SMS…",
  "numbers.rented.code_waiting_hint": "It usually arrives within seconds. After 2 minutes, ask for another code in Meta's window.",
  "numbers.rented.raw_title": "Another SMS received|{count} other SMS received",
  "numbers.rented.code_app": "We also notify the phone app of whoever rented it.",
  "numbers.rented.by_donetalk": "Rented through DoneTalk",
  "numbers.rented.active_line": "{price}/month · active since {since} · next charge on {next}",
  "numbers.rented.cancel_line": "Cancellation scheduled: the number works until {date}.",
  "numbers.rented.transfer_line": "Transfer requested on {date}. DoneTalk's team will contact you; the number keeps working.",
  "numbers.rented.transferred_line": "The line was transferred to your company.",
  "numbers.rented.sms_title": "Codes and SMS received",
  "numbers.rented.sms_none": "No SMS received yet.",
  "numbers.rented.sms_code": "Code",
  "numbers.rented.undo": "Undo the cancellation",
  "numbers.rented.take": "Take the number",
  "numbers.rented.cancel": "Cancel the number",
  "numbers.rented.cancel_title": "Cancel the number {number}?",
  "numbers.rented.cancel_lead": "The cancellation takes effect at the end of the cycle.",
  "numbers.rented.cancel_1": "Until then the number keeps working as usual.",
  "numbers.rented.cancel_2": "At the end of the cycle, DoneTalk takes the number off WhatsApp and ends the line. Conversations stay in the history.",
  "numbers.rented.cancel_3": "For 6 months, DoneTalk gives this number to no other company.",
  "numbers.rented.cancel_4": "Once ended, the number does not come back. To keep it, ask for the transfer.",
  "numbers.rented.cancel_digits": "To confirm, type the number's last 4 digits",
  "numbers.rented.keep": "Keep the number",
  "numbers.rented.cancel_confirm": "Cancel at the end of the cycle",
  "numbers.rented.cancel_done": "Cancellation scheduled. You can undo it until the date.",
  "numbers.rented.take_title": "Take the number",
  "numbers.rented.take_lead": "To move the line into your company's name, with another carrier or outside DoneTalk.",
  "numbers.rented.take_1": "You send the request here.",
  "numbers.rented.take_2": "DoneTalk's team answers within 2 business days with what it needs (usually the company's tax ID and who signs).",
  "numbers.rented.take_3": "The number keeps working until the transfer is done.",
  "numbers.rented.take_fee": "Transfer fee: {fee}, charged once with the plan.",
  "numbers.rented.take_note": "Anything the team should know? (optional)",
  "numbers.rented.take_confirm": "Request the transfer",
  "numbers.rented.transfer_done": "Request sent. DoneTalk's team will contact you.",
  "errors.numbers_unavailable": "Getting numbers is not available right now. Try again shortly or contact Nuvvun.",
  "errors.area_code_out_of_stock": "This area code just ran out of numbers. Choose another.",
  "errors.numbers_provider_error": "The number's carrier did not answer. Try again shortly.",
  "errors.number_not_found": "Number not found.",
  "errors.number_not_cancellable": "This number cannot be cancelled now.",
  "errors.number_not_cancel_scheduled": "This number has no scheduled cancellation.",
  "errors.number_not_transferable": "A transfer can only be requested for an active number.",
  "errors.number_not_transfer_requested": "This number has no transfer request.",
  "errors.number_not_awaiting": "This number is already on WhatsApp.",
  "errors.auto_attach_off": "Automatic connection is not available yet. Use “Connect with Meta”.",
  "errors.attach_not_failed": "Nothing to retry.",
  "errors.sandbox_only": "Test environment only.",
  "plan.addon.title": "Add-ons",
  "plan.addon.numbers": "Numbers rented through DoneTalk",
  "plan.addon.count": "{count} × {price} this month|{count} × {price} this month",
  "plan.addon.awaiting": "waiting to be connected to WhatsApp, not billed yet",
  "plan.addon.since": "active since {date}",
  "plan.addon.ends": "cancellation scheduled, ends on {date}",
  "plan.addon.closed": "ended on {date}",
  "plan.addon.transferred": "transferred to the company",
  "plan.addon.total": "Month's total, without Meta's messages",
  "plan.addon.hint": "Meta's messages are still charged by Meta, straight to the company's card. The numbers add-on is billed by Nuvvun with the plan.",
  "plan.addon.rented_count": "1 rented through DoneTalk|{count} rented through DoneTalk",
  "platform.tab.numbers": "Rented numbers",
  "platform.lead.numbers": "The Salvy lines DoneTalk supplies to customers: who uses them, what they bring in and cost, and what is pending.",
  "platform.numbers.kpi.active": "Active",
  "platform.numbers.kpi.charged": "Charged this month",
  "platform.numbers.kpi.paid": "Paid to Salvy",
  "platform.numbers.kpi.margin": "Left this month",
  "platform.numbers.kpi.fees": "Transfer fees",
  "platform.numbers.filter.all": "All",
  "platform.numbers.filter.awaiting": "Waiting to connect",
  "platform.numbers.filter.cancel": "Cancellation scheduled",
  "platform.numbers.filter.transfer": "Transfer requested",
  "platform.numbers.filter.quarantine": "Quarantine",
  "platform.numbers.col.number": "Number",
  "platform.numbers.col.customer": "Customer",
  "platform.numbers.col.state": "State",
  "platform.numbers.col.next": "Next step",
  "platform.numbers.col.action": "Action",
  "platform.numbers.state.awaiting_code": "Waiting to connect to WhatsApp",
  "platform.numbers.state.active": "Active",
  "platform.numbers.state.cancel_scheduled": "Cancellation scheduled",
  "platform.numbers.state.transfer_requested": "Transfer requested",
  "platform.numbers.state.transferred": "Transferred",
  "platform.numbers.state.quarantine": "Quarantine",
  "platform.numbers.state.closed": "Ended",
  "platform.numbers.next.returns": "returned by itself on {date} if not connected",
  "platform.numbers.next.active": "billed since {date}",
  "platform.numbers.next.ends": "ends on {date}",
  "platform.numbers.next.transfer": "talk to the customer about the transfer",
  "platform.numbers.next.transferred": "transferred on {date}",
  "platform.numbers.next.free_on": "free on {date}",
  "platform.numbers.next.closed": "ended on {date}",
  "platform.numbers.mark_transferred": "Mark as transferred",
  "platform.numbers.cancel_cycle": "Cancel at the end of the cycle",
  "platform.numbers.cancel_now": "Cancel now",
  "platform.numbers.cancel_now_confirm": "Cancel {number} now? It leaves WhatsApp at once and enters the quarantine.",
  "platform.numbers.cancel_cycle_confirm": "Schedule the cancellation of {number} for the end of the cycle?",
  "platform.numbers.hint": "The quarantine applies inside DoneTalk: a quarantined number is never given to another customer; if Salvy draws one on a new rental, DoneTalk returns it and asks for another. Test (sandbox) lines stay out of the totals.",
  "platform.action.number_rented": "Number rented through DoneTalk",
  "platform.action.number_transfer_requested": "Number transfer requested",
  "platform.action.number_transferred": "Number transferred to the customer",
  "platform.action.number_cancelled": "Number cancelled by Nuvvun",
  "onboarding.q.number": "Which number will you use on the official WhatsApp?",
  "onboarding.q.number_hint": "No free number? DoneTalk supplies one, with the area code you choose.",
  "onboarding.number.app": "The WhatsApp Business app's number",
  "onboarding.number.own": "A free company number",
  "onboarding.number.rent": "I want one through DoneTalk",
  "onboarding.guide.rent_title": "No free number?",
  "onboarding.guide.rent_text": "Get one here for {price}/month. You choose the area code, Meta's code shows up on screen and you are done in about 5 minutes.",
  "onboarding.guide.rent_cta": "Get a number",
  "onboarding.guide.rented_title": "Your rented number is ready",
  "onboarding.guide.rented_text": "{number} still has to be connected to WhatsApp: follow the steps on the number's card. Meta's code shows up there.",
  "onboarding.guide.whatsapp.q_rent_app": "Can I use the rented number on my phone?",
  "onboarding.guide.whatsapp.a_rent_app": "No. It works only through DoneTalk, on the official API. To also answer from the phone app, connect the number you already use there.",
  "onboarding.guide.whatsapp.q_rent_owner": "Is the rented number mine?",
  "onboarding.guide.whatsapp.a_rent_owner": "It is supplied by Nuvvun and stays with your company while you are a customer. If you leave, you can ask for the line to be transferred.",
  "onboarding.detail.rented_waiting": "Number rented ({number}), still to connect at Meta",
  "mobile.numbers.rented_paste": "Paste the code in Meta's window, on the computer. Rented through DoneTalk; not billed yet.",
  "numbers.rented.code_received": "Code received",
  "plan.addon.count_none": "Nothing charged this month yet",
  "numbers.rent.plan_full_line": "The plan already uses the {max} numbers it allows. To get another, talk to Nuvvun about changing plans.",
  "page.unsaved_bar": "You have unsaved changes",
  "platform.ai.base_url": "API address (optional)",
  "platform.ai.default_key": "Default key for this provider",
  "platform.ai.auto": "Automatic",
  "platform.ai.manual": "Chosen by hand",
  "platform.ai.back_to_auto": "back to automatic",
  "platform.ai.task_retiring": "{model} retires on {date}; its replacement is {next}.",
  "platform.ai.task_manual_until": "{model} retires on {date}. Chosen by hand, it stays until then and then moves to {next}.",
  "platform.ai.task_retiring_alone": "{model} retires on {date} and has no replacement yet. Choose another model.",
  "platform.ai.task_replaced": "Switched automatically from {from} on {date}.",
  "platform.ai.task_moved": "{task}: {from} → {to} (retirement announced)",
  "platform.ai.task_moved_retired": "{task}: {from} → {to} (model retired)",
  "platform.ai.catalog_added": "{count} new model in the catalog|{count} new models in the catalog",
  "platform.ai.replaced_by": "replacement: {model}",
  "platform.ai.col.mode": "Kind",
  "platform.ai.mode.chat": "Chat",
  "platform.ai.mode.embedding": "Embeddings",
  "platform.ai.mode.audio_transcription": "Transcription",
  "platform.ai.surfaces_hint": "Automatic: when the provider announces a model's retirement, the task moves to its replacement by itself. Choosing a model here keeps that choice until the retirement day; from that day on, calls go to the replacement, customers' choices included.",
  "builder.arrange": "Tidy up",
  "builder.arrange_selection": "Tidy up selection",
  "builder.arrange_hint": "Lays the blocks out left to right with fewer crossing lines and fits the whole flow on screen (Shift+Alt+T). With several blocks selected, only those.",
  "builder.arranged": "Blocks tidied up",
  "builder.selection_count": "{count} block selected|{count} blocks selected",
  "builder.duplicate": "Duplicate",
  "builder.duplicated": "{count} block duplicated|{count} blocks duplicated",
  "builder.delete_selected": "Delete",
  "builder.deleted_many": "{count} block deleted|{count} blocks deleted",
  "builder.clear_selection": "Clear selection",
  "builder.canvas_hint": "Shift or ⌘/Ctrl + click picks several · let a link go on empty canvas to create the next block · ⌨ shows the shortcuts",
  "onboarding.guide.payment_done": "Set up. Meta confirms the number can send.",
  "onboarding.guide.payment_done_at": "Set up. Meta confirmed the number can send in the check of {when}.",
  "onboarding.guide.payment_change": "See or change the card at Meta",
  "onboarding.guide.payment_after": "After adding it, click “Check now” on the number's card: the step is done once Meta confirms.",
  "tags.pill.label": "Tags: {names}",
  "tags.menu.manage": "Manage tags",
  "tags.panel.close": "Close tags",
  "tags.panel.people": "{count} contact|{count} contacts",
  "tags.panel.empty": "No tags yet",
  "tags.panel.empty_hint": "Create tags such as Lead or Payment pending to group people and filter conversations by them.",
  "tags.editor.new": "Create new tag",
  "tags.editor.edit": "Edit tag",
  "tags.editor.name": "Tag name",
  "tags.editor.color": "Choose the color",
  "tags.editor.suggestions": "Suggestions",
  "tags.editor.people": "People included",
  "tags.editor.add_people": "Add people",
  "tags.editor.remove_person": "Remove {name} from the tag",
  "tags.editor.create": "Create tag",
  "tags.editor.archive": "Archive tag",
  "tags.editor.archive_hint": "It leaves the filters and lists; reports keep it.",
  "tags.editor.archived": "Tag archived",
  "tags.editor.created": "Tag created",
  "tags.editor.saved": "Tag saved",
  "tags.editor.exists": "A tag with this name already exists",
  "tags.picker.search": "Search name or number",
  "tags.picker.add": "Add ({count})",
  "tags.picker.empty": "No one found",
  "tags.filter.empty": "No one has this tag",
  "tags.filter.empty_hint": "Use the tag button at the top of a conversation to add someone.",
  "tags.suggest.new_customer": "New customer",
  "tags.suggest.new_order": "New order",
  "tags.suggest.payment_pending": "Payment pending",
  "tags.suggest.follow_up": "Follow up",
  "tags.suggest.paid": "Paid",
  "tags.suggest.order_done": "Order completed",
  "tags.suggest.lead": "Lead",
  "tags.suggest.important": "Important",
  "permission.tags.manage": "Create and edit tags",
  "permission.appointments.read": "See agendas and appointments",
  "permission.appointments.write": "Book, move and cancel for contacts",
  "permission.scheduling.manage": "Set up agendas, hours and notices",
  "permissions.group.scheduling": "Scheduling",
  "plan.label.agendas": "Agendas",
  "plan.label.appointment_types": "Appointment types",
  "plan.limit.agendas": "1 agenda|{count} agendas",
  "plan.limit.appointment_types": "1 appointment type|{count} appointment types",
  "platform.plans.hint.agendas": "Active agendas. Blocks creating one more.",
  "platform.plans.hint.appointment_types": "Active appointment types. Blocks creating one more.",
  "integrations.event.appointment.booked": "Appointment booked",
  "integrations.event.appointment.rescheduled": "Appointment rescheduled",
  "integrations.event.appointment.cancelled": "Appointment cancelled",
  "integrations.event.appointment.confirmed": "Appointment confirmed",
  "integrations.event.appointment.attended": "Attended the appointment",
  "integrations.event.appointment.no_show": "Missed the appointment",
  "push.appointment.booked": "New appointment",
  "push.appointment.rescheduled": "Appointment rescheduled",
  "push.appointment.cancelled": "Appointment cancelled",
  "push.appointment.unconfirmed": "The customer didn't confirm",
  "push.appointment.change_requested": "The customer wants to change the time",
  "push.appointment.confirmed": "The customer confirmed",
  "push.appointment.summary": "Your agenda today",
  "push.appointment.summary_body": "1 appointment|{count} appointments",
  "mail.appointment.booked": "New appointment: {contact} · {type} · {when}",
  "mail.appointment.rescheduled": "Appointment moved: {contact} · {type} · {when}",
  "mail.appointment.cancelled": "Appointment cancelled: {contact} · {type} · {when}",
  "mail.appointment.add": "Add it to your calendar: {link}",
  "date.previous_month": "Previous month",
  "date.next_month": "Next month",
  "node.schedule": "Book",
  "node.schedule.type": "Agenda and type",
  "node.schedule.no_types": "Create an agenda with an appointment type in Settings › Agendas.",
  "node.schedule.body": "Text before the times",
  "node.schedule.body_placeholder": "Pick a time for your visit:",
  "node.schedule.mode": "How to show the times",
  "node.schedule.mode.list": "WhatsApp list",
  "node.schedule.mode.calendar": "WhatsApp calendar",
  "node.schedule.mode.buttons": "Buttons",
  "node.schedule.mode_hint.list": "Up to 8 times at once, with \"Other times\" and \"None of these\".",
  "node.schedule.mode_hint.calendar": "The person picks the day, then the time, on a calendar inside WhatsApp. Turn on the WhatsApp calendar in the agenda; without it, the list goes.",
  "node.schedule.mode_hint.buttons": "The 2 best options and \"Other times\".",
  "node.schedule.answer": "Answer to \"{question}\"",
  "node.schedule.hint": "Confirmation, reminders and rescheduling rules come from the agenda; the block only offers and books.",
  "builder.exit_booked": "Booked",
  "builder.exit_declined": "No time works",
  "builder.exit_no_times": "No free times",
  "simulator.schedule_offer": "Would offer the free times (in the test, sample times)",
  "simulator.schedule_book": "Would book {when} (in the test, nothing is booked)",
  "assistants.tab.agenda": "Scheduling",
  "assistants.agenda.title": "Scheduling",
  "assistants.agenda.lead": "When the customer wants to book, {name} checks the agenda, offers free times and books the one they choose.",
  "assistants.agenda.on": "Book in the agenda",
  "assistants.agenda.on_hint": "See free times, book, move, cancel and see the customer's appointments.",
  "assistants.agenda.types": "Can book",
  "assistants.agenda.duration": "{min} min",
  "assistants.agenda.no_types": "There are no agendas with appointment types yet.",
  "assistants.agenda.open_agendas": "Open Agendas",
  "assistants.agenda.all_types": "None ticked: it can book any of them.",
  "assistants.agenda.some_types": "Only the ticked types.",
  "assistants.agenda.how": "How it offers",
  "assistants.agenda.offer": "Offer",
  "assistants.agenda.offer_label": "How many times",
  "assistants.agenda.times": "1 time|{count} times",
  "assistants.agenda.at_a_time": "at a time,",
  "assistants.agenda.prefer": "preferably",
  "assistants.agenda.prefer_label": "Preference",
  "assistants.agenda.prefer_any": "the first free ones",
  "assistants.agenda.prefer_days": "within the next day|within the next {count} days",
  "assistants.agenda.shown_as": "shown as",
  "assistants.agenda.shown_as_label": "How to show",
  "assistants.agenda.present.list": "a WhatsApp list",
  "assistants.agenda.present.text": "text in the reply",
  "assistants.agenda.before": "Before booking,",
  "assistants.agenda.before_label": "Before booking",
  "assistants.agenda.confirm_yes": "repeat day, time and place and wait for a yes",
  "assistants.agenda.confirm_no": "book as soon as the customer picks",
  "assistants.agenda.refusals": "If none works",
  "assistants.agenda.refusals_label": "How many times",
  "assistants.agenda.refusal_n": "the first time|the {count}th time",
  "assistants.agenda.handoff": "hand over to a person ({team}).",
  "assistants.agenda.can_find": "See free times: only times that really exist; it never invents or calculates a date.",
  "assistants.agenda.can_book": "Book: only a time from the list. If someone took it first, it offers others.",
  "assistants.agenda.can_move": "Reschedule: within the type's rules (e.g. up to 4 h before).",
  "assistants.agenda.can_cancel": "Cancel: when the customer asks, within the type's rules.",
  "assistants.agenda.can_list": "See the customer's appointments: to answer \"what time is my visit?\".",
  "assistant.tool.scheduling": "Scheduling",
  "assistant.tool_hint.scheduling": "See free times and book appointments.",
  "assistants.test.appointment_book": "Would book: {detail} (in the test, nothing is booked)",
  "assistants.test.appointment_reschedule": "Would move: {detail}",
  "assistants.test.appointment_cancel": "Would cancel: {detail}",
  "templates.header.location": "Location (map)",
  "templates.header.location_hint": "Each send brings the place (e.g. the appointment's address), shown as a map on top.",
  "templates.header.location_preview": "The place's map",
  "push.appointment.calendar_changed": "The event changed in your calendar: the customer will pick another time",
  "event.appointment_booked": "Appointment booked: {type} · {when}",
  "event.appointment_booked_with": "Appointment booked: {type} · {when} · with {name}",
  "event.appointment_rescheduled": "Appointment moved: {type} · {when}",
  "event.appointment_cancelled": "Appointment cancelled: {type} · {when}",
  "event.appointment_confirmed": "The customer confirmed: {type} · {when}",
  "event.appointment_attended": "Attended: {type} · {when}",
  "event.appointment_no_show": "Missed: {type} · {when}",
  "event.appointment_unconfirmed": "No confirmation from the customer: {type} · {when}",
  "event.appointment_change_requested_move": "The customer wants to move it after the deadline: {type} · {when}",
  "event.appointment_change_requested_cancel": "The customer wants to cancel after the deadline: {type} · {when}",
  "event.appointment_calendar_changed": "The event changed in the attendee's calendar: talk to the customer about {type} · {when}",
  "event.appointment_calendar_changed_asked": "The event changed in the attendee's calendar; we asked the customer for a new time for {type}",
  "nav.agenda": "Calendar",
  "agendaview.title": "Calendar",
  "agendaview.book": "Book",
  "agendaview.busy": "Busy",
  "agendaview.busy_where": "{calendar} · {name}",
  "agendaview.day_empty": "Nothing booked",
  "agendaview.empty": "There are no calendars yet",
  "agendaview.empty_hint": "Create one in Settings › Calendars to book appointments with customers.",
  "agendaview.empty_action": "Create a calendar",
  "agendaview.filter.agenda": "Calendar",
  "agendaview.filter.all_agendas": "All calendars",
  "agendaview.filter.all_people": "Everyone",
  "agendaview.filter.me": "{name} (you)",
  "agendaview.filter.person": "Person",
  "agendaview.go_to": "Go to day",
  "agendaview.legend": "Legend",
  "agendaview.legend.confirmed": "Confirmed",
  "agendaview.legend.booked": "Waiting for the customer",
  "agendaview.legend.no_show": "No-show",
  "agendaview.legend.busy": "Busy in Google/Outlook",
  "agendaview.next_week": "Next week",
  "agendaview.previous_week": "Previous week",
  "agendaview.provider.google": "Google",
  "agendaview.provider.microsoft": "Outlook",
  "agendaview.provider.caldav": "iCloud/CalDAV",
  "agendaview.provider.ics": "Calendar link",
  "agendaview.today": "Today",
  "agendaview.tomorrow": "Tomorrow",
  "agendaview.week": "Week",
  "agendaview.week_of": "{from} to {to}",
  "agendaview.zone_note": "Times in the {zone} time zone",
  "agendaview.demo.week": "The team's week (WeekView)",
  "agendaview.demo.week_hint": "Overlapping appointments sit side by side; the red line is the current time; busy time from Google/Outlook is striped. On a phone it becomes a list of days.",
  "agendaview.demo.slots": "Free times (SlotGrid)",
  "agendaview.demo.slots_hint": "Arrow keys move between times; Enter picks one.",
  "agendaview.demo.panel": "An open appointment (AppointmentPanel)",
  "appointment.status.booked": "Waiting for the customer",
  "appointment.status.confirmed": "Confirmed",
  "appointment.status.cancelled": "Cancelled",
  "appointment.status.attended": "Attended",
  "appointment.status.no_show": "No-show",
  "appointment.panel": "Appointment",
  "appointment.loading": "Loading…",
  "appointment.when": "When",
  "appointment.when_value": "{day} {date}, {start}–{end}",
  "appointment.with": "With",
  "appointment.contact": "Customer",
  "appointment.where": "Where",
  "appointment.join": "Join the call",
  "appointment.cancel_reason": "Reason",
  "appointment.moved": "Rescheduled",
  "appointment.moved_count": "once|{count} times",
  "appointment.open_conversation": "Open the conversation",
  "appointment.reschedule": "Reschedule",
  "appointment.confirm_for_contact": "Confirm for the customer",
  "appointment.attended": "Attended",
  "appointment.no_show": "No-show",
  "appointment.cancel": "Cancel",
  "appointment.answers": "Answers",
  "appointment.notes": "Team note",
  "appointment.notes_label": "Only the team sees it",
  "appointment.notes_saved": "Note saved",
  "appointment.story": "What happened",
  "appointment.by.member": "by {name}",
  "appointment.by.team": "by someone on the team",
  "appointment.by.assistant": "by the assistant {name}",
  "appointment.by.assistant_unnamed": "by the AI assistant",
  "appointment.by.flow": "by the flow {name}",
  "appointment.by.flow_unnamed": "by a flow",
  "appointment.by.api": "by an integration",
  "appointment.by.contact": "by the customer",
  "appointment.by.system": "by DoneTalk",
  "appointment.history.booked": "Booked {by}",
  "appointment.history.rescheduled": "Rescheduled {by}",
  "appointment.history.cancelled": "Cancelled {by}",
  "appointment.history.confirmed": "Confirmed {by}",
  "appointment.history.attended": "Attendance recorded {by}",
  "appointment.history.no_show": "No-show recorded {by}",
  "appointment.history.confirmed_by_contact": "The customer tapped Confirm",
  "appointment.notice.confirmation": "Confirmation",
  "appointment.notice.confirm_request": "Confirmation request",
  "appointment.notice.reminder": "Reminder",
  "appointment.notice.rescheduled": "New time notice",
  "appointment.notice.cancelled": "Cancellation notice",
  "appointment.notice.no_show": "“We missed you” message",
  "appointment.notice.confirm_deadline": "Deadline for the customer to confirm",
  "appointment.notice.sent.confirmation": "Confirmation sent",
  "appointment.notice.sent.confirm_request": "Confirmation request sent",
  "appointment.notice.sent.reminder": "Reminder sent",
  "appointment.notice.sent.rescheduled": "New time notice sent",
  "appointment.notice.sent.cancelled": "Cancellation notice sent",
  "appointment.notice.sent.no_show": "“We missed you” message sent",
  "appointment.notice.deadline_passed": "The deadline for the customer to confirm passed",
  "appointment.notice.failed": "{name}: not sent",
  "appointment.notice.skipped": "{name}: not needed",
  "appointment.calendar.synced": "In {name}'s {calendar} calendar",
  "appointment.calendar.pending": "Going to {name}'s {calendar} calendar",
  "appointment.calendar.failed": "Couldn't be added to {name}'s {calendar} calendar",
  "appointment.cancel_title": "Cancel the appointment",
  "appointment.cancel_lead": "{when}. The time becomes free again.",
  "appointment.cancel_reason_label": "Reason (optional)",
  "appointment.cancel_notify": "Tell the customer on WhatsApp",
  "appointment.cancel_notify_hint": "The calendar's cancellation notice goes out.",
  "appointment.cancel_keep": "Back",
  "appointment.cancel_confirm": "Cancel appointment",
  "appointment.cancelled_toast": "Appointment cancelled",
  "appointment.marked.confirmed": "Confirmed for the customer",
  "appointment.marked.attended": "Attendance recorded",
  "appointment.marked.no_show": "No-show recorded",
  "appointment.contact_title": "Appointments",
  "appointment.contact_empty": "No appointments yet.",
  "appointment.book": "Book",
  "appointment.more_past": "Show 1 more past one|Show {count} more past ones",
  "appointment.fewer_past": "Show fewer",
  "appointment.place.contact_field": "The customer's address",
  "appointment.place.online_google_meet": "Online, on Google Meet",
  "appointment.place.online_teams": "Online, on Microsoft Teams",
  "appointment.place.online_link": "Online, by link",
  "appointment.place.phone": "By phone",
  "appointment.place.to_agree": "Place to be agreed",
  "appointment.error.slot_taken": "That time was just taken. Pick another one.",
  "appointment.error.contact_has_appointment": "This customer already has an appointment of this type.",
  "appointment.error.agenda_inactive": "This calendar is paused or turned off.",
  "appointment.error.agenda_has_no_people": "No one attends in this calendar yet.",
  "appointment.error.appointment_closed": "This appointment was already cancelled or finished.",
  "appointment.error.appointment_not_started": "You can mark attended or no-show only after it starts.",
  "appointment.error.appointment_not_found": "This appointment no longer exists.",
  "appointment.error.contact_not_found": "This contact no longer exists.",
  "appointment.error.member_not_in_agenda": "This person doesn't attend in this calendar.",
  "book.action": "Book an appointment",
  "book.title": "Book with {name}",
  "book.title_pick": "Book an appointment",
  "book.title_reschedule": "Reschedule with {name}",
  "book.pick_hint": "Who is the appointment for?",
  "book.pick_search": "Search contacts",
  "book.pick_empty": "No contacts found.",
  "book.for": "For",
  "book.change_contact": "Change",
  "book.from_when": "Current time:",
  "book.no_types": "No active appointment types. Create one in Settings › Calendars.",
  "book.type": "Calendar and type",
  "book.who": "Who attends",
  "book.anyone": "Anyone free",
  "book.together": "Everyone together",
  "book.required": "{label} (required)",
  "book.slots": "Free times",
  "book.loading": "Looking for free times…",
  "book.no_slots": "No free times in the coming days.",
  "book.more_times": "+1 time|+{count} times",
  "book.all_times": "Show all times",
  "book.fewer_times": "Show fewer times",
  "book.days_before": "Earlier days",
  "book.days_after": "Next days",
  "book.days_range": "{from} to {to}",
  "book.more": "See more days or pick another time",
  "book.other_title": "Pick another time",
  "book.other_hint": "Works outside the free times too. It's refused only when the person already has something at that time.",
  "book.other_day": "Day",
  "book.other_time": "Time",
  "book.taken": "Someone just booked that time. These are still free:",
  "book.has_one": "{name} already has an appointment of this type.",
  "book.open_existing": "Open the appointment",
  "book.note_window_open": "The confirmation goes out by itself on WhatsApp as a normal message, since the conversation is open (free up to 1,000 a month per number).",
  "book.note_template": "The confirmation goes out by itself on WhatsApp, with the Meta-approved template.",
  "book.note_unknown": "The confirmation goes out by itself on WhatsApp: as a normal message if the conversation is open, otherwise with the Meta-approved template.",
  "book.note_rescheduled": "The new time notice goes to the customer on WhatsApp by itself.",
  "book.note_off": "This calendar doesn't send this notice on WhatsApp (it's off in the calendar's notices).",
  "book.summary_when": "{day}, {date}, {start} to {end}",
  "book.summary_anyone": "whoever is free",
  "book.summary_calendar": "It goes to {name}'s {calendar} calendar and the reminders go out by themselves.",
  "book.summary_donetalk": "It stays in the DoneTalk calendar and the reminders go out by themselves.",
  "book.summary_reminders": "The reminders go out by themselves.",
  "book.submit": "Book",
  "book.submit_reschedule": "Reschedule",
  "book.done": "Booked: {when}",
  "book.done_rescheduled": "Rescheduled: {when}",
  "report.agenda.tab": "Calendar",
  "report.agenda.agenda": "Calendar",
  "report.agenda.all": "All calendars",
  "report.agenda.export": "Export CSV",
  "report.agenda.loading": "Calculating…",
  "report.agenda.kpi.booked": "Booked",
  "report.agenda.kpi.vs_previous": "{change} vs. the previous period",
  "report.agenda.kpi.no_previous": "Nothing in the previous period",
  "report.agenda.kpi.confirmed": "Confirmed",
  "report.agenda.kpi.by_button": "{rate} with the request's button",
  "report.agenda.kpi.no_show": "No-shows",
  "report.agenda.kpi.no_show_count": "1 no-show|{count} no-shows",
  "report.agenda.kpi.to_book": "From the first “hi” to booking",
  "report.agenda.kpi.to_book_hint": "with the assistant (median)",
  "report.agenda.kpi.meta": "Meta messages",
  "report.agenda.kpi.per_appointment": "{value} per appointment",
  "report.agenda.minutes": "1 min|{count} min",
  "report.agenda.hours": "{h} h {m} min",
  "report.agenda.sources": "Who booked",
  "report.agenda.source.assistant": "AI assistant",
  "report.agenda.source.flow": "Flows",
  "report.agenda.source.member": "Team members",
  "report.agenda.source.contact": "The customer",
  "report.agenda.source.api": "Integrations",
  "report.agenda.outcomes": "How they ended",
  "report.agenda.outcome.attended": "Attended",
  "report.agenda.outcome.rescheduled": "Rescheduled",
  "report.agenda.outcome.cancelled": "Cancelled",
  "report.agenda.outcome.noShow": "No-shows",
  "report.agenda.people": "By person",
  "report.agenda.col.person": "Person",
  "report.agenda.col.booked": "Booked",
  "report.agenda.col.confirmed": "Confirmed",
  "report.agenda.col.no_show": "No-shows",
  "report.agenda.col.sales": "Became sales",
  "report.agenda.empty": "No appointments in this period.",
  "report.agenda.sales_hint": "“Became sales”: the customer's conversations closed with a success outcome within 30 days after the appointment.",
  "settings.agendas": "Calendars",
  "settings.my_calendar": "My calendar",
  "settings.find.agendas": "calendar booking schedule appointment visit meeting reservation agenda",
  "settings.find.agenda_types": "appointment type duration visit consultation rules notice buffer",
  "settings.find.agenda_notices": "reminder notice confirmation whatsapp template reschedule cancel no-show",
  "settings.find.my_calendar": "my calendar google outlook icloud connect busy agenda",
  "settings.find.my_calendar_connect": "connect google outlook microsoft icloud apple caldav ics link calendar",
  "agendas.lead": "Where the assistant, the flows and the team book appointments with customers. Each calendar says who attends, when and how.",
  "agendas.new": "New calendar",
  "agendas.new_title": "New calendar",
  "agendas.new_hint": "It starts open Monday to Friday, 09:00–12:00 and 13:00–18:00. You can change everything afterwards.",
  "agendas.create": "Create calendar",
  "agendas.created": "Calendar created",
  "agendas.empty": "No calendars yet. Create the first one so the assistant, the flows and the team can book times.",
  "agendas.field.name": "Calendar name",
  "agendas.field.name_placeholder": "E.g. Property visits",
  "agendas.field.person": "Who attends",
  "agendas.kind.team": "A team",
  "agendas.kind.person": "One person",
  "agendas.kind.resource": "A place or resource",
  "agendas.kind_hint.team": "Several people attend, taking turns or together.",
  "agendas.kind_hint.person": "Only one person attends: a doctor, a consultant.",
  "agendas.kind_hint.resource": "A room, a piece of equipment: it only holds the time.",
  "agendas.state.active": "Active",
  "agendas.state.off": "Off",
  "agendas.state.paused": "Paused until {day}",
  "agendas.banner.title": "Your calendar is not connected yet",
  "agendas.banner.text": "Connect Google, Outlook or iCloud so nobody books anything on top of your appointments.",
  "agendas.banner.action": "Connect my calendar",
  "agendas.card.who": "Who attends",
  "agendas.card.types_title": "Types",
  "agendas.card.next": "Next free time",
  "agendas.card.this_week": "This week",
  "agendas.card.who_resource": "Resource: time only",
  "agendas.card.who_nobody": "Nobody yet",
  "agendas.card.who_fixed": "one fixed person",
  "agendas.card.who_round_robin": "turns among 1 person|turns among {count}",
  "agendas.card.who_owner": "whoever already serves the customer",
  "agendas.card.who_collective": "1 person|{count} people together",
  "agendas.card.types": "1 type|{count} types",
  "agendas.card.no_types": "No types yet",
  "agendas.card.none_free": "Nothing free in the coming days",
  "agendas.card.week": "1 booked · {missed}|{count} booked · {missed}",
  "agendas.card.missed": "1 no-show|{count} no-shows",
  "agendas.card.week_none": "Nothing booked",
  "agendas.card.calendar": "{provider} · {people}",
  "agendas.card.people": "1 person|{count} people",
  "agendas.card.only_here": "Only in DoneTalk",
  "agendas.card.reminders": "Notices: {list}",
  "agendas.card.and": " and ",
  "agendas.card.asks_confirmation": "Asks for confirmation",
  "agenda.tab.hours": "Hours",
  "agenda.tab.types": "Appointment types",
  "agenda.tab.people": "Who attends",
  "agenda.tab.calendars": "Connected calendars",
  "agenda.tab.notices": "Notices and reminders",
  "agenda.menu.rename": "Rename",
  "agenda.menu.turn_off": "Turn calendar off",
  "agenda.menu.turn_on": "Turn calendar on",
  "agenda.menu.delete": "Delete calendar",
  "agenda.off_done": "Calendar turned off. Nothing new is booked in it.",
  "agenda.on_done": "Calendar turned on.",
  "agenda.delete.title": "Delete {name}?",
  "agenda.delete.text": "The assistant, the flows and the team stop booking in it. If it already has appointments, it is only turned off and the history stays.",
  "agenda.delete.confirm": "Delete calendar",
  "agenda.delete.done": "Done. If the calendar had appointments, it was turned off to keep the history.",
  "agenda.pause.action": "Pause calendar",
  "agenda.pause.title": "Pause the calendar",
  "agenda.pause.text": "While it is paused, nobody books anything new in it. Appointments already booked stay.",
  "agenda.pause.until": "Paused until (inclusive)",
  "agenda.pause.confirm": "Pause",
  "agenda.pause.done": "Calendar paused until {day}.",
  "agenda.pause.resume": "Resume",
  "agenda.pause.resumed": "Calendar resumed.",
  "agenda.save.bad_hours": "Some time ranges are out of order or overlap. Fix the ones marked in red.",
  "agenda.save.pick_hours": "Choose which business hours this calendar uses.",
  "agenda.save.event_title": "Write the event title in Connected calendars.",
  "agenda.save.type": "Type {name}: {problem}",
  "agenda.undo": "Undo",
  "agenda.time.minutes": "{m} min",
  "agenda.time.hours": "{h} h",
  "agenda.time.hours_minutes": "{h} h {m} min",
  "agenda.time.days": "1 day|{count} days",
  "agenda.time.before": "{time} before",
  "agenda.time.at_start": "up to the start",
  "agenda.when.today": "Today, {time}",
  "agenda.when.tomorrow": "Tomorrow, {time}",
  "agenda.when.day": "{day}, {time}",
  "agenda.ago.now": "just now",
  "agenda.ago.minutes": "{n} min ago",
  "agenda.ago.hours": "{n} h ago",
  "agenda.ago.day": "on {day}",
  "agenda.ago.never": "never",
  "agenda.hours.title": "When this calendar takes appointments",
  "agenda.hours.mode.business_hours": "The business hours",
  "agenda.hours.mode.own": "The calendar's own hours",
  "agenda.hours.mode.per_person": "Each person has their own",
  "agenda.hours.mode_hint.business_hours": "The same days and hours as one of the team's business hours.",
  "agenda.hours.mode_hint.own": "A week just for this calendar.",
  "agenda.hours.mode_hint.per_person": "Each person has their week in Who attends.",
  "agenda.hours.which": "Which business hours",
  "agenda.hours.no_business_hours": "There are no business hours yet.",
  "agenda.hours.open_business_hours": "Create in Business hours",
  "agenda.hours.per_person_hint": "Each person can have their own week in Who attends. Whoever has none uses the week below.",
  "agenda.hours.open_people": "Open Who attends",
  "agenda.weekly.add": "+ range",
  "agenda.weekly.copy": "Copy Monday to the weekdays",
  "agenda.weekly.from": "Start ({day})",
  "agenda.weekly.to": "End ({day})",
  "agenda.weekly.remove": "Remove the range ({day})",
  "agenda.weekly.order": "The end must come after the start.",
  "agenda.weekly.overlap": "Two ranges overlap on this day.",
  "agenda.override.title": "Special dates and exceptions",
  "agenda.override.lead": "A holiday, different hours on a day, someone's vacation. It overrides the week's rules.",
  "agenda.override.add": "Add date",
  "agenda.override.add_title": "Special date",
  "agenda.override.added": "Date added",
  "agenda.override.none": "No special dates.",
  "agenda.override.closed": "Closed",
  "agenda.override.closed_hint": "Nothing is offered on these days.",
  "agenda.override.other_hours": "Other hours",
  "agenda.override.other_hours_hint": "On these days, only in these ranges.",
  "agenda.override.only": "Only {ranges}",
  "agenda.override.person_off": "{name} away (only this person leaves the turns)",
  "agenda.override.everyone": "The whole calendar",
  "agenda.override.who": "Applies to",
  "agenda.override.from": "From",
  "agenda.override.to": "To",
  "agenda.override.span": "{from} to {to}",
  "agenda.override.note": "Reason (optional)",
  "agenda.override.note_placeholder": "E.g. Christmas, vacation",
  "agenda.override.range_from": "Start",
  "agenda.override.range_to": "End",
  "agenda.override.range_remove": "Remove the range",
  "agenda.override.save": "Add",
  "agenda.override.remove": "Remove the date",
  "agenda.override.removed": "Date removed",
  "agenda.holidays.label": "Close on national holidays by itself",
  "agenda.holidays.hint": "Nothing is offered on those days. For a holiday in your city, use Add date.",
  "agenda.holidays.optional": "Also on Carnival and Corpus Christi (optional days off in Brazil)",
  "agenda.tz.title": "Time zone",
  "agenda.tz.contact": "Show the customer their own time zone when it is different",
  "agenda.tz.america_sao_paulo": "São Paulo, Rio and Brasília",
  "agenda.tz.america_manaus": "Manaus",
  "agenda.tz.america_belem": "Belém",
  "agenda.tz.america_fortaleza": "Fortaleza",
  "agenda.tz.america_recife": "Recife",
  "agenda.tz.america_cuiaba": "Cuiabá",
  "agenda.tz.america_rio_branco": "Rio Branco (Acre)",
  "agenda.tz.america_noronha": "Fernando de Noronha",
  "agenda.tz.america_argentina_buenos_aires": "Buenos Aires",
  "agenda.tz.america_santiago": "Santiago",
  "agenda.tz.america_bogota": "Bogotá",
  "agenda.tz.america_mexico_city": "Mexico City",
  "agenda.tz.america_lima": "Lima",
  "agenda.tz.america_new_york": "New York",
  "agenda.tz.europe_lisbon": "Lisbon",
  "agenda.tz.europe_madrid": "Madrid",
  "agenda.tz.utc": "Universal time",
  "agenda.preview.title": "This is how next week looks",
  "agenda.preview.hint": "The times free to book, already without what is busy in the connected calendars. It shows what is saved.",
  "agenda.preview.more": "+{count}",
  "agenda.preview.total": "1 free time for {type} ({duration}) in the next 7 days.|{count} free times for {type} ({duration}) in the next 7 days.",
  "agenda.preview.no_type": "Create an appointment type to see the free times.",
  "agenda.preview.open_types": "Open the types",
  "agenda.people.title": "Who attends",
  "agenda.people.lead": "Who gets this calendar's appointments. The order breaks ties in the turns.",
  "agenda.people.team": "Team",
  "agenda.people.no_team": "No team",
  "agenda.people.add_team": "Add 1 person from the {team} team|Add {count} people from the {team} team",
  "agenda.people.add": "Add person",
  "agenda.people.empty": "Nobody attends yet. Add the people below.",
  "agenda.people.active": "Attends",
  "agenda.people.on_hint": "gets appointments",
  "agenda.people.off_hint": "away for now: gets no new appointments",
  "agenda.people.up": "Move {name} up",
  "agenda.people.down": "Move {name} down",
  "agenda.people.remove": "Remove {name}",
  "agenda.people.order_hint": "In turns, it goes to whoever has the fewest appointments in the week; on a tie, whoever is higher up.",
  "agenda.people.own_week": "Own week",
  "agenda.people.own_week_hint": "Without an own week, the calendar's week applies.",
  "agenda.people.own_week_on": "own week",
  "agenda.people.agenda_week": "uses the calendar's week",
  "agenda.people.show_week": "Show the week",
  "agenda.people.hide_week": "Hide the week",
  "agenda.people.person": "Who attends",
  "agenda.people.person_hint": "A one-person calendar: appointments always go to this person.",
  "agenda.people.resource": "A room, a piece of equipment: the calendar only holds the time, without people. Nobody needs to connect a calendar.",
  "agenda.type.new": "New type",
  "agenda.type.new_name": "New type",
  "agenda.type.created": "Type created. Adjust it and save.",
  "agenda.type.empty": "No types yet. Create the first one: it is what the customer books (a visit, a consultation).",
  "agenda.type.inactive": "off",
  "agenda.type.untitled": "Untitled",
  "agenda.type.on": "On",
  "agenda.type.off": "Off",
  "agenda.type.name": "Name",
  "agenda.type.duration": "Duration",
  "agenda.type.step": "Starts",
  "agenda.type.every": "every {time}",
  "agenda.type.description": "What it is (the assistant reads this to know when to offer it)",
  "agenda.type.rules": "Time rules",
  "agenda.type.rule.after_a": "Leave",
  "agenda.type.rule.after_label": "Gap after",
  "agenda.type.rule.after_b": "free after each one and",
  "agenda.type.rule.before_label": "Gap before",
  "agenda.type.rule.before_b": "before.",
  "agenda.type.rule.notice_a": "Book at least",
  "agenda.type.rule.notice_label": "Minimum notice",
  "agenda.type.rule.notice_b": "in advance and at most",
  "agenda.type.rule.ahead_label": "How many days ahead",
  "agenda.type.rule.ahead_b": "ahead.",
  "agenda.type.rule.per_day_a": "At most",
  "agenda.type.rule.per_day_label": "Daily limit",
  "agenda.type.rule.per_day_b": "per person per day and",
  "agenda.type.rule.per_contact_label": "Limit per customer",
  "agenda.type.rule.per_contact_b": "open per customer.",
  "agenda.type.appointments": "1 appointment|{count} appointments",
  "agenda.type.no_limit": "no limit",
  "agenda.type.where": "Where it happens",
  "agenda.type.place.contact_field": "Contact's address (field)",
  "agenda.type.place.address": "Fixed address",
  "agenda.type.place.online": "Online: Meet, Teams or a link",
  "agenda.type.place.phone": "By phone",
  "agenda.type.place.to_agree": "Agree later",
  "agenda.type.place_hint.none": "Choose where it happens: it goes in the confirmation and the reminders.",
  "agenda.type.place_hint.contact_field": "The contact's address goes in the confirmation and the reminders.",
  "agenda.type.place_hint.address": "The address goes in the confirmation and the reminders, with the map link.",
  "agenda.type.place_hint.online": "The link goes in the confirmation and the reminders.",
  "agenda.type.place_hint.phone": "Whoever attends calls the customer's number.",
  "agenda.type.place_hint.to_agree": "The place is agreed in the conversation.",
  "agenda.type.place_short.none": "no place",
  "agenda.type.place_short.address": "in person",
  "agenda.type.place_short.contact_field": "at the customer's address",
  "agenda.type.place_short.online": "online",
  "agenda.type.place_short.phone": "by phone",
  "agenda.type.place_short.to_agree": "place to agree",
  "agenda.type.place_field": "Contact field with the address",
  "agenda.type.place_no_fields": "There are no contact fields yet. Create one in Contact fields.",
  "agenda.type.address": "Address",
  "agenda.type.address_placeholder": "Street, number, district, city",
  "agenda.type.maps": "Google Maps link (optional)",
  "agenda.type.maps_hint": "Paste the place's Google Maps link so the confirmation and the reminder show the map.",
  "agenda.type.maps_missed": "We could not find the map point in this link. Open the place in Google Maps and copy the address bar.",
  "agenda.type.pin": "Map point: {pin}",
  "agenda.type.pin_clear": "Remove",
  "agenda.type.online.title": "How the call works",
  "agenda.type.online.google_meet": "Google Meet (link created automatically)",
  "agenda.type.online.teams": "Microsoft Teams (link created automatically)",
  "agenda.type.online.link": "A fixed link",
  "agenda.type.online.link_field": "Call link",
  "agenda.type.online.hint": "The link is created in the attendee's calendar, which needs Google (for Meet) or Outlook (for Teams) connected.",
  "agenda.type.who": "Who attends",
  "agenda.type.who_mode.round_robin": "Taking turns",
  "agenda.type.who_mode.owner": "Whoever already serves the customer",
  "agenda.type.who_mode.fixed": "One fixed person",
  "agenda.type.who_mode.collective": "Several people together",
  "agenda.type.who_hint.round_robin": "It goes to whoever has the fewest appointments in the week; on a tie, the order in Who attends.",
  "agenda.type.who_hint.owner": "It goes to whoever already looks after the customer; if nobody does, to anyone free in the calendar.",
  "agenda.type.who_hint.fixed": "Always the same person.",
  "agenda.type.who_hint.collective": "Everyone in the calendar must be free, and they all go together.",
  "agenda.type.who_short.round_robin": "turns",
  "agenda.type.who_short.owner": "current owner",
  "agenda.type.who_short.fixed": "fixed person",
  "agenda.type.who_short.collective": "together",
  "agenda.type.prefer_owner": "If someone already served the customer, prefer the same person",
  "agenda.type.fixed_person": "Person",
  "agenda.type.no_people": "Nobody attends in this calendar yet.",
  "agenda.type.who_person": "A one-person calendar: {name} attends every appointment.",
  "agenda.type.who_resource": "A resource calendar: it only holds the time, without a person.",
  "agenda.intake.title": "Before booking, ask for",
  "agenda.intake.label": "Question",
  "agenda.intake.label_placeholder": "E.g. Property code",
  "agenda.intake.new_label": "question",
  "agenda.intake.kind_label": "Answer type",
  "agenda.intake.kind.text": "Free text",
  "agenda.intake.kind.choice": "Pick from options",
  "agenda.intake.save_to": "Save in the field",
  "agenda.intake.no_save": "Don't save in the contact",
  "agenda.intake.options": "Options",
  "agenda.intake.options_placeholder": "Type and press Enter",
  "agenda.intake.required": "Required",
  "agenda.intake.remove": "Remove the question",
  "agenda.intake.add": "Question",
  "agenda.intake.add_field": "+ contact field",
  "agenda.intake.hint": "The assistant and the flow ask for what is missing; what the contact already has is not asked again.",
  "agenda.type.confirm_title": "Confirmation, rescheduling and cancelling",
  "agenda.type.confirm_a": "Ask the customer to confirm:",
  "agenda.type.no_reply_a": "No answer by",
  "agenda.type.reply_by_label": "Deadline to answer",
  "agenda.type.no_reply_label": "What to do without an answer",
  "agenda.type.no_reply.notify": "warn the attendee and keep the time",
  "agenda.type.no_reply.release": "free the time and tell the customer",
  "agenda.type.no_reply.ask_again": "send the request again",
  "agenda.type.reschedule_a": "Reschedule by themselves:",
  "agenda.type.cancel_a": "Cancel by themselves:",
  "agenda.type.cannot": "not allowed",
  "agenda.type.until_start": "until it starts",
  "agenda.type.until": "up to {time} before",
  "agenda.type.confirm_hint": "The request goes out with the “Confirmation request” notice, in Notices and reminders. After the deadline to reschedule or cancel, a team member takes over.",
  "agenda.type.on_book.title": "On booking",
  "agenda.type.on_book.tags": "Add the tag:",
  "agenda.type.on_book.crm": "Log it in the CRM",
  "agenda.type.on_book.crm_hint": "The appointment becomes an activity in the connected CRM.",
  "agenda.type.on_book.close": "Close the conversation as",
  "agenda.type.on_book.no_close": "Don't close",
  "agenda.type.delete": "Delete type",
  "agenda.type.delete_title": "Delete {name}?",
  "agenda.type.delete_text": "It disappears from the assistant's, the flows' and the team's options. If it already has appointments, it is only turned off and the history stays.",
  "agenda.type.deleted": "Done. If the type had appointments, it was turned off.",
  "agenda.type.problem.name": "give it a name.",
  "agenda.type.problem.address": "write the address.",
  "agenda.type.problem.field": "choose the address field.",
  "agenda.type.problem.link": "the call link must start with https://.",
  "agenda.type.problem.person": "choose the person who attends.",
  "agenda.type.problem.intake": "write every question.",
  "agenda.type.problem.options": "a choice question needs at least 2 options.",
  "agenda.provider.google": "Google",
  "agenda.provider.microsoft": "Outlook",
  "agenda.provider.caldav": "iCloud/CalDAV",
  "agenda.provider.ics": "Calendar link",
  "agenda.calendars.title": "Each person's calendar",
  "agenda.calendars.lead": "Whatever is in the calendars that count as busy is never offered. The appointment is written to the calendar the person chose.",
  "agenda.calendars.resource": "This calendar is for a resource (a room, equipment): it has no people or connected calendars.",
  "agenda.calendars.no_people": "Nobody attends in this calendar yet. Add the people in Who attends.",
  "agenda.calendars.chip": "{provider} · {status}",
  "agenda.calendars.status.active": "connected",
  "agenda.calendars.status.needs_consent": "waiting for IT approval",
  "agenda.calendars.status.needs_reauth": "reconnect",
  "agenda.calendars.status.error": "with an error",
  "agenda.calendars.status.disconnected": "disconnected",
  "agenda.calendars.none": "No calendar connected",
  "agenda.calendars.only_here": "Uses only the DoneTalk calendar.",
  "agenda.calendars.read": "read {ago}",
  "agenda.calendars.not_read": "not read yet",
  "agenda.calendars.how.google": "reports changes right away",
  "agenda.calendars.how.microsoft": "reports changes right away",
  "agenda.calendars.how.caldav": "read every 5 min (Apple does not report changes right away)",
  "agenda.calendars.how.ics": "updated every 15 min · does not write appointments",
  "agenda.calendars.needs_consent": "Microsoft asks the company's IT to approve DoneTalk once. The person gets the ready link in My calendar.",
  "agenda.calendars.needs_reauth": "The connection dropped (password changed or access expired). It needs to be connected again.",
  "agenda.calendars.error": "The connection has an error. The person needs to open My calendar.",
  "agenda.calendars.ask": "Ask to connect",
  "agenda.calendars.ask_text": "Hi {name}! Connect your calendar in DoneTalk so nobody books anything on top of your appointments: {link}",
  "agenda.calendars.asked": "Message with the link copied. Send it to {name}.",
  "agenda.calendars.private": "Here you only see whether each calendar is connected; what is in it stays visible only to the person.",
  "agenda.calendars.event_title": "How the appointment shows in the calendar",
  "agenda.calendars.title_field": "Event title",
  "agenda.calendars.tokens": "Insert:",
  "agenda.calendars.token.type": "type",
  "agenda.calendars.token.contact": "customer",
  "agenda.calendars.token.agenda": "calendar",
  "agenda.calendars.looks_like": "It looks like:",
  "agenda.calendars.details": "Put the phone and the conversation link in the description",
  "agenda.calendars.details_hint": "Whoever opens the event in Google or Outlook sees who it is with and opens the conversation with one tap.",
  "agenda.calendars.invite_all": "Write it in the calendar of everyone attending together",
  "agenda.calendars.invite_all_hint": "In types with several people, the event goes to each one's calendar, not only the first.",
  "agenda.calendars.invite_contact": "Invite the customer by e-mail",
  "agenda.calendars.invite_contact_hint": "Uses the contact's e-mail, when there is one. The invitation comes from the attendee's calendar.",
  "agenda.calendars.on_change": "If the person moves or deletes the event in Google or Outlook",
  "agenda.calendars.change.notify_and_ask": "Tell the person and ask the customer for a new time",
  "agenda.calendars.change.notify": "Only tell the person",
  "agenda.calendars.change.ignore": "Do nothing",
  "agenda.calendars.connect_title": "Connect a calendar",
  "agenda.calendars.connect_hint": "Each person connects their own calendar in My calendar.",
  "agenda.notice.title": "To the customer, on WhatsApp",
  "agenda.notice.kind.confirmation": "Confirmation",
  "agenda.notice.kind.confirm_request": "Confirmation request",
  "agenda.notice.kind.reminder": "Reminder",
  "agenda.notice.kind.rescheduled": "New time",
  "agenda.notice.kind.cancelled": "Cancellation",
  "agenda.notice.kind.no_show": "We missed you",
  "agenda.notice.desc.confirmation": "Day, time, address and who attends, with the link to save it in a calendar.",
  "agenda.notice.desc.confirm_request": "Asks whether the customer will come and waits for the answer on the buttons.",
  "agenda.notice.desc.reminder": "Short, with the address and who attends.",
  "agenda.notice.desc.rescheduled": "What changed, from the old time to the new one.",
  "agenda.notice.desc.cancelled": "Confirms the cancellation and offers another day.",
  "agenda.notice.desc.no_show": "No charge or promotion (so it stays utility). Replying reschedules.",
  "agenda.notice.buttons.confirmation": "Reschedule · Cancel",
  "agenda.notice.buttons.confirm_request": "I'll be there · Reschedule · Cancel",
  "agenda.notice.buttons.reminder": "I need to reschedule",
  "agenda.notice.buttons.rescheduled": "Sounds good · Cancel",
  "agenda.notice.buttons.cancelled": "Book another day",
  "agenda.notice.buttons.no_show": "Book another time · No longer needed",
  "agenda.notice.buttons_line": "Buttons: {buttons}.",
  "agenda.notice.on_event.confirmation": "On booking",
  "agenda.notice.on_event.confirm_request": "On booking",
  "agenda.notice.on_event.reminder": "On booking",
  "agenda.notice.on_event.rescheduled": "On rescheduling",
  "agenda.notice.on_event.cancelled": "On cancelling",
  "agenda.notice.on_event.no_show": "On a no-show",
  "agenda.notice.label.days_before": "1 day before, {at}|{count} days before, {at}",
  "agenda.notice.label.same_day": "On the day, {at}",
  "agenda.notice.label.no_show": "{time} after, on a no-show",
  "agenda.notice.timing.before": "{time} before",
  "agenda.notice.timing.after": "{time} after",
  "agenda.notice.timing.after_now": "Right after",
  "agenda.notice.timing.days_before": "1 day before|{count} days before",
  "agenda.notice.timing.same_day": "On the same day",
  "agenda.notice.goes": "Goes out",
  "agenda.notice.when_label": "When it goes out",
  "agenda.notice.at": "at",
  "agenda.notice.at_label": "Notice time",
  "agenda.notice.template": "{name} · {status}",
  "agenda.notice.template_missing": "{name} · not created at Meta yet",
  "agenda.notice.edit_text": "Edit the text",
  "agenda.notice.see_text": "See the text",
  "agenda.notice.on": "On",
  "agenda.notice.off": "Off",
  "agenda.notice.add": "+ Another notice (e.g. 1 week before)",
  "agenda.notice.add_title": "Another notice",
  "agenda.notice.add_confirm": "Add notice",
  "agenda.notice.added": "Notice added",
  "agenda.notice.remove": "Delete notice",
  "agenda.notice.remove_title": "Delete this notice?",
  "agenda.notice.remove_text": "The notice stops going out for upcoming appointments. The ones already sent stay in the history.",
  "agenda.notice.removed": "Notice deleted",
  "agenda.notice.text_title": "Text: {kind}",
  "agenda.notice.text_label": "Message text",
  "agenda.notice.variables": "Insert:",
  "agenda.notice.unknown": "Meta does not know these parts: {list}. Use the buttons to insert them.",
  "agenda.notice.utility_hint": "Talk only about this appointment: what, when, where and with whom. A discount or promotion makes Meta charge it as marketing, which costs much more.",
  "agenda.notice.save_text": "Save text",
  "agenda.notice.text_saved": "Text saved",
  "agenda.notice.use_suggested": "Use the suggested text",
  "agenda.notice.preview": "This is how it arrives on WhatsApp (with sample data)",
  "agenda.notice.map_hint": "The map version shows the address pin on top, when the type has the Google Maps link.",
  "agenda.notice.map": "with map",
  "agenda.notice.with_map": "Also the map version",
  "agenda.notice.meta_title": "Template at Meta",
  "agenda.notice.meta_text": "Outside the 24-hour window, the notice goes out with the {name} template once Meta approves it. In the company's language it uses this text; in the others, DoneTalk's suggested text.",
  "agenda.notice.meta_create": "Create at Meta",
  "agenda.notice.meta_hint": "Meta usually reviews it in minutes. Meanwhile, with the conversation open, the notice already goes out as a normal message.",
  "agenda.notice.meta_needs_channels": "To create the template at Meta, ask whoever manages the WhatsApp numbers.",
  "agenda.notice.meta_sent": "Templates sent for Meta's review.",
  "agenda.notice.meta_failed": "1 template was not created. See the reason in the window.|{count} templates were not created. See the reasons in the window.",
  "agenda.notice.meta_result_failed": "not created ({error})",
  "agenda.notice.account": "WhatsApp account",
  "agenda.notice.no_reply_title": "If the customer does not confirm",
  "agenda.notice.no_reply_text": "The deadline and what to do when the customer does not answer are chosen in each appointment type: warn the attendee and keep it, free the time and tell the customer, or send the request again.",
  "agenda.notice.no_reply_line": "{type}: no answer by {until}, {then}.",
  "agenda.notice.no_reply_none": "No type asks for confirmation yet.",
  "agenda.team.title": "For the team",
  "agenda.team.push": "Notice in the app and on the phone when booking, rescheduling and cancelling",
  "agenda.team.summary": "Daily summary",
  "agenda.team.summary_hint": "Each person gets the day's appointments in the morning.",
  "agenda.team.summary_at": "Summary at",
  "agenda.team.email": "E-mail with the invitation (.ics)",
  "agenda.team.email_hint": "The attendee gets the appointment by e-mail to add to any calendar.",
  "agenda.saving.title": "Savings",
  "agenda.saving.window": "Send as a normal message when the conversation is open",
  "agenda.saving.window_hint": "Inside the 24-hour window, the notice goes out as a regular message with the same buttons: free up to 1,000 per number per month.",
  "agenda.saving.quiet": "Don't send notices at night",
  "agenda.saving.quiet_hint": "A notice that would fall in these hours goes out before them.",
  "agenda.saving.quiet_from": "Between",
  "agenda.saving.quiet_to": "and",
  "agenda.saving.quiet_from_label": "Quiet hours start",
  "agenda.saving.quiet_to_label": "Quiet hours end",
  "agenda.wa.title": "WhatsApp calendar",
  "agenda.wa.text": "A calendar inside the conversation: the customer picks the day and time without leaving WhatsApp. It is set up once per WhatsApp account; then the flows can use it.",
  "agenda.wa.status.published": "Ready",
  "agenda.wa.status.pending": "Setting up",
  "agenda.wa.status.failed": "Failed",
  "agenda.wa.status.none": "Not set up",
  "agenda.wa.setup": "Set up the calendar",
  "agenda.wa.again": "Set up again",
  "agenda.wa.done": "Calendar sent to Meta.",
  "agenda.wa.failed": "1 account failed.|{count} accounts failed.",
  "agenda.wa.no_account": "Connect a WhatsApp number first.",
  "agenda.wa.needs_channels": "To set it up, ask whoever manages the WhatsApp numbers.",
  "agenda.var.name": "name",
  "agenda.var.type": "type",
  "agenda.var.date": "date",
  "agenda.var.time": "time",
  "agenda.var.place": "place",
  "agenda.var.with": "with whom",
  "agenda.var.link": "calendar link",
  "agenda.var.previous": "old time",
  "agenda.lang.pt-BR": "Portuguese",
  "agenda.lang.es": "Spanish",
  "agenda.lang.en": "English",
  "agenda.sample.name": "Ana",
  "agenda.sample.contact": "Ana Souza",
  "agenda.sample.type": "Assessment",
  "agenda.sample.date": "Friday, October 10",
  "agenda.sample.time": "2:30 PM",
  "agenda.sample.place": "1000 Paulista Ave",
  "agenda.sample.with": "Paulo",
  "agenda.sample.previous": "Thursday, October 9, 10:00 AM",
  "agenda.notice.preset.confirmation": "Hi {{name}}! Your {{type}} is booked for {{date}} at {{time}} with {{with}}.\n\n📍 {{place}}\n\nAdd it to your calendar: {{link}}\n\nIf you need to change it, tap below.",
  "agenda.notice.preset.confirm_request": "Hi {{name}}! Your {{type}} is on {{date}} at {{time}}, at {{place}}.\n\nWill you make it?",
  "agenda.notice.preset.reminder": "Hi {{name}}! Reminder: your {{type}} is on {{date}} at {{time}} with {{with}}.\n\n📍 {{place}}\n\nSee you then!",
  "agenda.notice.preset.rescheduled": "Hi {{name}}! Your {{type}} moved from {{previous}} to {{date}} at {{time}} with {{with}}.\n\n📍 {{place}}\n\nAdd it to your calendar: {{link}}",
  "agenda.notice.preset.cancelled": "Hi {{name}}. Your {{type}} on {{date}} at {{time}} was cancelled.\n\nIf you like, we can book another day.",
  "agenda.notice.preset.no_show": "Hi {{name}}. We missed you at your {{type}} on {{date}} at {{time}}.\n\nWould you like to book another time?",
  "mycal.lead": "Connect your calendar so nobody books anything on top of your appointments. DoneTalk reads what is busy and writes there what is booked with you.",
  "mycal.empty": "No calendar connected yet. Choose below.",
  "mycal.busy": "Counts as busy",
  "mycal.write": "Writes here",
  "mycal.read_only": "read only",
  "mycal.primary": "main",
  "mycal.no_calendars": "No calendars found in this account.",
  "mycal.sync": "Update now",
  "mycal.synced": "Calendar updated.",
  "mycal.reconnect": "Connect again",
  "mycal.disconnect": "Disconnect",
  "mycal.disconnect_title": "Disconnect this calendar?",
  "mycal.disconnect_text": "DoneTalk stops reading busy times and writing appointments in it. Events already written stay there.",
  "mycal.disconnected": "Calendar disconnected",
  "mycal.soon": "soon",
  "mycal.connect.title": "Connect a calendar",
  "mycal.connect.action": "Connect",
  "mycal.connect.privacy": "DoneTalk only reads busy times (not what each appointment is) and writes the appointments booked with you.",
  "mycal.provider.google": "Google Calendar",
  "mycal.provider.microsoft": "Outlook and Microsoft 365",
  "mycal.provider.icloud": "Apple iCloud",
  "mycal.provider.caldav": "Other (CalDAV)",
  "mycal.provider.caldav_short": "iCloud or CalDAV",
  "mycal.provider.ics": "Just a calendar link",
  "mycal.provider_hint.google": "Reads busy times, writes and learns about changes right away.",
  "mycal.provider_hint.microsoft": "Work and personal accounts (outlook.com, hotmail).",
  "mycal.provider_hint.icloud": "With an app-specific password created in your Apple Account.",
  "mycal.provider_hint.caldav": "Zoho, Fastmail, Nextcloud and the like.",
  "mycal.provider_hint.ics": "Read only, when the company does not allow connecting.",
  "mycal.result.connected": "Calendar connected.",
  "mycal.result.denied": "You did not allow access. Try again whenever you like.",
  "mycal.result.expired": "The time to connect ran out. Try again.",
  "mycal.result.consent_required": "Your company needs to approve DoneTalk at Microsoft. Send the link to IT.",
  "mycal.result.needs_consent": "Your company needs to approve DoneTalk at Microsoft. Send the link to IT.",
  "mycal.result.failed": "Could not connect. Try again.",
  "mycal.result.admin_consented": "IT approved DoneTalk. Now connect your account.",
  "mycal.it.title": "Microsoft asks for IT approval",
  "mycal.it.text": "In most companies IT needs to approve DoneTalk once. Send this link to IT; after that, the whole team connects on their own.",
  "mycal.it.copy": "Copy the link for IT",
  "mycal.it.copied": "Link copied. Send it to your company's IT.",
  "mycal.it.copy_failed": "Could not copy the link. Try again.",
  "mycal.caldav.title": "Another calendar (CalDAV)",
  "mycal.caldav.icloud_title": "Apple iCloud",
  "mycal.caldav.icloud_help": "At Apple, create an app-specific password (Sign-In and Security › App-Specific Passwords) and paste it here. Don't use your normal password.",
  "mycal.caldav.icloud_link": "Open account.apple.com",
  "mycal.caldav.help": "Zoho, Fastmail, Nextcloud and the like: use the CalDAV address and the app password the service shows in its settings.",
  "mycal.caldav.url": "Server address",
  "mycal.caldav.apple_id": "Apple Account e-mail",
  "mycal.caldav.username": "Username",
  "mycal.caldav.app_password": "App-specific password",
  "mycal.caldav.password": "Password (an app password, if the service has one)",
  "mycal.caldav.safe": "The password is stored encrypted and is only used to read and write your calendar.",
  "mycal.ics.title": "Just a calendar link",
  "mycal.ics.url": "Calendar link (.ics)",
  "mycal.ics.help": "In Google: Calendar settings › Secret address in iCal format. In Outlook: Calendar › Shared › Publish a calendar.",
  "mycal.ics.limits": "Read only: shows busy times, updates every 15 min and does not write appointments.",
  "mycal.error.login": "Username or password refused. Check them and use an app password.",
  "mycal.error.unreachable": "We could not reach this address. Check it and try again.",
  "mycal.error.invalid": "Check the address: it must start with https://.",
  "agenda.var_token.name": "name",
  "agenda.var_token.type": "type",
  "agenda.var_token.date": "date",
  "agenda.var_token.time": "time",
  "agenda.var_token.place": "place",
  "agenda.var_token.with": "with",
  "agenda.var_token.link": "link",
  "agenda.var_token.previous": "previous",
  "book.send_confirmation": "Send the confirmation on WhatsApp now",
  "book.confirmation_held": "The confirmation won't go now; reminders still go as usual.",
  "report.agenda.source_named.assistant": "Assistant {name}",
  "report.agenda.source_named.flow": "Flow {name}",
  "agenda.holidays.see": "See the {year} list",
  "agenda.holidays.list_title": "Holidays in {year}",
  "agenda.holidays.list_hint": "Your state's and city's holidays go in as special dates.",
  "agenda.holiday.new_year": "New Year's Day",
  "agenda.holiday.tiradentes": "Tiradentes",
  "agenda.holiday.labour_day": "Labour Day",
  "agenda.holiday.independence": "Brazil's Independence",
  "agenda.holiday.aparecida": "Our Lady of Aparecida",
  "agenda.holiday.all_souls": "All Souls' Day",
  "agenda.holiday.republic": "Republic Day",
  "agenda.holiday.black_consciousness": "Black Consciousness Day",
  "agenda.holiday.christmas": "Christmas",
  "agenda.holiday.good_friday": "Good Friday",
  "agenda.holiday.carnival_monday": "Carnival (Monday)",
  "agenda.holiday.carnival_tuesday": "Carnival (Tuesday)",
  "agenda.holiday.corpus_christi": "Corpus Christi",
  "agenda.preview.holiday": "Holiday",
  "agenda.calendars.connect_mine": "Connect my calendar",
  "conversas.handoff.assistant_requested": "The assistant asked for a person",
  "conversas.handoff.exit_condition": "The assistant reached its exit condition",
  "conversas.handoff.max_turns": "The assistant reached its reply limit",
  "conversas.handoff.ai_error": "The assistant could not reply",
  "conversas.handoff.review_hold": "The review held the assistant's reply",
  "conversas.handoff.assistant_finished": "The assistant finished its part",
  "conversas.card.context": "Context",
  "settings.import": "Import data",
  "settings.find.import": "import bring migrate copiloto other platform history",
  "settings.find.import-copiloto": "copiloto migration key history conversations",
  "import.lead": "Bring contacts and conversations from another platform. DoneTalk only reads: nothing is deleted at the source.",
  "import.who": "Only Owner and Admin see this area. Connecting, importing and cancelling are audited.",
  "import.copiloto.title": "Copiloto",
  "import.copiloto.lead": "Contacts, conversations with photos and audio, tags, notes and closing reasons.",
  "import.copiloto.address": "Copiloto address",
  "import.copiloto.other_address": "Another address",
  "import.copiloto.address_other": "Address",
  "import.copiloto.key": "Migration key",
  "import.copiloto.key_hint": "An account admin generates it in Copiloto, under Profile › API › Migration key. It lasts up to 7 days and only reads.",
  "import.copiloto.connect": "Connect",
  "import.open.title": "Import of {account}",
  "import.csv.title": "Contact spreadsheet",
  "import.csv.lead": "Contacts only, from a CSV file. In Contacts › Import.",
  "import.others.title": "Other platforms",
  "import.others.lead": "Coming soon. Ask support if you come from another system.",
  "import.past": "Previous imports",
  "import.page.title": "From Copiloto · {account}",
  "import.status.connected": "Connected",
  "import.status.running": "Importing",
  "import.status.paused": "Paused",
  "import.status.done": "Done",
  "import.status.failed": "Stopped",
  "import.status.cancelled": "Cancelled",
  "import.step": "Step {n} of {of}",
  "import.step1.title": "what comes",
  "import.step2.title": "link to DoneTalk",
  "import.continue": "Continue",
  "import.start": "Start the import",
  "import.cancel": "Cancel",
  "import.cancel_keep": "Cancel (what came stays)",
  "import.pause": "Pause",
  "import.resume": "Resume",
  "import.open_item": "Open",
  "import.numbers.title": "Numbers",
  "import.numbers.official": "Official API",
  "import.numbers.qr": "QR code: only the history comes",
  "import.numbers.conversations": "{count} conversation|{count} conversations",
  "import.numbers.waits_connection": "Comes to DoneTalk waiting for its connection through Meta, with the history.",
  "import.numbers.on_channel": "The history goes to the number {name}.",
  "import.numbers.qr_target": "Link to the official number",
  "import.numbers.same_as": "The same as {name}",
  "import.numbers.qr_needs_official": "Choose an official API number first to receive this history.",
  "import.period.title": "Period",
  "import.period.all": "Everything, since the first conversation ({date})",
  "import.period.12m": "Last 12 months",
  "import.period.6m": "Last 6 months",
  "import.period.retention": "The company keeps messages for {days} days: older conversations do not come.",
  "import.include.title": "What comes",
  "import.include.totals": "{contacts} contacts, {conversations} conversations and {messages} messages in Copiloto.",
  "import.include.files": "Photos, audio, videos and documents ({count})",
  "import.include.notes": "Team notes",
  "import.include.assistant": "The AI's instructions as a draft assistant",
  "import.never": "Never comes: simulator and test conversations, groups, tokens and passwords, CRM deals and pipelines.",
  "import.people.title": "Who sent the messages",
  "import.people.lead": "Each Copiloto person linked to their DoneTalk account, found by e-mail. Whoever has no account shows by name.",
  "import.people.no_account": "No account: name only",
  "import.people.assistant": "The AI's messages show as from the assistant created from it.",
  "import.people.same_contact": "A contact already in DoneTalk is matched by number, with or without the ninth digit.",
  "import.reasons.title": "Closing reasons → outcomes",
  "import.reasons.lead": "Each Copiloto reason becomes an outcome. \"Opted out\" also marks the contact as no marketing.",
  "import.reasons.create": "Create: {name}",
  "import.reasons.none": "No outcome",
  "import.running.lead": "You can close this screen and keep using DoneTalk. The progress shows here.",
  "import.progress.title": "Progress",
  "import.progress.contacts": "Contacts",
  "import.progress.conversations": "Conversations",
  "import.progress.messages": "Messages",
  "import.progress.files": "Files",
  "import.progress.of": "{done} of {total}",
  "import.progress.files_missing": "{count} file Copiloto had not kept: it shows as unavailable in the conversation.|{count} files Copiloto had not kept: they show as unavailable in the conversation.",
  "import.progress.matched": "{count} contact already existed in DoneTalk and was matched by number.|{count} contacts already existed in DoneTalk and were matched by number.",
  "import.progress.no_phone": "{count} contact without a WhatsApp number was left out.|{count} contacts without a WhatsApp number were left out.",
  "import.progress.groups": "{count} group conversation was left out.|{count} group conversations were left out.",
  "import.progress.assistant_unavailable": "The AI's configuration could not be read: create the assistant by hand.",
  "import.failed.title": "The import stopped",
  "import.failed.key": "Copiloto no longer accepted the key (it expired or was revoked). Generate another and connect again: what came is not repeated.",
  "import.failed.other": "Copiloto did not answer after several tries. Connect again in a while: what came is not repeated.",
  "import.failed.again": "Connect again",
  "import.todo.title": "What is still to set up in DoneTalk",
  "import.todo.assistant": "Review the draft assistant and turn it on for the number",
  "import.todo.closing": "Close idle conversations, as Copiloto did",
  "import.todo.systems": "Company systems that used Copiloto's API move to DoneTalk's",
  "import.todo.templates": "Message templates: they come from Meta with the number",
  "import.key.kept": "The migration key is kept encrypted until the final pass.",
  "import.key.gone": "The migration key was deleted here. In Copiloto it can be revoked before it expires.",
  "import.finished_at": "finished on {when}",
  "import.switch.title": "Switch the number to DoneTalk",
  "import.switch.lead": "The number stays the same, on the same WhatsApp account: no SMS code, and the approved templates come along.",
  "import.switch.both": "While Copiloto and DoneTalk are both on the account, both receive every message. Do steps 2 to 5 on the same day, outside peak hours.",
  "import.switch.who.copiloto": "Copiloto",
  "import.switch.who.meta": "Meta",
  "import.switch.ready.title": "Get DoneTalk ready",
  "import.switch.ready.body": "The history is already here. Review the assistant, the team and the hours before turning the number on.",
  "import.switch.ai.title": "In Copiloto, turn the number's AI off",
  "import.switch.ai.body": "AI agents › the number › turn replies off. Then only DoneTalk answers after step 3.",
  "import.switch.ai.done": "Marked done on {when}.",
  "import.switch.ai.mark": "Done",
  "import.switch.ai.undo": "Unmark",
  "import.switch.connect.title": "Connect the number in DoneTalk",
  "import.switch.connect.body": "In Numbers, click Connect with Meta and choose the same business, WhatsApp account and number. No SMS code.",
  "import.switch.connect.done": "Connected. New messages already arrive in DoneTalk.",
  "import.switch.connect.go": "Go to Numbers",
  "import.switch.final.title": "Final pass",
  "import.switch.final.body": "After connecting, DoneTalk reads from Copiloto what arrived since the import. A few minutes.",
  "import.switch.final.done": "Done. What arrived during the switch is already here.",
  "import.switch.final.run": "Run the final pass",
  "import.switch.disconnect.title": "In Copiloto, disconnect the number",
  "import.switch.disconnect.after": "After the final pass: Settings › WhatsApp › Disconnect. DoneTalk checks by itself.",
  "import.switch.disconnect.still": "Still on the WhatsApp account: {apps}. Disconnect in Copiloto and check again.",
  "import.switch.disconnect.done": "Only DoneTalk receives this number's messages.",
  "import.switch.disconnect.unknown": "It could not be checked now. Try again in a moment.",
  "import.switch.disconnect.recheck": "Check again",
  "import.switch.systems": "Campaigns, notices and company systems using Copiloto's API stop at step 5: they need to move to DoneTalk's API first.",
  "numbers.waiting_connection": "Waiting for connection",
  "numbers.imported.lead": "Came from Copiloto with its history. To turn it on, connect through Meta's window choosing this same account and number.",
  "numbers.imported.connect": "Connect with Meta",
  "numbers.imported.see_import": "See the import",
  "contact.history_copiloto": "Copiloto history",
  "errors.import_key_rejected": "Copiloto did not accept the key. Check it was copied whole, has not expired and that migration is on.",
  "errors.import_address_invalid": "That address cannot be used. Use Copiloto's address, with https.",
  "errors.import_source_unreachable": "Copiloto did not answer. Try again in a moment.",
  "errors.import_source_busy": "Copiloto asked to wait a little. Try again in a minute.",
  "errors.import_open": "An import is already open. Finish or cancel it before starting another.",
  "errors.import_not_editable": "This import already started: the choices can no longer change.",
  "errors.import_not_startable": "This import cannot start now.",
  "errors.import_wrong_state": "That action does not apply at this point of the import.",
  "errors.import_key_gone": "The migration key was already deleted. Generate another in Copiloto and connect again.",
  "message.imported": "Came from Copiloto",
  "message.imported_by": "Came from Copiloto · sent by {name}",
  "message.file_unavailable": "file unavailable",
  "numbers.meta.steps_title": "In Meta's window",
  "numbers.meta.importing": "Bringing numbers from Copiloto? Don't connect them here now: start with the import. They are connected on switch day.",
  "numbers.meta.importing_link": "Import from Copiloto",
  "campaigns.var.value": "Integration value: {name}",
  "team.capacity_hint": "How many conversations each person handles at once, from 0 to {max}.",
  "errors.validation_field": "Check the field “{field}” and try again.",
  "field.defaultCapacity": "Capacity per person",
  "field.capacityOverride": "Person's capacity",
  "field.name": "Name",
  "field.email": "Email",
  "field.phone": "Phone",
  "numbers.handling.first": "Who answers first",
  "numbers.handling.people": "The team's people",
  "numbers.handling.flow": "Flow: {name}",
  "numbers.handling.team": "The number's team",
  "numbers.handling.no_team": "No team",
  "numbers.handling.hint": "Messages that arrive on this number go to the chosen team.",
  "numbers.handling.hint_assistant": "The assistant answers whoever writes to this number and hands over to the team when a person is needed.",
  "numbers.handling.saved": "The number's handling was saved",
  "numbers.handling.hint_flow": "The flow answers first; when it hands over to a person, the conversation goes to the chosen team.",
  "numbers.disconnect": "Disconnect",
  "numbers.disconnect_title": "Disconnect {number}?",
  "numbers.disconnect_lead": "The number leaves DoneTalk:",
  "numbers.disconnect_1": "DoneTalk stops receiving and sending messages through it, campaigns and notices included.",
  "numbers.disconnect_2": "Conversations stay here as history.",
  "numbers.disconnect_3": "Nothing changes at Meta: the number stays registered and keeps working in other systems that use it.",
  "numbers.disconnect_4": "To use it again, just connect it through Meta.",
  "numbers.disconnect_keep": "Keep connected",
  "numbers.disconnected": "Number disconnected.",
  "numbers.disconnected_meta_failed": "Number disconnected. Meta did not answer just now, but whatever it sends for it will be ignored.",
  "numbers.off_since": "Disconnected from DoneTalk on {date}. Nothing arrives or leaves through it here.",
  "numbers.off_lead": "This number is off: nothing arrives or leaves through it here.",
  "numbers.off_hint": "Its conversations stay in the history. To use it again, connect it through Meta.",
  "delivery.error.channel_disconnected": "The number was disconnected from DoneTalk. Connect it again in Settings › Numbers to send.",
  "errors.number_rented": "This number is rented through DoneTalk: end the rental on the number's own card.",
  "onboarding.org.outcomes_locked_hint": "DoneTalk's outcomes keep their names: uncheck the ones you don't need and add your own at the end of the list.",
  "onboarding.org.outcome_locked": "A DoneTalk outcome: its name does not change. Uncheck it to leave it out.",
  "select.chosen": "1 chosen|{count} chosen",
  "select.add": "Add “{value}”",
  "assistant.language_auto": "The contact's own",
  "assistant.tone_option.cordial": "Cordial",
  "assistant.tone_option.friendly": "Friendly",
  "assistant.tone_option.objective": "Objective",
  "assistant.tone_option.formal": "Formal",
  "assistant.tone_option.relaxed": "Relaxed",
  "assistant.tone_option.empathetic": "Empathetic",
  "assistant.tone_option.welcoming": "Welcoming",
  "assistant.tone_option.patient": "Patient",
  "assistant.tone_option.direct": "Direct",
  "assistant.tone_option.humorous": "Good-humored",
  "assistant.tone_option.enthusiastic": "Enthusiastic",
  "assistant.tone_option.professional": "Professional",
  "assistant.tone_option.technical": "Technical",
  "assistant.tone_option.consultative": "Consultative",
  "assistant.tone_option.persuasive": "Persuasive",
  "assistant.tone_option.calm": "Calm",
  "assistant.tone_option.respectful": "Respectful",
  "assistant.tone_option.simple": "Simple",
  "builder.missing_choice": "Choose the {field} in the “{block}” block ({id}) first.",
  "builder.invalid_generic": "The flow has an incomplete block. Check the blocks and try again.",
  "composer.link_preview_remove": "Send without the link preview",
  "message.list_view_only": "Only to see: the customer chooses, on WhatsApp.",
  "message.list_chosen": "Chosen by the customer",
  "knowledge.source.file": "File",
  "knowledge.file_choose": "Choose file",
  "knowledge.file_change": "Change file",
  "knowledge.file_reading": "Reading the file…",
  "knowledge.file_ready": "{name}: {chars} characters of text.",
  "knowledge.file_hint": "PDF, Markdown (.md) or text (.txt). The text is read here in the browser; scanned PDFs (images only) have no text to read.",
  "knowledge.file_unsupported": "This kind of file is not accepted. Use PDF, Markdown (.md) or text (.txt).",
  "knowledge.file_empty": "This file is empty.",
  "knowledge.file_unreadable": "This file could not be read.",
  "list.drag": "Drag {name} to change the order (or use the ↑ ↓ arrows)",
  "ai.surface.flow.choice": "Menu answered in words",
  "replies.title": "Flow and assistant replies",
  "replies.hint": "Several messages in a row get a single reply. A tap on a button is answered at once.",
  "replies.answer": "Reply",
  "replies.after_last": "after the contact's last message",
  "replies.wait": "Waiting time",
  "replies.seconds": "{n} seconds",
  "replies.at_once": "right",
  "node.field.menu_text": "When they type instead of tapping",
  "node.menu_text.understand": "The AI understands and goes on",
  "node.menu_text.fallback": "Goes to \"No valid answer\"",
  "node.menu_text.resend": "Sends the menu again",
  "node.menu_text_hint.understand": "The AI reads what the person wrote and picks the right option. When it can't tell, it goes to \"No valid answer\" (or sends the menu again, when that exit isn't connected).",
  "node.menu_text_hint.fallback": "Only an option's exact name counts. Anything else goes to \"No valid answer\" (or sends the menu again, when that exit isn't connected).",
  "node.menu_text_hint.resend": "Only an option's exact name counts. Anything else gets the not-understood text and the menu again; when the attempts run out, it goes to \"No valid answer\".",
  "inbox.header.attendances": "{n} conversations",
  "event.taken_over.flow": "{name} wrote and took over · the flow paused",
  "event.taken_over.assistant": "{name} wrote and took over · the assistant paused",
  "event.reason.member_reply": "Wrote in the conversation",
  "handoff.from_label": "Start",
  "handoff.from.beginning": "From the beginning",
  "handoff.from.resume": "Where it stopped: {step}",
  "handoff.from.step": "At a chosen step",
  "handoff.step_label": "Step",
  "errors.flow_not_stopped": "This flow did not stop in this conversation: start from the beginning or at a step.",
  "errors.flow_step_not_found": "That step is no longer in the flow's published version.",
  "outcome.when_label": "When to conclude",
  "outcome.when.now": "Now",
  "outcome.when.hour": "If no answer within 1 hour",
  "outcome.when.hours": "If no answer within {n} hours",
  "outcome.when.day": "If no answer within 1 day",
  "outcome.when.days": "If no answer within {n} days",
  "outcome.when_hint": "Meanwhile the conversation waits for the contact. If they answer first, the conclusion is called off.",
  "outcome.schedule": "Schedule",
  "outcome.scheduled": "Conclusion scheduled.",
  "inbox.scheduled_close.chip": "Concludes in {time} · {outcome}",
  "inbox.scheduled_close.tip": "Concludes as {outcome} on {when}, unless the contact answers first.",
  "inbox.scheduled_close.cancel": "Cancel scheduled conclusion",
  "inbox.scheduled_close.cancelled": "Scheduled conclusion cancelled.",
  "event.close_scheduled": "Conclude as {outcome} on {when} unless the contact answers",
  "event.close_unscheduled.contact_replied": "Scheduled conclusion called off: the contact answered",
  "event.close_unscheduled.cancelled": "{name} cancelled the scheduled conclusion",
  "event.close_unscheduled.failed": "The scheduled conclusion did not happen: the outcome was turned off or now needs a note",
  "node.split": "Split",
  "node.repeat": "Repeat",
  "node.goto_flow": "Go to another flow",
  "node.optout": "Automatic messages",
  "builder.exit_path": "Path {n} · {pct}%",
  "builder.exit_repeat_loop": "Repeat (up to {n}×)",
  "builder.exit_repeat_done": "Repeated enough",
  "builder.exit_reply": "If the contact replies",
  "builder.exit_timeout": "{time} without a reply",
  "builder.repeat_summary": "Up to {n}×",
  "node.optout.label": "Automatic messages",
  "node.optout.on": "Receives them again",
  "node.optout.off": "Stops receiving them",
  "node.optout.hint": "\"Stops receiving them\" records the contact's opt-out: campaigns and automatic messages stop going to them. \"Receives them again\" records that they accepted again.",
  "node.field.flow": "Flow",
  "node.goto_flow.hint": "The conversation enters the chosen (published) flow and this one ends here. What this flow gathered does not carry over.",
  "node.field.option_keywords": "Also accepts",
  "node.field.option_keywords_placeholder": "words, nicknames… Enter to add",
  "node.field.own_timeout": "Wait for a reply for (minutes)",
  "node.field.own_timeout_placeholder": "The flow's time",
  "node.field.own_timeout_hint": "With a time here, this block gets its own \"without a reply\" exit. Empty, the flow's inactivity time applies.",
  "node.condition.subject": "About",
  "node.condition.subject.tag": "Contact's tag",
  "node.condition.subject.field": "Contact field",
  "node.condition.subject.message": "Message received",
  "node.condition.subject.assignee": "Person attending",
  "node.condition.subject.window": "24-hour window",
  "node.condition.subject.variable": "Flow variable",
  "node.condition.window_open": "Open",
  "node.condition.window_closed": "Closed",
  "node.condition.label.tag_with": "Has the tag {tag}",
  "node.condition.label.tag_without": "Lacks the tag {tag}",
  "node.condition.label.assignee_any": "Has someone attending",
  "node.condition.label.assignee_is": "Attended by {name}",
  "node.condition.label.assignee_not": "Not attended by {name}",
  "node.condition.label.window_open": "24-hour window open",
  "node.condition.label.window_closed": "24-hour window closed",
  "op.not_contains": "does not contain",
  "node.tag.add": "Add tags",
  "node.tag.remove": "Remove tags",
  "node.split.paths": "Paths",
  "node.split.weight": "Weight",
  "node.split.add": "Add a path",
  "node.split.hint": "Each conversation follows a path drawn at random, in proportion to the weights: good for testing two messages or sharing work.",
  "node.repeat.times": "How many times to repeat",
  "node.repeat.hint": "The first times the conversation passes here it goes by \"Repeat\"; then once by \"Repeated enough\", and the count starts over.",
  "node.ai_route": "AI triage",
  "node.ai_condition": "AI condition",
  "node.ai_tags": "Tags by AI",
  "node.ai_fields": "Fields by AI",
  "ai.surface.flow.blocks": "Flows' AI blocks",
  "builder.exit_ai_unsure": "AI could not tell",
  "builder.exit_yes": "Yes",
  "builder.exit_no": "No",
  "builder.default_route": "Route {n}",
  "node.ai_route.reads_message": "Reads the contact's message",
  "node.ai_route.prompt": "Question (optional)",
  "node.ai_route.prompt_hint": "With a question, the AI reads the answer. Without one, it reads the message that brought the contact here.",
  "node.ai_route.routes": "Routes",
  "node.ai_route.label": "Route name (e.g. Billing)",
  "node.ai_route.description": "When to go this way (e.g. invoice, payment)",
  "node.ai_route.add": "Add a route",
  "node.ai_route.hint": "The AI picks the route that fits what the contact needs. When it cannot tell, it goes by \"AI could not tell\".",
  "node.ai_condition.question": "Question for the AI",
  "node.ai_condition.hint": "A yes-or-no question about the conversation, such as \"Has the customer decided to cancel?\". The AI answers \"No\" when the conversation does not make it clear.",
  "node.ai_tags.tags": "Tags the AI may use",
  "node.ai_tags.any": "Any tag",
  "node.ai_tags.instructions": "Guidance (optional)",
  "node.ai_tags.hint": "The AI reads the conversation and puts on the contact the tags that fit. With none chosen, it may use all.",
  "node.ai_fields.fields": "Contact fields",
  "node.ai_fields.hint": "The AI fills the fields with what the contact said in the conversation. A field the conversation does not state stays as it was.",
  "node.message.vary": "Vary with AI",
  "node.message.vary_hint": "Each contact gets the same message in other words, keeping its meaning, links and numbers.",
  "builder.exit_other_reply": "Another reply",
  "builder.exit_replied": "Replied",
  "builder.tag_trigger": "When a tag is put on the contact",
  "builder.tag_trigger_hint": "The flow starts in the contact's open conversation. Without one, it opens one: begin with an approved template then, since the 24-hour window is closed.",
  "node.message.attach": "Attach a file",
  "node.message.uploading": "Uploading…",
  "node.message.remove_file": "Remove the file",
  "node.message.file_hint": "The text goes as the caption of the photo, video or document; with an audio, right after it.",
  "node.message.kind.image": "Photo",
  "node.message.kind.video": "Video",
  "node.message.kind.audio": "Audio",
  "node.message.kind.document": "Document",
  "node.template.wait": "Wait for the reply",
  "node.template.wait_hint": "The flow stops here until the contact replies to the template, then goes by \"Replied\".",
  "node.template.by_button": "One path per button",
  "node.template.by_button_hint": "Each of the template's quick-reply buttons gets its exit; anything else goes by \"Another reply\".",
  "builder.remove_link": "Remove this link",
  "builder.search_blocks": "Search blocks",
  "builder.no_blocks": "No block by that name.",
  "builder.copied": "{count} block(s) copied: ⌘/Ctrl+V pastes here or in another flow.",
  "builder.pasted": "{count} block(s) pasted.",
  "builder.group.messages": "Messages",
  "builder.group.ai": "Artificial intelligence",
  "builder.group.logic": "Paths",
  "builder.group.contact": "Contact",
  "builder.group.service": "Service",
  "builder.group.integrations": "Integrations",
  "node.desc.message": "Sends a text, with a photo, video, audio or document if you want.",
  "node.desc.template": "Sends an approved template: the only way to write outside the 24-hour window. Can wait for the reply and branch by button.",
  "node.desc.menu": "A question with options (WhatsApp list or buttons); each option leads to a path.",
  "node.desc.input": "Asks a question and keeps the answer, checking CPF, e-mail, date…",
  "node.desc.ai_route": "The AI understands what the contact needs and follows the right path.",
  "node.desc.ai_condition": "A yes-or-no question about the conversation, answered by the AI.",
  "node.desc.ai_tags": "The AI puts on the contact the tags that fit the conversation.",
  "node.desc.ai_fields": "The AI fills contact fields with what they said.",
  "node.desc.assistant": "Hands the conversation to an AI assistant, which can hand it back to the flow.",
  "node.desc.condition": "Follows different paths by tag, field, message, attendant or 24-hour window.",
  "node.desc.split": "Draws a path at random, in the proportion you choose.",
  "node.desc.repeat": "Counts the passes here: repeats a few times, then follows another path.",
  "node.desc.wait": "Waits for a while, until a date or a time; can go on sooner if the contact replies.",
  "node.desc.business_hours": "One path inside business hours, another outside.",
  "node.desc.tag": "Puts tags on and takes them off the contact or the conversation.",
  "node.desc.set_field": "Saves a value in a contact field.",
  "node.desc.set_variable": "Keeps a value to use later in the flow.",
  "node.desc.optout": "Records whether the contact receives automatic messages (opt-out).",
  "node.desc.transfer": "Hands the conversation to a person or team.",
  "node.desc.schedule": "Offers free times and books with the contact.",
  "node.desc.close": "Concludes the conversation with an outcome.",
  "node.desc.goto_flow": "Puts the conversation into another published flow.",
  "node.desc.end": "Ends the flow here.",
  "node.desc.http_request": "Calls another system's address and keeps the answer.",
  "node.desc.script": "Computes values with a piece of code.",
  "node.desc.event": "Tells other systems that something happened.",
  "node.desc.exception": "Where the flow goes when something goes wrong.",
  "builder.undo": "Undo",
  "builder.redo": "Redo",
  "builder.undo_hint": "Undo (⌘/Ctrl+Z)",
  "builder.redo_hint": "Redo (⌘/Ctrl+Shift+Z)",
  "builder.shortcuts": "Editor shortcuts",
  "builder.versions_hint": "The published versions: see them and go back to an earlier one.",
  "builder.triggers_hint": "When the flow starts: on the number, by word, by tag or from the assistant.",
  "builder.test_hint": "Talk to the flow here, without sending anything to anyone.",
  "builder.save_hint": "Keeps the changes without putting them live (⌘/Ctrl+S).",
  "builder.publish_hint": "Puts it live: the next conversations follow this version.",
  "builder.shortcut.add.keys": "Click a block in the panel",
  "builder.shortcut.add.does": "Creates the block linked from the selected one (or in the middle of the screen).",
  "builder.shortcut.drop.keys": "Drag from the panel",
  "builder.shortcut.drop.does": "Drops the block wherever you want.",
  "builder.shortcut.link.keys": "Drag an exit's dot",
  "builder.shortcut.link.does": "Links to another block; let go on empty canvas to create the next block already linked.",
  "builder.shortcut.unlink.keys": "× in the middle of a link",
  "builder.shortcut.unlink.does": "Removes the link (shows when pointing at it).",
  "builder.shortcut.select.keys": "Shift or ⌘/Ctrl + click",
  "builder.shortcut.select.does": "Picks several blocks.",
  "builder.shortcut.box.keys": "Shift or ⌘/Ctrl + drag",
  "builder.shortcut.box.does": "Picks the blocks inside the area.",
  "builder.shortcut.all.keys": "⌘/Ctrl+A",
  "builder.shortcut.all.does": "Picks every block.",
  "builder.shortcut.copy.keys": "⌘/Ctrl+C",
  "builder.shortcut.copy.does": "Copies the picked blocks.",
  "builder.shortcut.paste.keys": "⌘/Ctrl+V",
  "builder.shortcut.paste.does": "Pastes in the middle of the screen, in this or another flow.",
  "builder.shortcut.duplicate.keys": "⌘/Ctrl+D",
  "builder.shortcut.duplicate.does": "Duplicates the picked blocks.",
  "builder.shortcut.delete.keys": "Delete or Backspace",
  "builder.shortcut.delete.does": "Deletes the picked blocks or link.",
  "builder.shortcut.undo.keys": "⌘/Ctrl+Z",
  "builder.shortcut.undo.does": "Undoes the last change.",
  "builder.shortcut.redo.keys": "⌘/Ctrl+Shift+Z",
  "builder.shortcut.redo.does": "Redoes what was undone.",
  "builder.shortcut.save.keys": "⌘/Ctrl+S",
  "builder.shortcut.save.does": "Saves the draft.",
  "builder.shortcut.arrange.keys": "Shift+Alt+T",
  "builder.shortcut.arrange.does": "Arranges the blocks.",
  "builder.shortcut.zoom.keys": "⌘/Ctrl + scroll, or pinch",
  "builder.shortcut.zoom.does": "Zooms in and out; scrolling alone moves the canvas.",
  "builder.shortcut.fit.keys": "⛶ in the bottom corner",
  "builder.shortcut.fit.does": "Shows the whole flow.",
  "builder.channel_default_none": "This company has no number connected yet. Once one is, tick here the number whose new conversations start with this flow.",
  "builder.start_when": "When this flow starts",
  "builder.start_none": "No trigger yet. So the flow only starts when someone hands a conversation to it or another flow goes to it.",
  "builder.start_none_short": "No trigger: click to choose when it starts",
  "builder.start_choose": "Choose triggers",
  "builder.start_published_hint": "Triggers apply to the published version: while the flow is only a draft, nothing starts on its own.",
  "builder.start_line.channel_default": "A contact starts a conversation on {number}",
  "builder.start_line.keyword": "The contact writes: {words}",
  "builder.start_line.tag_added": "The tag {tag} is put on the contact",
  "composer.format.bar": "Formatting",
  "composer.format.bold": "Bold",
  "composer.format.italic": "Italic",
  "composer.format.strike": "Strikethrough",
  "composer.format.code": "Inline code",
  "composer.format.numbered": "Numbered list",
  "composer.format.bulleted": "Bulleted list",
  "composer.format.quote": "Quote",
  "settings.api": "API",
  "api.title": "API",
  "api.lead": "Keys for other systems (ERP, CRM, website, automations) to use DoneTalk: create and send campaigns, add contacts, send messages and more. Each key does only what is ticked on it.",
  "api.address": "API address",
  "api.docs": "Read the documentation",
  "api.keys": "Keys",
  "api.new_key": "New key",
  "api.edit_key": "Edit key",
  "api.key_name": "Name",
  "api.key_name_placeholder": "E.g. Company ERP",
  "api.environment": "Environment",
  "api.environment.live": "Production",
  "api.environment.test": "Test (sends nothing)",
  "api.environment.test_short": "Test",
  "api.environment_hint": "A test key answers like a production one, with example data, and stores, sends and charges nothing.",
  "api.scopes": "What this key may do",
  "api.scopes_required": "Tick at least one permission.",
  "api.group.campaigns": "Campaigns",
  "api.group.contacts": "Contacts",
  "api.group.templates": "Templates",
  "api.group.messages": "Messages and conversations",
  "api.group.flows": "Flows and scheduling",
  "api.group.other": "Other",
  "api.scope.campaigns:read": "See campaigns and results",
  "api.scope.campaigns:write": "Create and edit drafts",
  "api.scope.campaigns:send": "Start, pause and cancel",
  "api.scope.contacts:read": "See contacts and their field values",
  "api.scope.contacts:write": "Create and update contacts",
  "api.scope.fields:read": "See the list of fields",
  "api.scope.fields:write": "Create fields",
  "api.scope.contacts:delete": "Erase contacts' data (LGPD)",
  "api.scope.templates:read": "See templates",
  "api.scope.templates:write": "Create templates and submit them to Meta",
  "api.scope.messages:send_template": "Send templates",
  "api.scope.messages:send_text": "Send text and files (24-hour window)",
  "api.scope.conversations:read": "See conversations and messages",
  "api.scope.conversations:write": "Close and reopen conversations",
  "api.scope.flows:start": "Start flows",
  "api.scope.appointments:read": "See appointments",
  "api.scope.appointments:write": "Book, move and cancel appointments",
  "api.scope.webhooks:manage": "Manage webhooks",
  "api.scope.reports:read": "See reports and costs",
  "api.scope.workspace:read": "See numbers, teams and tags",
  "api.scope.integrations:outboundpro": "Connect OutboundPro Conversas",
  "api.skip_approval": "Start campaigns without waiting for approval",
  "api.skip_approval_hint": "Without it, this key's campaigns follow the company's approval rule. The budget always applies.",
  "api.expires": "Valid until (optional)",
  "api.ips": "Only from these IP addresses (optional)",
  "api.ips_hint": "One per line, like 200.155.12.10 or 200.155.12.0/24. Empty: any address.",
  "api.create": "Create key",
  "api.created_title": "Key created",
  "api.created_hint": "Copy it and keep it somewhere safe. For security, it is not shown again.",
  "api.created_warning": "Whoever holds this key acts for the company within what you ticked. If it leaks, revoke it and create another.",
  "api.copy_key": "Copy key",
  "api.legacy": "Integration access (old)",
  "api.legacy_hint": "Made before per-key permissions: does all an integration could. Choose its permissions to limit it.",
  "api.all_scopes": "Everything",
  "api.created_by": "created by {name}",
  "api.expires_on": "valid until {date}",
  "api.revoke_confirm": "Revoke the key {name}? The system using it stops working at once.",
  "api.empty": "No keys yet. Create one to connect another system.",
  "api.saved": "Key saved",
  "api.keys_moved": "API keys are in Settings › API.",
  "integrations.event.campaign.started": "Campaign started",
  "integrations.event.campaign.paused": "Campaign paused",
  "integrations.event.campaign.resumed": "Campaign resumed",
  "integrations.event.campaign.completed": "Campaign completed",
  "integrations.event.campaign.cancelled": "Campaign cancelled",
  "integrations.event.campaign.recipient.sent": "Campaign: message sent",
  "integrations.event.campaign.recipient.delivered": "Campaign: message delivered",
  "integrations.event.campaign.recipient.read": "Campaign: message read",
  "integrations.event.campaign.recipient.replied": "Campaign: contact replied",
  "integrations.event.campaign.recipient.failed": "Campaign: failed for a contact",
  "integrations.event.campaign.recipient.opted_out": "Campaign: contact opted out",
  "policy.gate.authors": "Reviews messages from",
  "policy.gate.author.member": "Team members",
  "policy.gate.author.assistant": "AI assistant",
  "policy.gate.author.flow": "Flows",
  "policy.gate.author_short.member": "people",
  "policy.gate.author_short.assistant": "AI assistant",
  "policy.gate.author_short.flow": "flows",
  "policy.gate.authors_hint": "The AI assistant follows this policy's rules even when it is not reviewed: they go into its instructions. Tick the assistant only if each of its replies should also go through the review.",
  "policy.summary.authors": "Reviews: {who}",
  "event.transfer_note.gate_hold": "the message review held a reply",
  "event.transfer_note.max_turns": "the assistant reached its reply limit",
  "event.transfer_note.exit_field_set": "the assistant got the detail it was after",
  "event.transfer_note.exit_keyword": "the contact said one of the assistant's exit words",
  "event.transfer_note.error": "the assistant could not go on",
  "gate.your_edit": "Your message, to edit",
  "errors.gate_override_denied": "The policy does not let you send this message as it is. Edit the text.",
  "errors.gate_decision_unavailable": "This review has expired. Send the message again.",
  "errors.gate_no_rewrite": "There is no suggestion to use. Edit the text.",
  "inbox.draft": "Draft:",
  "common.delete": "Delete",
  "settings.tools": "Tools",
  "permission.tools.manage": "Create and edit the assistants' tools and connections",
  "ai.surface.tools.draft": "Create a tool with AI",
  "assistants.tab.tools": "Tools",
  "errors.tool_key_taken": "A tool already has this AI name. Pick another.",
  "errors.connection_in_use": "Tools still use this connection. Switch them to another one first.",
  "errors.tool_call_decided": "Someone already decided on this request.",
  "errors.package_not_found": "This package is not available to the company.",
  "errors.tool_not_found": "Tool not found.",
  "errors.connection_not_found": "Connection not found.",
  "tools.lead": "What the assistants can do in the middle of a conversation: look up and change data in the company's system.",
  "tools.new": "New tool",
  "tools.active": "On",
  "tools.inactive": "Off",
  "tools.empty": "No tools yet. Create the first one by describing what it does to the AI.",
  "tools.soon": "Coming soon",
  "tools.group.company": "The company's",
  "tools.group.company_hint": "Made here, switched on in the assistants you choose",
  "tools.group.connections": "Connections",
  "tools.group.connections_hint": "The system's address and secret, kept once for several tools",
  "tools.group.platform": "The platform's",
  "tools.group.platform_hint": "Ready: just switch them on in each assistant",
  "tools.kind.form": "form",
  "tools.kind.flow": "flow",
  "tools.list.assistants": "1 assistant|{count} assistants",
  "tools.list.no_assistant": "no assistant",
  "tools.list.uses": "1 use in 60 days|{count} uses in 60 days",
  "tools.effect.read": "Read only",
  "tools.effect.read_hint": "Reads and changes nothing. Runs for real in tests too.",
  "tools.effect.write": "Changes data",
  "tools.effect.write_hint": "Changes something in the system. Simulated in tests.",
  "tools.confirm_short.contact": "confirmed by the contact",
  "tools.confirm_short.person": "a person approves",
  "tools.confirm_short.none": "no confirmation",
  "tools.confirm.title": "Before changing",
  "tools.confirm.contact": "Confirm with the contact",
  "tools.confirm.contact_hint": "the AI says what will change; DoneTalk only calls after the contact agrees, with the same data.",
  "tools.confirm.person": "A person approves",
  "tools.confirm.person_hint": "the team sees the request in the conversation and approves or declines it.",
  "tools.confirm.none": "No confirmation",
  "tools.confirm.none_hint": "calls as soon as the AI decides.",
  "tools.preview": "The system describes the change first",
  "tools.preview_hint": "The first call goes with confirmed = false and the system answers what it would do; the AI reads that to the contact.",
  "tools.timeout": "Wait for the answer up to",
  "tools.seconds": "1 second|{n} seconds",
  "tools.hourly_limit": "Calls per conversation",
  "tools.per_hour": "up to {n} an hour",
  "tools.ms": "{n} ms",
  "tools.required": "required",
  "tools.secret_hint": "secret ending in {hint}",
  "tools.auth.donetalk": "DoneTalk signature",
  "tools.auth.copiloto": "Copiloto-format signature",
  "tools.auth.bearer": "Token (Bearer)",
  "tools.auth.header": "Key in a header",
  "tools.auth.none": "No authentication",
  "tools.auth_hint.donetalk": "DoneTalk signs each call with the secret and the time (DoneTalk-Signature), like the webhooks.",
  "tools.auth_hint.copiloto": "For systems built for Copiloto's external lookup: X-Copiloto-Timestamp and X-Copiloto-Signature.",
  "tools.auth_hint.bearer": "The secret goes in Authorization: Bearer.",
  "tools.auth_hint.header": "The secret goes in the header you name.",
  "tools.auth_hint.none": "Tests only: anyone who knows the address can call it.",
  "tools.connection.title": "Connection",
  "tools.connection.new": "New connection",
  "tools.connection.new_option": "+ New connection…",
  "tools.connection.edit": "Edit connection",
  "tools.connection.name": "Name",
  "tools.connection.name_placeholder": "Store system",
  "tools.connection.base_url": "Address",
  "tools.connection.auth": "How DoneTalk identifies itself",
  "tools.connection.header": "Header name",
  "tools.connection.secret": "Secret",
  "tools.connection.secret_replace": "New secret (the current one ends in {hint}; empty keeps it)",
  "tools.connection.secret_hint": "Stored encrypted. Once saved, only the last 4 characters show.",
  "tools.connection.used_by": "used by 1 tool|used by {count} tools",
  "tools.connection.in_use": "Used by tools: switch them to another connection before deleting.",
  "tools.name": "Name",
  "tools.key": "Name for the AI",
  "tools.key_taken": "A tool already has this name for the AI.",
  "tools.description": "When to use it (what the AI reads)",
  "tools.description_hint": "Say when to use it, what not to do and what to tell the contact afterwards. Each assistant can adjust this text in its Tools tab.",
  "tools.part.name": "Name and when to use it",
  "tools.part.inputs": "What the AI needs to find out",
  "tools.part.call": "Where to call",
  "tools.part.response": "What comes back to the AI",
  "tools.part.safety": "Safety",
  "tools.inputs.key": "Field",
  "tools.inputs.type": "Type",
  "tools.inputs.description": "For the AI",
  "tools.inputs.remove": "Remove the field",
  "tools.inputs.add": "Add field",
  "tools.inputs.none": "No fields: the tool uses only what comes from the conversation.",
  "tools.inputs.options": "Accepted values",
  "tools.inputs.options_placeholder": "hotel, motel",
  "tools.inputs.automatic": "Sent on its own, from the conversation (the AI never provides it): the contact's phone and name, the conversation and the assistant.",
  "tools.inputs.contact_fields": "Also send these contact fields",
  "tools.inputs.contact_fields_placeholder": "plan, city",
  "tools.input_type.text": "Text",
  "tools.input_type.number": "Number",
  "tools.input_type.boolean": "Yes or no",
  "tools.input_type.list": "List",
  "tools.input_type.date": "Date",
  "tools.call.method": "Method",
  "tools.call.path": "Path",
  "tools.call.format": "Format",
  "tools.call.donetalk": "DoneTalk standard",
  "tools.call.donetalk_hint": "the system gets the signed request and answers a text for the AI.",
  "tools.call.docs": "See the format",
  "tools.call.any": "Any API",
  "tools.call.any_hint": "build the path and the body with the conversation's data, for example {phone} and {input}.",
  "tools.call.headers": "Headers (one per line)",
  "tools.call.body": "Body",
  "tools.response.text": "The answer's text (the text field, or the whole answer)",
  "tools.response.field": "One field of the answer",
  "tools.response.template": "A sentence built from the answer",
  "tools.response.field_path": "Field path",
  "tools.response.template_text": "Sentence",
  "tools.response.limit": "The AI reads up to {chars} characters. If the system does not answer within {seconds} s, it hears \"unavailable now\" and goes on without the data.",
  "tools.ai_view.title": "What the AI sees",
  "tools.ai_view.phone": "The phone is not here: the AI cannot switch contacts.",
  "tools.ai_view.checked": "DoneTalk checks it",
  "tools.missing.title": "Missing before saving",
  "tools.missing.name": "The tool's name",
  "tools.missing.key": "A name for the AI: lowercase letters, digits and _",
  "tools.missing.description": "The \"when to use it\", at least 10 characters",
  "tools.missing.connection": "The connection to the system",
  "tools.missing.input_key": "Fields with a valid name: lowercase letters, digits and _",
  "tools.missing.input_repeated": "Fields without repeated names",
  "tools.missing.response_field": "The answer field's path",
  "tools.missing.response_template": "The sentence with the answer",
  "tools.flow.title": "Need more steps?",
  "tools.flow.hint": "Looking up first and changing only if the account exists, for example: the tool will open as a flow.",
  "tools.on_assistants": "On in",
  "tools.on_assistants_hint": "Switch it on or adjust it in each assistant's Tools tab.",
  "tools.remove.title": "Delete the tool",
  "tools.remove.hint": "Assistants stop using it at once. The call history stays.",
  "tools.remove.action": "Delete",
  "tools.how.ai": "Describe it to the AI",
  "tools.how.ai_hint": "Say in words what it does, or paste the API's documentation. The AI fills in everything.",
  "tools.how.form": "Form",
  "tools.how.form_hint": "One call to a system. You fill in each part.",
  "tools.how.start_form": "Open the form",
  "tools.how.flow": "Multi-step flow",
  "tools.how.flow_hint": "Looks up, decides and calls again, in the flow builder, without code.",
  "tools.how.package": "Ready-made package",
  "tools.ai.title": "What the tool does",
  "tools.ai.describe": "In words",
  "tools.ai.describe_placeholder": "When the customer asks about an order, look up its status by the order number in our system.",
  "tools.ai.docs": "Documentation, cURL or an example of the API (optional)",
  "tools.ai.create": "Create with AI",
  "tools.ai.hint": "The AI drafts it; nothing is saved or switched on until you review it.",
  "tools.ai.drafted": "The AI drafted this. Review each part and use \"Test now\" before saving.",
  "tools.test.title": "Test now",
  "tools.test.phone": "Example contact's phone",
  "tools.test.real": "Do it for real",
  "tools.test.real_hint": "Unticked, nothing is called: this tool changes data.",
  "tools.test.real_hint_preview": "Unticked, the system only describes what it would do (confirmed = false).",
  "tools.test.run": "Test",
  "tools.test.ai_reads": "What the AI reads",
  "tools.test.sent": "What was sent",
  "tools.test.received": "What came back",
  "tools.test.not_called": "Nothing was called: tick \"Do it for real\" to call the system.",
  "tools.test.note": "The test is not in the history and does not count toward the limit. The secret never shows here.",
  "tools.test.status.ok": "Worked",
  "tools.test.status.refused": "The system said no",
  "tools.test.status.failed": "No answer",
  "tools.test.status.simulated": "Simulated",
  "tools.call_status.ok": "Worked",
  "tools.call_status.refused": "The system declined",
  "tools.call_status.failed": "Failed",
  "tools.call_status.limited": "Over the limit",
  "tools.call_status.simulated": "Simulated",
  "tools.call_status.awaiting_contact": "Waiting for the contact's yes",
  "tools.call_status.awaiting_person": "Waiting for approval",
  "tools.call_status.declined": "Declined by the team",
  "tools.call_status.expired": "Expired",
  "tools.error.timeout": "the system did not answer in time",
  "tools.error.network": "could not connect",
  "tools.error.too_large": "answer too large",
  "tools.error.no_text": "the answer had no text",
  "tools.error.field_missing": "the chosen field was missing",
  "tools.error.empty": "empty answer",
  "tools.error.no_connection": "no connection",
  "tools.error.bad_address": "invalid address",
  "tools.error.unsafe_address": "address not allowed (public https only)",
  "tools.error.hourly_limit": "hourly limit",
  "tools.error.tool_inactive": "tool switched off",
  "tools.error.other": "error",
  "tools.error.http": "the system answered HTTP {status}",
  "tools.calls.title": "Call history",
  "tools.calls.total": "Calls in {n} days",
  "tools.calls.ok": "Worked",
  "tools.calls.failed": "Failed",
  "tools.calls.failed_n": "{n} failed",
  "tools.calls.all_tools": "All tools",
  "tools.calls.any_result": "Any result",
  "tools.calls.filter.ok": "Worked",
  "tools.calls.filter.refused": "The system declined",
  "tools.calls.filter.failed": "Failed",
  "tools.calls.filter.limited": "Over the limit",
  "tools.calls.filter.pending": "Waiting",
  "tools.calls.filter.declined": "Declined by the team",
  "tools.calls.days": "Last {n} days",
  "tools.calls.period": "Period",
  "tools.calls.when": "When",
  "tools.calls.tool": "Tool",
  "tools.calls.assistant": "Assistant",
  "tools.calls.conversation": "Conversation",
  "tools.calls.result": "Result",
  "tools.calls.time": "Time",
  "tools.calls.by_tool": "By tool",
  "tools.calls.empty": "No calls in the period.",
  "tools.calls.more": "Show more",
  "tools.decide.approve": "Approve",
  "tools.decide.decline": "Decline",
  "tools.package.install": "Install {name}",
  "tools.package.install_n": "Install 1 tool|Install {count} tools",
  "tools.package.installed": "1 tool installed|{count} tools installed",
  "tools.package.connection": "Connection: {name}",
  "tools.package.secret": "Secret agreed with the system",
  "tools.package.test": "Test the connection",
  "tools.package.connected": "Connected: \"{tool}\" answered in {ms} ms",
  "tools.package.tools": "The package's tools",
  "tools.package.already": "already installed",
  "tools.package.preview": "system preview",
  "tools.package.on": "Switch on in",
  "tools.package.on_hint": "The ticked assistants start using the tools at once (a new version is published).",
  "tools.package.kit_aco.name": "ACO kit",
  "tools.package.kit_aco.lead": "Amanda's tools in Copiloto, ready for DoneTalk: same addresses and the same \"when to use it\" texts. Only the secret is missing.",
  "event.tool.read": "{who} looked up {tool}",
  "event.tool.write": "{who} used {tool}",
  "event.tool.write_confirmed": "{who} used {tool} · confirmed by the contact",
  "event.tool.approved": "{tool} approved by {name}",
  "event.tool.declined": "{name} declined {tool}",
  "event.tool.failed": "{tool} did not answer; the conversation went on without the data",
  "event.tool.waiting_contact": "Waiting for the contact's yes: {tool}",
  "event.tool.waiting_person": "Waiting for the team's approval: {tool}",
  "event.info.tool": "Tool",
  "event.info.tool_input": "Request",
  "event.info.tool_preview": "Preview",
  "event.info.tool_result": "The AI read",
  "event.info.tool_confirmed": "Confirmed by",
  "event.info.tool_approved": "Approved by",
  "event.info.tool_time": "Time",
  "assistants.tools.title": "The company's tools",
  "assistants.tools.hint": "Switch on the ones this assistant may use. It decides when, by the \"when to use it\".",
  "assistants.tools.own": "When to use it, in this assistant",
  "assistants.tools.adjust": "Adjust \"when to use it\" for this assistant",
  "assistants.tools.back_to_tool": "Back to the tool's text",
  "assistants.tools.none": "The company has no tools yet.",
  "assistants.tools.open": "See the company's tools",
  "assistants.tools.rules_title": "Always, for any tool",
  "assistants.tools.rule_phone": "The phone and the name come from the conversation; the AI does not choose whose account it is.",
  "assistants.tools.rule_confirm": "What changes data follows the confirmation chosen on the tool.",
  "assistants.tools.rule_test": "In this assistant's \"Test\", what changes data is simulated.",
  "assistants.tools.rule_fact": "The AI uses the answer as fact and says it saw it, never that it consulted a system.",
  "assistants.tools.rule_limit": "Up to 5 calls of the same tool per conversation per hour.",
  "assistants.test.phone": "Test contact's phone (for the tools)",
  "assistants.test.note_tools": "Nothing goes to WhatsApp. Read-only tools run for real with the phone above; those that change data are simulated.",
  "assistants.test.tool_read": "Looked up {tool}: {text}",
  "assistants.test.tool_preview": "{tool} showed the preview: {text}",
  "assistants.test.tool_waiting": "{tool}: would wait for the contact's yes",
  "assistants.test.tool_simulated": "Simulated: {tool} {text}",
  "assistants.test.tool_approval": "{tool}: a person from the team would approve",
  "assistants.test.tool_missing": "{tool}: missing {text}",
  "email.tool_failing.subject": "DoneTalk · {workspace}: the tool {tool} keeps failing",
  "email.tool_failing.text": "The tool {tool} failed its last 5 calls. The assistant went on with the conversations without the data, and the tool is still on.",
  "email.tool_failing.error": "Last reason: {error}.",
  "email.tool_failing.cta": "See the call history",
  "email.tool_failing.why": "You get this notice because you own or manage the company in DoneTalk. It comes at most once a day per tool.",
  "errors.tool_call_not_yours": "Only whoever answers this conversation, or who distributes conversations, can approve this request.",
  "errors.tool_call_not_found": "Request not found.",
  "templates.category.authentication_hint": "Access and verification codes. Meta writes the text and adds the copy-code button.",
  "templates.otp.title": "Access code",
  "templates.otp.lead": "Meta writes the text in the template's language, with the code in bold and the Copy code button. You only choose what comes with it.",
  "templates.otp.security": "Ask not to share it",
  "templates.otp.security_hint": "After the code, Meta adds a security note.",
  "templates.otp.expiry": "Say when it expires",
  "templates.otp.expiry_hint": "In the footer, Meta writes in how many minutes the code expires.",
  "templates.otp.minutes": "Minutes until it expires",
  "templates.otp.minutes_hint": "From 1 to 90 minutes.",
  "templates.otp.send_hint": "When sending, the code goes as the body's first value; the button copies the same code.",
  "templates.otp.not_verified": "Meta opens access-code templates only to verified businesses. Verify the business in Meta Business Manager and come back here.",
  "templates.otp.refused": "Meta has not opened access-code templates to this account yet. It does so over time: you can try again from {date}.",
  "templates.otp.row": "Access code: Meta writes the text when it approves.",
  "templates.otp.preview_body": "*{{1}}* is your verification code.",
  "templates.otp.preview_security": "For your security, do not share this code.",
  "templates.otp.preview_footer": "Expires in {n} minutes.",
  "templates.otp.preview_button": "Copy code",
  "templates.issue.otp_expiration_range": "Meta takes 1 to 90 minutes.",
  "errors.authentication_not_allowed": "Meta has not opened access-code templates to this account yet.",
  "settings.skills": "Skills",
  "skills.lead": "The ways of doing things your AI assistants follow: a sales method, how to collect, how to welcome a complaint. The AI opens each skill when the conversation calls for it.",
  "skills.new": "New skill",
  "skills.add": "Add to the company",
  "skills.added": "Skill added. Now turn it on in the assistants that will use it.",
  "skills.copy": "Copy to edit",
  "skills.copied": "Copy created. It belongs to the company and no longer gets the library's improvements.",
  "skills.removed": "Skill removed.",
  "skills.in_use": "This skill is on in: {names}. Turn it off in those assistants before removing it.",
  "skills.version": "Version {n}",
  "skills.revision": "Revision {n}",
  "skills.revisions": "Revision history",
  "skills.ai_view": "What the assistant reads",
  "skills.on_assistants": "In assistants",
  "skills.on_assistants_hint": "Each assistant chooses its skills on its Skills tab.",
  "skills.to_assistants": "Go to assistants",
  "skills.group.company": "The company's",
  "skills.group.company_hint": "Written by you, the way you do things.",
  "skills.group.library": "From the DoneTalk library",
  "skills.group.library_hint": "Well-known methods, adjusted for your company. They get improvements.",
  "skills.list.unused": "No assistant uses it",
  "skills.list.company_empty": "None yet. Create one or use “Organize with AI” to turn the instructions you already have into skills.",
  "skills.list.library_empty": "No library skill added.",
  "skills.area.essentials": "Essentials",
  "skills.area.sales": "Sales",
  "skills.area.marketing": "Marketing",
  "skills.area.support": "Support",
  "skills.area.success": "Customer success",
  "skills.area.retention": "Retention",
  "skills.area.finance": "Finance",
  "skills.area.people": "People",
  "skills.area.operations": "Operations",
  "skills.audience.customers": "With customers",
  "skills.audience.team": "With the team",
  "skills.origin.organize": "Organized with AI",
  "skills.origin.copy": "Library copy",
  "skills.library.title": "DoneTalk library",
  "skills.library.open": "Open the library",
  "skills.library.lead": "{count} skill ready to use. Each follows a well-known method; you only say how your company does it.|{count} skills ready to use. Each follows a well-known method; you only say how your company does it.",
  "skills.library.search": "Search the library",
  "skills.library.filter.all": "All",
  "skills.library.filter.customers": "With customers",
  "skills.library.filter.team": "With the team",
  "skills.library.filter.added": "Added",
  "skills.library.added": "Added",
  "skills.library.market_hint": "By default you see the general skills and your country's ({country}). Some follow a country's rules, like collections and personal data.",
  "skills.part.when": "When to use",
  "skills.part.goal": "Goal",
  "skills.part.steps": "Steps",
  "skills.part.always": "Always",
  "skills.part.never": "Never",
  "skills.part.examples": "Examples",
  "skills.part.origin": "Based on:",
  "skills.setup.title": "Adjustments for your company",
  "skills.setup.hint": "The method is DoneTalk's; here you say how your company does it. What is left blank the AI does not make up: it asks or hands over to a person.",
  "skills.setup.pending": "Adjustments blank",
  "skills.brings.title": "What it brings",
  "skills.brings.hint": "When added, the ticked items are created in the company.",
  "skills.brings.hint_added": "What was created when the skill was added. Adjust it in Contact fields and Outcomes.",
  "skills.brings.fields": "Fields the AI fills",
  "skills.brings.outcomes": "Conversation outcomes",
  "skills.brings.handoff": "When it hands over to a person",
  "skills.brings.exists": "Already exists",
  "skills.update.available": "New version",
  "skills.update.title": "Version {n} available",
  "skills.update.hint": "Your adjustments stay. Nothing changes until you update.",
  "skills.update.take": "Update",
  "skills.update.later": "Not now",
  "skills.update.taken": "Updated. The assistants already use the new version.",
  "skills.update.later_done": "Fine. We will tell you again at the next version.",
  "skills.remove.title": "Remove skill",
  "skills.remove.hint": "It can only be removed when no assistant uses it.",
  "skills.remove.action": "Remove",
  "skills.field.name": "Name",
  "skills.field.area": "Area",
  "skills.field.audience": "With whom",
  "skills.field.when_hint": "This is what the AI reads to decide to open this skill. Be concrete: “when the customer asks for a discount”.",
  "skills.field.lines_hint": "One item per line.",
  "skills.field.examples_hint": "A contact's message and the ideal reply. Two or three good examples teach more than many rules.",
  "skills.field.example_contact": "The contact writes",
  "skills.field.example_reply": "The AI replies",
  "skills.field.example_add": "Add example",
  "skills.field.example_remove": "Remove example",
  "skills.field.notes": "Notes",
  "skills.links.title": "Links",
  "skills.links.handoff_hint": "Situations in which the AI hands over to a person. One per line.",
  "skills.links.fields": "Contact fields it fills",
  "skills.links.tools": "Tools it uses",
  "skills.links.collections": "Knowledge bases it looks up",
  "skills.links.hint": "The skill only reminds the AI to use these; each assistant still needs them turned on.",
  "skills.mode.on_demand": "When needed",
  "skills.mode.always": "Always",
  "skills.mode.on_demand_hint": "The AI sees only the name and when to use it, and opens the skill when the conversation calls for it. Uses little memory.",
  "skills.mode.always_hint": "The whole skill goes into every reply. Use it for what applies to any conversation, like the brand's tone.",
  "skills.assistant.title": "This assistant's skills",
  "skills.assistant.hint": "Turn on the ones it uses. They apply once published.",
  "skills.assistant.mode": "How it uses it",
  "skills.assistant.when_own": "When to use, only in this assistant",
  "skills.assistant.when_own_hint": "Blank uses the skill's own.",
  "skills.assistant.open": "Open the skill",
  "skills.assistant.none": "The company has no skills yet. Add one from the library or create one.",
  "skills.assistant.modes_title": "When needed or always?",
  "skills.assistant.many_always": "{n} skills on “Always” weigh on every reply. Keep on “Always” only what applies to any conversation.",
  "skills.scenarios.title": "Scenarios",
  "skills.scenarios.hint": "A simulated customer writes, the draft replies and another AI checks what a good reply does. Nothing is sent.",
  "skills.scenarios.library_hint": "Run them in the “Test” of an assistant that uses this skill.",
  "skills.scenarios.none": "No scenarios. Library skills bring theirs; create the company's.",
  "skills.scenarios.run": "Run",
  "skills.scenarios.run_all": "Run all",
  "skills.scenarios.replies": "See the conversation",
  "skills.scenarios.add": "New scenario",
  "skills.scenarios.remove": "Remove scenario",
  "skills.scenarios.field.title": "Title",
  "skills.scenarios.field.persona": "Who the customer is",
  "skills.scenarios.field.messages": "What the customer writes",
  "skills.scenarios.field.messages_hint": "One message per line, up to 6.",
  "skills.scenarios.field.expect": "What a good reply does",
  "skills.scenarios.field.expect_hint": "One per line, up to 8. E.g. “asks the size before giving the price”.",
  "skills.organize.button": "Organize with AI",
  "skills.organize.lead": "Paste what you already have: today's prompt, a manual, scripts. The AI separates what is a short instruction, what becomes a skill, what is information for the knowledge base and the contact fields. What it cannot decide, it asks.",
  "skills.organize.text": "Text",
  "skills.organize.chars": "{n} of {max} characters",
  "skills.organize.assistant": "For which assistant",
  "skills.organize.assistant_hint": "The result becomes a draft of it, to review and publish. Without an assistant, only the skills, fields and information are created.",
  "skills.organize.no_assistant": "None, just organize",
  "skills.organize.start": "Organize",
  "skills.organize.how.title": "How it works",
  "skills.organize.how.1": "The AI reads everything and compares it with what the company already has.",
  "skills.organize.how.2": "It asks what it cannot decide alone, in short rounds.",
  "skills.organize.how.3": "It shows the proposal: each part with a box to tick.",
  "skills.organize.how.4": "You apply what you want. The assistant gets a draft.",
  "skills.organize.how.safe": "Nothing changes until you apply, and what is published keeps answering.",
  "skills.organize.reading": "The AI is reading and organizing…",
  "skills.organize.reading_hint": "It can take a few minutes. You can leave this screen: the analysis goes on.",
  "skills.organize.failed": "It could not be organized",
  "skills.organize.failed_hint": "The analysis stopped halfway. Try again; if it happens again, contact support.",
  "skills.organize.again": "Try again",
  "skills.organize.into_draft": "What is applied becomes a draft of {name}.",
  "skills.organize.no_assistant_hint": "No assistant: only the skills, fields and information are created.",
  "skills.organize.instructions": "New, shorter instructions",
  "skills.organize.skills": "Skills",
  "skills.organize.skills_hint": "The company's skills can be edited later in Skills.",
  "skills.organize.knowledge": "Information for the knowledge base",
  "skills.organize.fact.new": "New",
  "skills.organize.fact.present": "Already in the base",
  "skills.organize.fact.outdated": "Differs from the base",
  "skills.organize.base": "Save in",
  "skills.organize.new_base": "New base “Organized with AI”",
  "skills.organize.fields": "Contact fields",
  "skills.organize.field_action.create": "Create",
  "skills.organize.field_action.fix": "Adjust",
  "skills.organize.handoff_hint": "It becomes a company skill with these situations.",
  "skills.organize.apply": "Apply {n} items",
  "skills.organize.applied_toast": "Applied.",
  "skills.organize.done": "Done",
  "skills.organize.done_skills": "Skills: {names}",
  "skills.organize.done_fields": "{n} contact fields",
  "skills.organize.done_facts": "{n} pieces of information in the knowledge base",
  "skills.organize.done_draft": "A draft of {name}, to review in Test and publish",
  "skills.organize.open_assistant": "Open the assistant",
  "skills.organize.to_skills": "See the skills",
  "ai_questions.title": "The AI needs a few answers",
  "ai_questions.round": "Round {n} of {total}",
  "ai_questions.recommended": "Recommended",
  "ai_questions.other": "Another answer…",
  "ai_questions.recorded": "The answers are recorded.",
  "ai_questions.submit": "Answer",
  "memory.title": "Assistant's memory",
  "memory.window": "Memory of {tokens} tokens",
  "memory.loading": "Calculating…",
  "memory.part.rules": "Rules and instructions",
  "memory.part.skills": "Skills",
  "memory.part.knowledge": "Whole bases",
  "memory.part.conversation": "Conversation (typical)",
  "memory.tokens": "{tokens} tokens",
  "memory.share": "Uses {percent} of the memory.",
  "memory.share_room": "There is plenty of room for long conversations.",
  "memory.share_tight": "Very long conversations may get tight; keep big bases on search.",
  "memory.cost": "Each reply costs about {usd} ({brl}), with caching.",
  "memory.cost_usd": "Each reply costs about {usd}, with caching.",
  "assistants.tab.skills": "Skills",
  "assistants.knows.mode_label": "How it reads this base",
  "assistants.knows.mode.auto": "Automatic",
  "assistants.knows.mode.whole": "Whole",
  "assistants.knows.mode.search": "By search",
  "assistants.knows.mode_hint": "Whole: the AI reads the entire base in every reply (best for small bases). By search: it reads only the passages related to the conversation. Automatic: whole up to 150 thousand characters.",
  "assistants.knows.is_whole": "Read whole · {chars} characters",
  "assistants.knows.is_search": "Read by search · {chars} characters",
  "assistants.test.view_chat": "Conversation",
  "assistants.test.skill": "Opened the skill {name}",
  "event.skill_opened": "The AI opened the skill {name}",
  "event.info.skill": "Skill",
  "event.info.skill_version": "Version",
  "message.trace.title": "How the AI answered",
  "message.trace.skills": "Skills:",
  "message.trace.skill_always": "{name} (always)",
  "message.trace.skill_earlier": "{name} (opened earlier)",
  "message.trace.skill_here": "{name} (opened now)",
  "message.trace.whole": "Bases read whole:",
  "message.trace.passages": "Passages looked up:",
  "message.trace.tools": "Tools:",
  "message.trace.read": "Read {n} messages of this conversation",
  "message.trace.previous": "{n} from earlier conversations",
  "message.trace.cached": "{percent}% from cache",
  "message.trace.adjust": "Adjust what shows in the conversation",
  "ai.conversation.title": "In the conversation",
  "ai.conversation.skill_events": "Show when the AI opens a skill",
  "ai.conversation.skill_events_hint": "A discreet line in the conversation, like “The AI opened the skill Negotiation”. Only the team sees it; never the contact.",
  "ai.surface.skills.organize": "Organize with AI",
  "ai.surface.skills.draft": "Improve a skill with AI",
  "ai.surface.skills.judge": "Test scenarios",
  "errors.skill_not_found": "Skill not found.",
  "errors.skill_already_added": "This skill was already added.",
  "errors.skill_not_library": "This skill is not from the library.",
  "errors.skill_in_use": "The skill is on in some assistant.",
  "errors.organize_not_found": "Organization run not found.",
  "errors.organize_not_ready": "The proposal is not ready yet.",
  "skills.tips.title": "A good skill",
  "skills.tips.1": "A concrete “when to use”: it is how the AI decides to open the skill.",
  "skills.tips.2": "Short steps, in the order they happen in the conversation.",
  "skills.tips.3": "Two or three real examples are worth more than many rules.",
  "assistants.instructions_long": "{n} characters: this looks more like a manual than instructions. Parts like methods and scripts work better as skills, and information as a knowledge base.",
  "onboarding.step.entry.skills": "Assistant skills",
  "onboarding.when.entry.skills": "Done with at least one skill added. It is optional.",
  "onboarding.done.entry.skills": "Skills added",
  "onboarding.lead.entry.skills": "Choose the ways of doing things the assistant follows: sales, collections, complaints.",
  "onboarding.detail.skills": "1 skill|{count} skills",
  "onboarding.guide.skills.title": "Assistant skills",
  "onboarding.guide.skills.text": "Ready methods the assistant follows, like qualifying a lead or welcoming a complaint. The suggestions come from what you told us in the questionnaire.",
  "onboarding.guide.skills.then": "Then turn the skills on in the assistant, on its Skills tab, and answer each one's adjustments.",
  "skills.suggested.title": "Suggested for your company",
  "skills.suggested.hint": "From what you told us in the questionnaire: what the company does and its segment. Each one's adjustments can be answered later.",
  "skills.suggested.add": "Add 1 ticked|Add {count} ticked",
  "skills.suggested.added": "1 skill added.|{count} skills added.",
  "skills.library.show_all": "Show every country's",
  "active.title": "Active messages",
  "active.state.can_receive": "Can receive active messages",
  "active.state.paused": "Paused until {day}",
  "active.state.opted_out": "Does not want active messages",
  "active.status.can_receive": "Can receive",
  "active.status.paused": "Paused",
  "active.status.opted_out": "Does not want them",
  "active.since": "Since {day}: {how}.",
  "active.answered": "If they write, they are answered normally.",
  "active.history": "History",
  "active.history_paused": "Paused until {day}",
  "active.origin.button": "tapped “{button}” on the template {template}",
  "active.origin.assistant": "asked in the conversation, the AI recorded it",
  "active.origin.keyword": "wrote “{word}”",
  "active.origin.api": "by an integration",
  "active.origin.pause_ended": "the pause ended",
  "active.origin.flow": "by a flow",
  "active.origin.person": "recorded by someone on the team",
  "active.action.pause": "Pause…",
  "active.action.opt_out": "Does not want them",
  "active.action.change_date": "Change date",
  "active.action.end_pause": "End pause",
  "active.action.resume": "Receive again",
  "active.pause.title": "Pause active messages",
  "active.pause.hint": "Nothing the company starts goes out until that day. If the contact writes, they are answered normally.",
  "active.pause.for": "For how long",
  "active.pause.until": "Or until the day",
  "active.pause.save": "Pause",
  "active.period.7d": "7 days",
  "active.period.30d": "30 days",
  "active.period.3m": "3 months",
  "active.period.6m": "6 months",
  "active.period.1y": "1 year",
  "active.picker.paused": "{name} paused active messages until {day}. Marketing templates do not go out.",
  "active.picker.opted_out": "{name} does not want active messages. Marketing templates do not go out.",
  "active.picker.held": "Not sent to this contact",
  "active.confirm.title": "Send even though paused?",
  "active.confirm.paused": "{name} paused active messages until {day}. This is a utility template: it goes out if you confirm, and who sent it is recorded.",
  "active.confirm.opted_out": "{name} does not want active messages. This is a utility template: it goes out if you confirm, and who sent it is recorded.",
  "active.confirm.cancel": "Do not send",
  "active.confirm.send": "Send",
  "active.refused.paused": "The contact paused active messages until {day}.",
  "active.rules.title": "Pause and opt-out: what they hold",
  "active.rules.hint": "It applies to everything the company sends first: campaigns, templates sent from a conversation, flows and the API.",
  "active.rules.category": "Template type",
  "active.rules.never": "Never sent (Meta's policy and the LGPD)",
  "active.rules.always": "Always sent: the person asked for the code",
  "active.rules.utility": "Utility",
  "active.rules.answered": "When the contact writes, they are answered normally: a pause or an opt-out only holds what the company starts.",
  "active.utility.send": "Sends",
  "active.utility.hold": "Does not send",
  "active.utility.ask": "Warns whoever is sending",
  "active.end.title": "When the pause ends",
  "active.end.hint": "The contact goes back to campaign audiences and API sends by itself. Besides that:",
  "active.end.none": "Nothing",
  "active.end.team": "Back in the team's queue",
  "active.end.tag": "Add the tag",
  "active.end.flow": "Start the flow",
  "active.end.flow_hint": "The team gets the contact's last conversation back in its queue. The flow should begin with a template, as the 24-hour window is closed.",
  "active.assistant.label": "The AI applies it when the contact asks in the conversation",
  "active.assistant.hint": "“Write to me in March”, “I don't want messages anymore”: the assistant pauses or opts out and confirms in its reply. Without a clear date, it asks.",
  "buttons.menu": "What the buttons do",
  "buttons.title": "What {name}'s buttons do",
  "buttons.lead": "The button's text is Meta's; what happens when it is tapped is DoneTalk's. It applies to every send (campaign, conversation, flow and API) and needs no new approval.",
  "buttons.none": "This template has no quick-reply buttons.",
  "buttons.when_tapped": "When tapped:",
  "buttons.action": "Action",
  "buttons.main.pause": "Pause active messages",
  "buttons.main.opt_out": "Does not want active messages",
  "buttons.main.opt_in": "Receive again",
  "buttons.main.route": "Open a conversation",
  "buttons.main.close": "Close with an outcome",
  "buttons.main.record": "Only record the tap",
  "buttons.main_hint.pause": "Fills “Can contact from”. If the contact writes, they are answered normally.",
  "buttons.main_hint.opt_out": "Until they ask to come back. It is the same opt-out as the words “sair” and “parar”.",
  "buttons.main_hint.opt_in": "For a “I want to receive again” button: ends the pause or the opt-out.",
  "buttons.main_hint.route": "The conversation opens in the chosen queue, or the flow or the assistant starts.",
  "buttons.main_hint.close": "It counts in reports like any closed conversation.",
  "buttons.main_hint.record": "It counts in reports and tells your systems, changing nothing.",
  "buttons.pause_for": "For",
  "buttons.route.with": "With",
  "buttons.route.team": "A team",
  "buttons.route.flow": "A flow",
  "buttons.route.assistant": "An AI assistant",
  "buttons.route.which_team": "Team",
  "buttons.route.which_flow": "Flow",
  "buttons.route.which_assistant": "Assistant",
  "buttons.route.usual_queue": "The number's usual queue",
  "buttons.outcome": "Outcome",
  "buttons.also_and": "and also",
  "buttons.also_label": "And also",
  "buttons.also.tag_add": "Add tag",
  "buttons.also.tag_remove": "Remove tag",
  "buttons.also.field": "Fill field",
  "buttons.also.tag": "Tag",
  "buttons.also.field_key": "Field",
  "buttons.also.field_value": "Value",
  "buttons.also_add": "+ Another action",
  "buttons.also_remove": "Remove this action",
  "buttons.where": "A campaign can change a button's action for itself only. Otherwise the template's applies.",
  "event.button_tapped": "Tapped “{button}”",
  "event.applied.pause": "active messages paused until {day}",
  "event.applied.opt_out": "does not want active messages",
  "event.applied.opt_in": "receives active messages again",
  "event.applied.route": "conversation opened",
  "event.applied.close": "closed",
  "event.applied.tag_add": "tag added",
  "event.applied.tag_remove": "tag removed",
  "event.applied.field": "field {field} filled",
  "event.active.paused": "{who} paused active messages until {day}",
  "event.active.opted_out": "{who} marked: does not want active messages",
  "event.active.resumed": "{who} allowed active messages again",
  "event.active.pause_ended": "The pause on active messages ended",
  "event.active.integration": "An integration",
  "event.info.button": "Button",
  "event.info.template": "Template",
  "event.info.applied": "Applied",
  "assistants.test.active_pause": "Would pause active messages until {day}",
  "assistants.test.active_stop": "Would mark: does not want active messages",
  "assistants.test.active_resume": "Would allow active messages again",
  "assistant.tool.active_messages": "Pause or stop active messages",
  "assistant.tool_hint.active_messages": "When the contact asks “write to me in March” or “no more messages”. They are still answered when they write.",
  "builder.exit_held": "Not sent",
  "node.template.held_hint": "“Not sent”: the contact paused or refused active messages, and this template would be one. Without that path, it takes the error path.",
  "campaigns.button.template": "Does what the template says",
  "campaigns.skip.paused": "Paused active messages",
  "campaigns.recipient.skip.paused": "Out: paused",
  "segments.marketing.paused": "Paused",
  "segments.marketing.can_receive": "Can receive active messages",
  "segments.field.pause_ends_days": "Days until the pause ends",
  "integrations.event.template.button_clicked": "Template button tapped",
  "errors.contact_paused": "The contact paused active messages.",
  "errors.marketing_opted_out": "The contact does not want active messages.",
  "errors.active_messages_confirm": "The contact paused active messages: confirm to send.",
  "memory.part.tools": "Tools",
  "memory.strip.label": "Memory",
  "memory.strip.share": "{percent} used",
  "memory.strip.per_reply": "{cost} per reply",
  "memory.strip.details": "See details",
  "inbox.action.clear": "Clear conversation",
  "clear.title": "Clear this conversation?",
  "clear.text": "Every message with {name} disappears for the team and for the AI, which stops reading what came before. The contact still sees everything on their WhatsApp.",
  "clear.kept": "Who cleared it and when is recorded. People allowed to see removed messages can still see them and bring them back.",
  "clear.confirm": "Clear conversation",
  "clear.done": "Conversation cleared.",
  "event.cleared": "{name} cleared the conversation",
  "permission.conversations.clear": "Clear conversations",
  "export.title": "Conversation with {name}",
  "export.number": "Number: {number}",
  "export.exported": "Exported by {name} on {when} ({zone} time)",
  "export.counts": "{attendances} conversation(s) · {messages} message(s)",
  "export.role.team": "{name} (team)",
  "export.role.ai": "{name} (AI)",
  "export.role.flow": "Flow {name}",
  "export.role.campaign": "Campaign {name}",
  "export.role.system": "Automatic message",
  "export.role.api": "Integration",
  "export.reply_to": "↪ In reply to {name}: “{text}”",
  "export.from_ad": "Came from the ad: {ad}",
  "export.voice": "🎤 Voice message",
  "export.audio": "🎵 Audio",
  "export.transcript": "Transcription: “{text}”",
  "export.no_transcript": "(no transcription)",
  "export.location": "📍 Location: {place}",
  "export.contact_card": "👤 Contact: {name} {phones}",
  "export.template": "Template {name}",
  "export.buttons": "Buttons: {buttons}",
  "export.options": "Options: {options}",
  "export.chose": "Chose: {option}",
  "export.flag.edited": "edited",
  "export.flag.deleted": "deleted by the contact",
  "export.flag.removed": "removed by {name} on {day}",
  "export.flag.failed": "not delivered",
  "export.flag.read": "read at {time}",
  "export.flag.delivered": "delivered",
  "export.flag.played": "played at {time}",
  "export.attendance_open": "Conversation opened on {start} · Team: {team}",
  "export.attendance_closed": "Conversation from {start} to {end} · Team: {team} · Outcome: {outcome}",
  "export.note": "Internal note by {name}",
  "export.attached": "<attached: {file}>",
  "export.file": "📎 {file} ({size})",
  "export.reactions": "Reactions: {list}",
  "export.zip_text": "Conversation.txt",
  "export.event.snoozed": "Snoozed",
  "export.event.opted_out": "Asked to opt out: “{word}”",
  "export.event.tool": "Tool used: {tool}",
  "permission.conversations.export": "Export conversations",
  "inbox.action.export": "Export conversation",
  "exportchat.title": "Export conversation",
  "exportchat.format": "Format",
  "exportchat.pdf": "PDF",
  "exportchat.pdf_hint": "Organised by day, with photos, to read or print.",
  "exportchat.txt": "Text (like WhatsApp)",
  "exportchat.txt_hint": "One line per message, in WhatsApp's format.",
  "exportchat.zip": "Text with the files (ZIP)",
  "exportchat.zip_hint": "The text plus every photo, audio and document, like WhatsApp's “attach media”.",
  "exportchat.scope": "What to export",
  "exportchat.scope_thread": "The whole conversation with this contact",
  "exportchat.scope_conversation": "Only this conversation",
  "exportchat.notes": "Internal notes",
  "exportchat.events": "Conversation events (transfers, outcomes, AI…)",
  "exportchat.hidden": "Removed messages (marked as removed)",
  "exportchat.audit": "The export is recorded in the audit log.",
  "exportchat.submit": "Export",
  "export.by": "by {name}",
  "export.flag.failed_code": "not delivered (Meta code {code})",
  "api.scope.conversations:export": "Export conversations (PDF, text, ZIP)",
  "knowledge.download": "Download {name}",
  "knowledge.file_not_kept": "{n} chunks. The original file could not be kept: the assistant reads the text as usual.",
  "knowledge.doc.reads": "What the assistant reads",
  "knowledge.doc.reads_hint": "The whole text as the assistant gets it, split into {chunks} chunks for search.",
  "knowledge.doc.no_text": "This content has no text read yet.",
  "knowledge.doc.about": "About this content",
  "knowledge.doc.file": "File",
  "knowledge.doc.file_not_kept": "Original not kept",
  "knowledge.doc.file_not_kept_hint": "This file was sent before DoneTalk kept originals, so only its text is here. To have the file to open and download, remove this content and send the file again.",
  "knowledge.doc.added": "Added",
  "knowledge.doc.added_by": "{when} by {name}",
  "knowledge.doc.chars": "Characters",
  "knowledge.doc.download_text": "Download text",
  "knowledge.doc.download_file": "Download file",
  "knowledge.doc.open_file": "Open file",
  "errors.document_not_found": "This content is no longer in the knowledge base.",
  "errors.file_not_found": "The original file of this content is not kept.",
  "campaigns.banner.waiting": "Outside the sending hours · {sent} of {total} sent. Sends again {at}, following the campaign's days and hours.",
  "campaigns.status.waiting_at": "Waiting for its hours · {at}",
  "fields.search": "Search fields by name, key or option",
  "fields.search_none": "No field matches “{query}”.",
  "email.ai_model_off.subject": "DoneTalk · {workspace}: the model {model} was switched off",
  "email.ai_model_off.text": "The model {model}, which the company chose, was switched off. These tasks went back to DoneTalk's model: {tasks}. Nothing stopped working.",
  "email.ai_model_off.cta": "See the AI models",
  "email.ai_model_off.why": "You get this notice because you are an owner or admin of the company on DoneTalk.",
  "aimodels.effort": "Effort",
  "aimodels.reasoning": "Reasoning",
  "aimodels.level.none": "None",
  "aimodels.level.minimal": "Minimal",
  "aimodels.level.low": "Low",
  "aimodels.level.medium": "Medium",
  "aimodels.level.high": "High",
  "aimodels.level.xhigh": "Very high",
  "aimodels.level.max": "Maximum",
  "aimodels.chip.temperature": "Temperature: {value}",
  "aimodels.chip.fallback": "Fallback: {model}",
  "aimodels.hint.assistant.reply": "What the assistants answer contacts.",
  "aimodels.hint.gate.judge": "Checks messages before they go out, following the Policies.",
  "aimodels.hint.outcome.classify": "Suggests the outcome when a conversation is closed.",
  "aimodels.hint.summary.brief": "The summary that goes along when the conversation moves to someone else.",
  "aimodels.hint.knowledge.embed": "Prepares the knowledge base for search.",
  "aimodels.hint.audio.transcribe": "Turns the audio received into text.",
  "aimodels.hint.learning.mine": "Reads the week's conversations and suggests improvements.",
  "aimodels.hint.onboarding.propose": "Prepares the setup suggestions.",
  "aimodels.hint.flow.choice": "Understands people who type instead of tapping a flow's menu.",
  "aimodels.hint.flow.blocks": "The AI blocks inside flows.",
  "aimodels.hint.tools.draft": "Drafts a tool from its description.",
  "aimodels.hint.skills.organize": "Splits a long prompt into instructions, skills and knowledge.",
  "aimodels.hint.skills.draft": "Improves the text of a company skill.",
  "aimodels.hint.skills.judge": "Grades the answers in the test scenarios.",
  "aimodels.fallback_none": "None",
  "aimodels.price": "Price: {input} per million tokens read, {output} per million written.",
  "aimodels.offered_tools": "This task needs a model that uses tools. The list shows only those that fit.",
  "aimodels.offered": "The list shows only the models that fit this task.",
  "aimodels.model": "Model",
  "aimodels.settings": "This model's settings",
  "aimodels.thinking_hint.effort": "More effort thinks more before answering: slower and costlier. For WhatsApp conversations, low.",
  "aimodels.thinking_hint.reasoning": "More reasoning thinks more before answering: slower and costlier. For WhatsApp conversations, low.",
  "aimodels.fallback": "Fallback model, if this one fails",
  "aimodels.note.no_temperature": "Temperature: this model takes none. The assistants' Creativity has no effect with it.",
  "aimodels.note.temperature_without_thinking": "Temperature: only with reasoning \"None\".",
  "aimodels.note.temperature": "Temperature: takes each task's and the assistants' Creativity.",
  "aimodels.note.responses": "Tools: through OpenAI's Responses API.",
  "aimodels.none_offered": "No model available for this task. Switch models on in Console › AI › Models.",
  "aimodels.chosen_company": "Chosen by the company",
  "aimodels.chosen_custom": "Custom",
  "aimodels.platform_only": "Set by DoneTalk",
  "aimodels.from_donetalk": "DoneTalk's: ",
  "aimodels.follows_platform": "Follows the platform: ",
  "aimodels.change": "Change",
  "aimodels.choose_other": "Choose another",
  "aimodels.use_donetalk": "Use DoneTalk's",
  "aimodels.back_to_platform": "Back to the default",
  "aimodels.tab.models": "Models",
  "aimodels.tab.keys": "Keys",
  "aimodels.tab.usage": "Usage",
  "aimodels.notice.model_off": "The model {model} was switched off. These tasks went back to DoneTalk's model: {tasks}.",
  "aimodels.notice.ok": "Got it",
  "aimodels.locked": "DoneTalk chooses this company's AI models. Talk to support to change them.",
  "aimodels.keys_note": "Without changes, each task uses DoneTalk's model, which updates by itself. Models of another provider use DoneTalk's keys, and each one's cost shows in Usage; with \"Use my own keys\" on, they use the company's key.",
  "aimodels.footer": "For owners and admins. Every change is in the audit log. If a chosen model goes away, the task moves to its replacement or back to DoneTalk's, with a notice here and by e-mail.",
  "aimodels.compare.title": "Compare models",
  "aimodels.compare.task": "Task",
  "aimodels.compare.period": "Period",
  "aimodels.compare.assistant": "Assistant",
  "aimodels.compare.days": "Last {n} days",
  "aimodels.compare.all_assistants": "All",
  "aimodels.compare.line": "Measure",
  "aimodels.compare.replies": "Replies sent",
  "aimodels.compare.reply_time": "Average time to reply",
  "aimodels.compare.calls": "Calls",
  "aimodels.compare.call_time": "Average model time",
  "aimodels.compare.cost": "Average cost per call",
  "aimodels.compare.cache": "Read from cache",
  "aimodels.compare.handed_off": "Conversations handed to a person",
  "aimodels.compare.tools": "Tools used",
  "aimodels.compare.successes": "Successful outcomes",
  "aimodels.compare.errors": "Errors",
  "aimodels.compare.empty": "No calls of this task in the period.",
  "aimodels.compare.few": "A model has fewer than 30 in the period: the comparison still says little.",
  "aimodels.console.following": "{count} customers follow",
  "aimodels.console.own": "{count} custom: {names}",
  "aimodels.console.impact": "On saving, {count} customers following the default move to the chosen model, with the settings translated for it. Custom ones keep their choice.",
  "aimodels.console.embed_locked": "Changing this model means reading every customer's bases again, which is not automatic yet. So the change is off here.",
  "aimodels.console.lock": "The customer can choose its models",
  "aimodels.console.lock_hint": "Off, only the platform chooses for it here; in Settings › AI it sees the models without changing them.",
  "aimodels.console.assistants": "Assistants",
  "aimodels.console.assistant_own": "Own model: {model}",
  "aimodels.console.assistant_company": "Uses the company's",
  "aimodels.console.history": "History",
  "aimodels.history.chosen": "{task}: {from} → {to}",
  "aimodels.history.assistant": "An assistant's model: {from} → {to}",
  "aimodels.history.locked_on": "Choice locked: only the platform chooses",
  "aimodels.history.locked_off": "Choice open to the customer",
  "aimodels.history.platform": "Platform",
  "aimodels.history.default": "default",
  "aimodels.assistant.title": "Reply model",
  "aimodels.assistant.company": "The company's",
  "aimodels.assistant.own": "Another one for this assistant only",
  "aimodels.assistant.own_hint": "Good for testing a model without touching the other assistants.",
  "aimodels.assistant.from_next": "Applies from the next reply, without publishing a new version.",
  "aimodels.assistant.choose": "Choose the model",
  "aimodels.assistant.creativity_off": "{model} does not take Creativity: the way it speaks comes from the tone and instructions.",
  "aimodels.trace.model": "Model",
  "aimodels.trace.time": "Reply time",
  "aimodels.trace.fallback": "Answered instead of {model}, which failed",
  "platform.page.ai": "AI",
  "marketing.open_conversation.title": "A campaign in an open conversation",
  "marketing.open_conversation.hint": "When a campaign reaches a contact who already has an open conversation (from another campaign or with someone on the team) and they reply: who keeps the conversation.",
  "marketing.open_conversation.keep": "Keep it with whoever is attending",
  "marketing.open_conversation.keep_hint": "The reply stays in the conversation as it is: the person, assistant or flow already on it carries on.",
  "marketing.open_conversation.route_if_free": "Hand it to the campaign's destination if nobody is attending",
  "marketing.open_conversation.route_if_free_hint": "If a team member has the conversation, they keep it. If not, the campaign's team, flow or assistant takes over.",
  "marketing.open_conversation.route": "Always hand it to the campaign's destination",
  "marketing.open_conversation.route_hint": "The campaign's team, flow or assistant takes over even if someone was attending; that person leaves the conversation and the timeline shows it.",
  "campaigns.open_rule": "People with an open conversation receive it. If they reply, the company's rule applies: \"{rule}\".",
  "message.transcript": "Transcript",
  "message.transcribing": "Transcribing the audio…",
  "ai.conversation.transcribe": "Transcribe the audio received",
  "ai.conversation.transcribe_hint": "The assistant understands what the contact said and the team reads the text under the audio. Each transcription is an AI call, with its cost in Usage.",
  "ai.surface.media.describe": "Image and file descriptions",
  "aimodels.hint.media.describe": "Describes for the assistant the images, stickers and documents exchanged in the conversation.",
  "ai.conversation.describe": "Describe images and files for the assistant",
  "ai.conversation.describe_hint": "Each photo, sticker or document exchanged (by the contact or the team) gets a description only the assistant reads, and the latest photos go whole to models that see. Each description is an AI call, with its cost in Usage.",
  "email.ai_provider_down.subject_credit": "DoneTalk · {provider} refused the platform's key: no credit",
  "email.ai_provider_down.subject_key": "DoneTalk · {provider} refused the platform's key",
  "email.ai_provider_down.text_credit": "Since {since}, {provider} has refused the platform's calls: the account has no credit left.",
  "email.ai_provider_down.text_key": "Since {since}, {provider} no longer accepts the platform's key (invalid or revoked).",
  "email.ai_provider_down.meanwhile": "Meanwhile each task moves to its backup provider, chosen in Console › AI › Tasks, so service does not stop. Tasks without a backup wait until this is solved. You will get another e-mail when the provider is back.",
  "email.ai_provider_down.cta": "Open the Console",
  "email.ai_provider_down.why": "You get this notice because you are a DoneTalk platform admin.",
  "email.ai_provider_back.subject": "DoneTalk · {provider} is answering again",
  "email.ai_provider_back.text": "{provider} accepted the platform's key again at {until}. It was out since {since}; meanwhile {count} calls were refused and went to the backup provider where there was one.",
  "email.ai_key_refused.subject": "DoneTalk · {workspace}: {provider} refused the company's key",
  "email.ai_key_refused.text_credit": "{provider} refused the company's AI key: the account has no credit left.",
  "email.ai_key_refused.text_key": "{provider} no longer accepts the company's AI key (invalid or revoked).",
  "email.ai_key_refused.meanwhile": "Meanwhile DoneTalk uses another provider so service does not stop. Add credit or replace the key in Settings › AI › Keys.",
  "email.ai_key_refused.cta": "See the AI keys",
  "errors.ai_provider_account": "The AI provider refused access (credit or key). Whoever handles it has been told.",
  "aimodels.cross": "If the provider fails",
  "aimodels.cross_hint": "A model of another provider, used last when the task's provider refuses or is down (no credit, for example). Applies to every company.",
  "aimodels.console.cross": "If the provider fails: {model}",
  "aimodels.console.no_cross": "No backup provider: if the provider fails, the task stops",
  "aimodels.notice.key_refused_credit": "{provider} refused the company's key: no credit left. Meanwhile DoneTalk uses another provider. Add credit or replace the key in Keys.",
  "aimodels.notice.key_refused_key": "{provider} no longer accepts the company's key. Meanwhile DoneTalk uses another provider. Replace the key in Keys.",
  "aimodels.trace.fallback_account": "Answered instead of {model}: the provider refused (credit or key)",
  "platform.ai.incident.open_credit": "{provider} out of credit: the platform's key is being refused",
  "platform.ai.incident.open_key": "{provider} no longer accepts the platform's key",
  "platform.ai.incident.open_text": "Since {since} · {count} calls refused. Tasks are on their backup provider; those without one are stopped. It clears by itself on the first call that passes after adding credit or replacing the key.",
  "platform.ai.incident.past_credit": "{provider} was out of credit from {since} to {until} ({count} calls refused)",
  "platform.ai.incident.past_key": "{provider} refused the key from {since} to {until} ({count} calls refused)",
  "campaigns.read_rule": "Read counts only people who keep read receipts on in WhatsApp; those who turned them off show as delivered.",
  "message.trace.version": "Instructions",
  "message.trace.version_number": "version {number}",
  "campaigns.config.title": "Settings",
  "campaigns.config.start": "Start",
  "campaigns.config.started": "Started on {when}",
  "campaigns.config.window": "Sending hours",
  "campaigns.config.days_hours": "{days}, {from} to {to}",
  "campaigns.config.every_day": "Every day",
  "campaigns.config.no_window": "No hours set",
  "campaigns.config.people": "1 person|{count} people",
  "campaigns.config.skips": "Does not send to",
  "campaigns.config.skip_open": "people already in a conversation",
  "campaigns.config.skip_recent": "people who got a campaign in the last {days} days",
  "campaigns.config.no_goal": "None: the assistant does not know what this campaign wants",
  "campaigns.config.no_fallback": "nothing (the message may fail)",
  "campaigns.config.never_stops": "Never stops by itself",
  "campaigns.config.approval": "Approval",
  "campaigns.config.approved_by": "Approved by {name} on {when}",
  "campaigns.config.waiting_approval": "Waiting for approval",
  "campaigns.pace.title": "Sending pace",
  "campaigns.pace.fast": "As fast as Meta allows",
  "campaigns.pace.per_minute": "Up to {count} an hour ({per} a minute)",
  "campaigns.pace.every_minutes": "Up to {count} an hour (1 every {minutes} minutes)",
  "campaigns.pace.hint": "Slower gives the campaign time to stop by itself if many people opt out, and spreads the replies for whoever answers. Meta's daily limit always applies.",
  "campaigns.sending.title": "Change sending",
  "campaigns.sending.when": "Applies from the next minute, without pausing the campaign. The rest of the campaign stays as approved.",
  "inbox.view.automation": "Automation",
  "inbox.with_flow": "With the flow {name}",
  "inbox.with_a_flow": "With a flow",
  "inbox.with_assistant": "With {name} (AI)",
  "inbox.with_an_assistant": "With the assistant",
  "inbox.contact_wrote": "contact wrote {when}",
  "inbox.ago_minutes": "{n} min ago",
  "inbox.ago_hours": "{n} h ago",
  "inbox.ago_days": "{n} d ago",
  "campaigns.filter.in_flow": "In a flow",
  "campaigns.col.handler": "Handled by",
  "campaigns.handler.closed": "Closed",
  "campaigns.handler.queue": "In the queue",
  "numbers.name.in_use": "In use, not yet reviewed by Meta",
  "numbers.health.code.141012": "The number reached its limit of new conversations started by the business (with templates) over the last 24 hours. Room comes back as the sends of 24 hours ago expire. Conversations the contact started go on as usual.",
  "numbers.health.code.141015": "The business (its Meta portfolio) reached its limit of business-started conversations over the last 24 hours. The limit covers every number in the portfolio and frees up gradually as the sends of 24 hours ago expire.",
  "contact.copy_phone": "Copy phone",
  "contact.phone_copied": "Phone copied",
  "editor.label": "Image editor",
  "editor.undo": "Undo",
  "editor.redo": "Redo",
  "editor.crop": "Crop and rotate",
  "editor.filter": "Filter",
  "editor.draw": "Draw",
  "editor.text": "Text",
  "editor.shapes": "Shapes",
  "editor.blur": "Blur",
  "editor.emoji": "Emoji",
  "editor.sticker": "Sticker",
  "editor.quality": "Photo quality",
  "editor.quality_none": "This photo isn't in high definition.",
  "editor.quality_standard": "Standard quality",
  "editor.quality_hd": "HD quality",
  "editor.quality_help": "HD photos are sharper, but standard quality photos take up less storage and are sent faster.",
  "editor.copy": "Copy",
  "editor.copied": "Image copied",
  "editor.copy_failed": "The browser didn't allow copying the image.",
  "editor.download": "Download",
  "editor.ok": "OK",
  "editor.rotate_left": "Rotate left",
  "editor.rotate_right": "Rotate right",
  "editor.reset": "Reset",
  "editor.filter_name.none": "None",
  "editor.filter_name.pop": "Pop",
  "editor.filter_name.bw": "B&W",
  "editor.filter_name.cool": "Cool",
  "editor.filter_name.chrome": "Chrome",
  "editor.filter_name.film": "Film",
  "editor.color.black": "Black",
  "editor.color.gray": "Gray",
  "editor.color.white": "White",
  "editor.color.blue": "Blue",
  "editor.color.green": "Green",
  "editor.color.purple": "Purple",
  "editor.color.orange": "Orange",
  "editor.color.red": "Red",
  "editor.more_colors": "More colors",
  "editor.hex": "Color code",
  "editor.brush_size": "Thickness {size}",
  "editor.font": "Font",
  "editor.align_left": "Align left",
  "editor.align_center": "Center",
  "editor.align_right": "Align right",
  "editor.background": "Background",
  "editor.delete": "Delete",
  "editor.text_label": "Text on the image",
  "editor.shape.rect": "Square",
  "editor.shape.circle": "Circle",
  "editor.shape.line": "Line",
  "editor.shape.arrow": "Arrow",
  "editor.fill": "Fill",
  "editor.stroke": "Outline",
  "editor.no_color": "No color",
  "editor.stroke_width": "Outline width",
  "editor.blur_mode": "Blur mode",
  "editor.blur_pixelate": "Pixelate",
  "editor.blur_soft": "Blur",
  "editor.blur_size": "Brush size",
  "editor.rotate_item": "Rotate",
  "editor.stickers_recent": "Recent",
  "editor.stickers_none": "Stickers used in conversations show up here.",
  "editor.sticker_file": "Use an image",
  "editor.export_failed": "The edited image couldn't be prepared. Try again.",
  "media.discard_title": "Discard the selection?",
  "campaigns.after.title": "After sending",
  "campaigns.after.lead": "What happens to people who do not answer and to people who stop answering. All within the campaign's sending hours.",
  "campaigns.after.never_title": "People who do not answer the template",
  "campaigns.after.send": "Send",
  "campaigns.after.no_reminder": "no reminder",
  "campaigns.after.one_reminder": "1 reminder",
  "campaigns.after.reminders": "Reminders",
  "campaigns.after.with_template": "with the template",
  "campaigns.after.template": "Reminder template",
  "campaigns.after.pick_template": "pick the template",
  "campaigns.after.after": "after",
  "campaigns.after.delay": "When to send the reminder",
  "campaigns.after.reminder_hint": "It is a new template, charged as marketing, and counts toward the number's daily limit. It uses the campaign's variables. It does not go to people who paused or left active messages, and it stops on its own if the number's quality drops.",
  "campaigns.after.no_templates": "No other approved template on this number.",
  "campaigns.after.quiet_title": "People who answered and went quiet",
  "campaigns.after.resumes": "{name} follows up",
  "campaigns.after.the_assistant": "The assistant",
  "campaigns.after.follow_up": "When to follow up",
  "campaigns.after.times": "How many follow-ups",
  "campaigns.after.quiet_hint": "{name} reads the conversation again and decides: a short message toward the goal, concluding it if it already ended, or a person only in an extreme case. Free: it goes inside the 24 h window.",
  "campaigns.after.quiet_needs_assistant": "Follow-ups are the assistant's: they apply when an assistant answers the campaign.",
  "campaigns.after.closing_title": "Closing on silence",
  "campaigns.after.follows.customer": "Follows the company's rule:",
  "campaigns.after.follows.channel": "Follows the number's rule:",
  "campaigns.after.follows.team": "Follows the team's rule:",
  "campaigns.after.follows.campaign": "Follows the campaign's rule:",
  "campaigns.after.no_rule": "No rule closes on silence: conversations stay open.",
  "campaigns.after.customize": "Customize for this campaign",
  "campaigns.after.custom": "Custom: replaces the company's rule in this campaign.",
  "campaigns.after.back_to_rule": "Back to the company's rule",
  "campaigns.after.saved_hint": "It applies from the next minute.",
  "campaigns.after.report": "After sending: results",
  "campaigns.after.reminders_line": "sent · {replied} answered · cost {cost}",
  "campaigns.after.reminders_off": "Only with the reminder on.",
  "campaigns.after.follow_ups": "Follow-ups",
  "campaigns.after.follow_ups_of": "{name}'s follow-ups",
  "campaigns.after.follow_ups_line": "sent · {resumed} came back to the conversation",
  "campaigns.after.follow_ups_hint": "Free, inside the window.",
  "campaigns.after.closed_rule": "Closed on silence",
  "campaigns.after.closed_rule_line": "by the campaign's rule",
  "campaigns.after.closed_rule_hint": "With the outcome the AI chose, or {outcome}.",
  "campaigns.after.closed_rule_off": "The campaign follows the company's rule.",
  "campaigns.after.endings": "How the conversations ended",
  "campaigns.after.ending.automation": "Closed by the automation",
  "campaigns.after.ending.automation_of": "Closed by {name}",
  "campaigns.after.ending.silence": "Closed on silence",
  "campaigns.after.ending.person": "Handed to a person",
  "campaigns.after.ending.open": "Still open",
  "campaigns.after.endings_hint": "Each row opens the list of those conversations, with the reason for each handover.",
  "campaigns.after.endings_empty": "No conversations here.",
  "campaigns.after.reason": "Reason: {reason}",
  "followup.when.before_close": "1 h before the window closes",
  "followup.when.after_2h": "after 2 h of silence",
  "followup.when.after_4h": "after 4 h of silence",
  "followup.when.after_8h": "after 8 h of silence",
  "followup.when.off": "no follow-up",
  "followup.up_to": "up to",
  "followup.times": "once|{count} times",
  "followup.hours": "{n} h",
  "followup.days": "1 day|{count} days",
  "policy.choose": "the AI chooses (or {outcome})",
  "policy.when_silent": "When the contact does not answer for",
  "policy.close_as": "→ close as",
  "policy.short": "{hours} without an answer → {outcome}",
  "policy.sentence.choose": "When the contact does not answer for {hours} hours → the AI chooses the outcome (or {outcome})",
  "policy.company": "The company's",
  "policy.custom": "Custom",
  "policy.custom_hint": "A custom rule replaces the company's where it applies: the most specific one wins.",
  "policy.replaces": "replaces the company's",
  "policy.level.campaign": "Campaign",
  "policy.level.channel": "Number",
  "policy.level.team": "Team",
  "policy.level.customer": "Company",
  "policy.order_title": "Which rule applies to a conversation",
  "policy.order": "Campaign › number › team › company. Only one applies per conversation: the first that applies in that order. A conversation in a team's queue waiting for the business to answer is never closed on silence.",
  "policy.campaign_rule_hint": "Change it on the campaign, under After sending.",
  "policy.scope_channel": "number {name}",
  "policy.applies_number": "Number",
  "inbox.next.follow_up": "follow-up {when}",
  "inbox.next.closes": "closes in {time} without an answer",
  "inbox.next.at": "at {time}",
  "inbox.next.tomorrow": "tomorrow at {time}",
  "inbox.next.chip": "Follow-up {when}",
  "inbox.next.chip_tip": "{name} follows up before the window closes if the contact does not answer: follow-up {n} of {of}, {when}.",
  "inbox.next.rule": "Closing rule",
  "inbox.next.rule_line": "{whose}: {rule}",
  "inbox.next.closes_at": "Closes {when} if the contact does not answer.",
  "event.follow_up.running": "Follow-up {n} of {of}",
  "event.follow_up.sent": "Follow-up {n} of {of}",
  "event.follow_up.closed": "Follow-up {n} of {of} · the conversation had already ended: closed",
  "event.follow_up.handed_off": "Follow-up {n} of {of} · handed to a person",
  "event.follow_up.nothing": "Follow-up {n} of {of} · nothing to say",
  "event.follow_up.superseded": "Follow-up {n} of {of} · the contact wrote first",
  "event.follow_up.failed": "Follow-up {n} of {of} · it could not be done",
  "event.closed_rule": "Closed by the {whose} rule: {hours} without an answer",
  "event.rule_whose.campaign": "campaign's",
  "event.rule_whose.channel": "number's",
  "event.rule_whose.team": "team's",
  "event.rule_whose.customer": "company's",
  "event.closed_chosen": "outcome chosen by the AI",
  "event.info.rule": "Rule",
  "message.follow_up": "follow-up {n} of {of}",
  "assistant.follow_up.title": "Follow-up outside campaigns",
  "assistant.follow_up.hint": "When the contact stops answering, {name} follows up before the 24 h window closes, within the chosen hours, and decides: a short message, concluding, or a person only in an extreme case. In campaign conversations the campaign's setting applies.",
  "assistant.follow_up.hours": "Follow-up hours",
  "assistant.follow_up.any_time": "Any time",
  "assistant.follow_up.within": "Within the hours below",
  "inbox.next.today": "today at {time}",
  "inbox.next.other_day": "{date} at {time}",
  "message.trace.follow_up": "Why it wrote"
}
